/* AUTO-GENERATED FROM prisma/schema.prisma — DO NOT EDIT BY HAND */

/**
 * Shared enum shape.
 *
 * Each enum is emitted as a `const` object (same shape Prisma emits for
 * `@alinea/db`) plus a string-literal union type with the identical name.
 * Import the enum once and use it both as a value (for `@IsEnum`,
 * `@ApiProperty({ enum })`, equality checks, exhaustive switches) and as
 * a type annotation.
 *
 * Tuple aliases (`*_VALUES`) are NOT emitted. If you need the values as a
 * `readonly string[]`, call `enumValues(MyEnum)` from `@alinea/types`. If
 * you need a runtime type guard, call `isEnumValue(MyEnum, value)`.
 */
export const RowStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  DRAFT: 'DRAFT',
  DELETED: 'DELETED',
} as const;
export type RowStatus = (typeof RowStatus)[keyof typeof RowStatus];

export const ResourceAccessMode = {
  INHERIT_RBAC: 'INHERIT_RBAC',
  RESTRICTED_FGA: 'RESTRICTED_FGA',
} as const;
export type ResourceAccessMode = (typeof ResourceAccessMode)[keyof typeof ResourceAccessMode];

export const UserEntityRole = {
  CONTROLLER: 'CONTROLLER',
  ACCOUNTANT: 'ACCOUNTANT',
  VIEWER: 'VIEWER',
  ADMIN: 'ADMIN',
} as const;
export type UserEntityRole = (typeof UserEntityRole)[keyof typeof UserEntityRole];

export const SegmentDataType = {
  STRING: 'STRING',
  NUMBER: 'NUMBER',
  DATE: 'DATE',
  BOOLEAN: 'BOOLEAN',
} as const;
export type SegmentDataType = (typeof SegmentDataType)[keyof typeof SegmentDataType];

export const VendorStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  BLOCKED: 'BLOCKED',
  UNDER_REVIEW: 'UNDER_REVIEW',
} as const;
export type VendorStatus = (typeof VendorStatus)[keyof typeof VendorStatus];

export const VendorType = {
  SUPPLIER: 'SUPPLIER',
  SERVICE_PROVIDER: 'SERVICE_PROVIDER',
  BOTH: 'BOTH',
  GOVERNMENT_ENTITY: 'GOVERNMENT_ENTITY',
  BANK_FEE: 'BANK_FEE',
} as const;
export type VendorType = (typeof VendorType)[keyof typeof VendorType];

export const VendorEstablishmentType = {
  HEADQUARTERS: 'HEADQUARTERS',
  BRANCH: 'BRANCH',
} as const;
export type VendorEstablishmentType =
  (typeof VendorEstablishmentType)[keyof typeof VendorEstablishmentType];

export const TaxIdType = {
  CNPJ: 'CNPJ',
  CPF: 'CPF',
  ACRONYM: 'ACRONYM',
  INTERNATIONAL: 'INTERNATIONAL',
  RFC: 'RFC',
  EIN: 'EIN',
} as const;
export type TaxIdType = (typeof TaxIdType)[keyof typeof TaxIdType];

export const TaxRegime = {
  SIMPLES_NACIONAL: 'SIMPLES_NACIONAL',
  LUCRO_PRESUMIDO: 'LUCRO_PRESUMIDO',
  LUCRO_REAL: 'LUCRO_REAL',
  MEI: 'MEI',
  MX_GENERAL_601: 'MX_GENERAL_601',
  MX_RESICO_626: 'MX_RESICO_626',
  FOREIGN: 'FOREIGN',
} as const;
export type TaxRegime = (typeof TaxRegime)[keyof typeof TaxRegime];

export const PaymentMethodType = {
  BOLETO: 'BOLETO',
  PIX: 'PIX',
  TED: 'TED',
  DOC: 'DOC',
  CREDIT_CARD: 'CREDIT_CARD',
  DEBIT_CARD: 'DEBIT_CARD',
  GUIA: 'GUIA',
  CHECK: 'CHECK',
  OTHER: 'OTHER',
  ADVANCE: 'ADVANCE',
  ACH: 'ACH',
} as const;
export type PaymentMethodType = (typeof PaymentMethodType)[keyof typeof PaymentMethodType];

export const PaymentPriority = {
  HIGH: 'HIGH',
  NORMAL: 'NORMAL',
  LOW: 'LOW',
} as const;
export type PaymentPriority = (typeof PaymentPriority)[keyof typeof PaymentPriority];

export const RiskRating = {
  A: 'A',
  B: 'B',
  C: 'C',
  D: 'D',
} as const;
export type RiskRating = (typeof RiskRating)[keyof typeof RiskRating];

export const AddressType = {
  BILLING: 'BILLING',
  SHIPPING: 'SHIPPING',
  BOTH: 'BOTH',
  HEADQUARTERS: 'HEADQUARTERS',
} as const;
export type AddressType = (typeof AddressType)[keyof typeof AddressType];

export const BankAccountType = {
  CHECKING: 'CHECKING',
  SAVINGS: 'SAVINGS',
  SALARY: 'SALARY',
  PAYMENT: 'PAYMENT',
  INVESTMENT: 'INVESTMENT',
  BENEFITS: 'BENEFITS',
} as const;
export type BankAccountType = (typeof BankAccountType)[keyof typeof BankAccountType];

export const PixKeyType = {
  CNPJ: 'CNPJ',
  CPF: 'CPF',
  EMAIL: 'EMAIL',
  PHONE: 'PHONE',
  RANDOM: 'RANDOM',
} as const;
export type PixKeyType = (typeof PixKeyType)[keyof typeof PixKeyType];

export const SettingType = {
  BILL_SUBMIT_REQUIRED_FIELDS: 'BILL_SUBMIT_REQUIRED_FIELDS',
  REIMBURSEMENT_REQUEST_REQUIRED_FIELDS: 'REIMBURSEMENT_REQUEST_REQUIRED_FIELDS',
  EMAIL_INBOX_AP_REQUIRED_FIELDS: 'EMAIL_INBOX_AP_REQUIRED_FIELDS',
  EMAIL_INBOX_REIMBURSEMENT_REQUIRED_FIELDS: 'EMAIL_INBOX_REIMBURSEMENT_REQUIRED_FIELDS',
  APPROVAL_GLOBAL_SETTINGS: 'APPROVAL_GLOBAL_SETTINGS',
  HCM_PAYROLL_EXPENSE_SETTINGS: 'HCM_PAYROLL_EXPENSE_SETTINGS',
  HCM_PAYROLL_COST_SETTINGS: 'HCM_PAYROLL_COST_SETTINGS',
  HCM_PAYROLL_GL_SETTINGS: 'HCM_PAYROLL_GL_SETTINGS',
  BUSINESS_CONTEXT: 'BUSINESS_CONTEXT',
  BUDGET_GLOBAL_SETTINGS: 'BUDGET_GLOBAL_SETTINGS',
  PROCUREMENT_GLOBAL_SETTINGS: 'PROCUREMENT_GLOBAL_SETTINGS',
  ONBOARDING_WIDGET_DISMISSED: 'ONBOARDING_WIDGET_DISMISSED',
  CONTRACT_REVIEW_PROMPTS: 'CONTRACT_REVIEW_PROMPTS',
  AR_COLLECTION_SETTINGS: 'AR_COLLECTION_SETTINGS',
  BILLING_SAAS_METRICS_SETTINGS: 'BILLING_SAAS_METRICS_SETTINGS',
  BILLING_AR_FORECAST_SETTINGS: 'BILLING_AR_FORECAST_SETTINGS',
  AP_BILL_INGESTION_SETTINGS: 'AP_BILL_INGESTION_SETTINGS',
  AP_AI_POSTING: 'AP_AI_POSTING',
  AR_INVOICE_APPROVAL_SETTINGS: 'AR_INVOICE_APPROVAL_SETTINGS',
} as const;
export type SettingType = (typeof SettingType)[keyof typeof SettingType];

export const SavedViewModule = {
  GL: 'GL',
  AP: 'AP',
  AR: 'AR',
  HCM: 'HCM',
  CORE: 'CORE',
} as const;
export type SavedViewModule = (typeof SavedViewModule)[keyof typeof SavedViewModule];

export const SavedViewScope = {
  PRIVATE: 'PRIVATE',
  TENANT: 'TENANT',
} as const;
export type SavedViewScope = (typeof SavedViewScope)[keyof typeof SavedViewScope];

export const VendorDocumentStatus = {
  VALID: 'VALID',
  EXPIRED: 'EXPIRED',
  PENDING_RENEWAL: 'PENDING_RENEWAL',
  REJECTED: 'REJECTED',
} as const;
export type VendorDocumentStatus = (typeof VendorDocumentStatus)[keyof typeof VendorDocumentStatus];

export const SuggestionMode = {
  ROOT: 'ROOT',
  SYSTEM: 'SYSTEM',
  TAX: 'TAX',
} as const;
export type SuggestionMode = (typeof SuggestionMode)[keyof typeof SuggestionMode];

export const DocumentStatus = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  EXTRACTED: 'EXTRACTED',
  PENDING_REVIEW: 'PENDING_REVIEW',
  CLASSIFYING: 'CLASSIFYING',
  LINKED: 'LINKED',
  VALIDATED: 'VALIDATED',
  RECONCILIATION_COMPLETED: 'RECONCILIATION_COMPLETED',
  FAILED: 'FAILED',
} as const;
export type DocumentStatus = (typeof DocumentStatus)[keyof typeof DocumentStatus];

export const DocumentType = {
  BOLETO: 'BOLETO',
  NFE: 'NFE',
  NFE_PRODUTO: 'NFE_PRODUTO',
  NFE_SERVICO: 'NFE_SERVICO',
  CARD_INVOICE: 'CARD_INVOICE',
  BOLETO_COM_NF: 'BOLETO_COM_NF',
  TELECOM_BILL: 'TELECOM_BILL',
  UTILITIES_BILL: 'UTILITIES_BILL',
  DARF: 'DARF',
  GPS: 'GPS',
  GUIA_ISS: 'GUIA_ISS',
  GUIA_ICMS: 'GUIA_ICMS',
  GRF: 'GRF',
  DAS: 'DAS',
  COMPROVANTE_PAGAMENTO: 'COMPROVANTE_PAGAMENTO',
  CUPOM_FISCAL: 'CUPOM_FISCAL',
  PURCHASE_QUOTE: 'PURCHASE_QUOTE',
  RECIBO_PLATAFORMA: 'RECIBO_PLATAFORMA',
  RECIBO_GENERICO: 'RECIBO_GENERICO',
  GENERIC_INVOICE: 'GENERIC_INVOICE',
  INTERNATIONAL_INVOICE: 'INTERNATIONAL_INVOICE',
  OFX: 'OFX',
  BANK_STATEMENT: 'BANK_STATEMENT',
  CARD_STATEMENT: 'CARD_STATEMENT',
  UNKNOWN: 'UNKNOWN',
} as const;
export type DocumentType = (typeof DocumentType)[keyof typeof DocumentType];

export const ApDocumentBillLinkReason = {
  ONFLY_RDV_STATEMENT: 'ONFLY_RDV_STATEMENT',
} as const;
export type ApDocumentBillLinkReason =
  (typeof ApDocumentBillLinkReason)[keyof typeof ApDocumentBillLinkReason];

export const RollupPlanStatus = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
  ARCHIVED: 'ARCHIVED',
} as const;
export type RollupPlanStatus = (typeof RollupPlanStatus)[keyof typeof RollupPlanStatus];

export const RollupGroupType = {
  AGGREGATION: 'AGGREGATION',
  CALCULATED: 'CALCULATED',
} as const;
export type RollupGroupType = (typeof RollupGroupType)[keyof typeof RollupGroupType];

export const AggregationType = {
  SUM: 'SUM',
  AVG: 'AVG',
  COUNT: 'COUNT',
  MIN: 'MIN',
  MAX: 'MAX',
} as const;
export type AggregationType = (typeof AggregationType)[keyof typeof AggregationType];

export const FilterDimension = {
  ENTITY: 'ENTITY',
  MANAGERIAL_ACCOUNT: 'MANAGERIAL_ACCOUNT',
  COST_CENTER: 'COST_CENTER',
  DEPARTMENT: 'DEPARTMENT',
  SEGMENT: 'SEGMENT',
  VENDOR: 'VENDOR',
  DATE_RANGE: 'DATE_RANGE',
  AMOUNT: 'AMOUNT',
} as const;
export type FilterDimension = (typeof FilterDimension)[keyof typeof FilterDimension];

export const FilterOperator = {
  EQUALS: 'EQUALS',
  NOT_EQUALS: 'NOT_EQUALS',
  IN: 'IN',
  NOT_IN: 'NOT_IN',
  LIKE: 'LIKE',
  BETWEEN: 'BETWEEN',
  GREATER_THAN: 'GREATER_THAN',
  GREATER_OR_EQUAL: 'GREATER_OR_EQUAL',
  LESS_THAN: 'LESS_THAN',
  LESS_OR_EQUAL: 'LESS_OR_EQUAL',
} as const;
export type FilterOperator = (typeof FilterOperator)[keyof typeof FilterOperator];

export const FilterLogic = {
  AND: 'AND',
  OR: 'OR',
} as const;
export type FilterLogic = (typeof FilterLogic)[keyof typeof FilterLogic];

export const VendorKnowledgeReviewStatus = {
  DRAFT: 'DRAFT',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
} as const;
export type VendorKnowledgeReviewStatus =
  (typeof VendorKnowledgeReviewStatus)[keyof typeof VendorKnowledgeReviewStatus];

export const PisCofinsCreditRevenueUse = {
  DIRECT_CUMULATIVE: 'DIRECT_CUMULATIVE',
  DIRECT_NON_CUMULATIVE: 'DIRECT_NON_CUMULATIVE',
  COMMON: 'COMMON',
} as const;
export type PisCofinsCreditRevenueUse =
  (typeof PisCofinsCreditRevenueUse)[keyof typeof PisCofinsCreditRevenueUse];

export const ApBillStatus = {
  DRAFT: 'DRAFT',
  SUBMITTED: 'SUBMITTED',
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  PROCESSING_APPROVAL: 'PROCESSING_APPROVAL',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  PARTIALLY_PAID: 'PARTIALLY_PAID',
  PAID: 'PAID',
  COMPLETED: 'COMPLETED',
  VOID: 'VOID',
  MIGRATED: 'MIGRATED',
} as const;
export type ApBillStatus = (typeof ApBillStatus)[keyof typeof ApBillStatus];

export const ApBillSource = {
  MANUAL: 'MANUAL',
  EMAIL: 'EMAIL',
  OCR: 'OCR',
  API: 'API',
  EXTERNAL_FORM: 'EXTERNAL_FORM',
  NFE_AUTO_IMPORT: 'NFE_AUTO_IMPORT',
  BANK_FEE_AUTO: 'BANK_FEE_AUTO',
  VENDOR_ADVANCEMENT_RECONCILIATION: 'VENDOR_ADVANCEMENT_RECONCILIATION',
  PAYROLL_PROCESSING: 'PAYROLL_PROCESSING',
  CSV_IMPORT: 'CSV_IMPORT',
  CONTA_SIMPLES_CARD_ATTACHMENT: 'CONTA_SIMPLES_CARD_ATTACHMENT',
  CLARA_CARD_ATTACHMENT: 'CLARA_CARD_ATTACHMENT',
  BREX_CARD_ATTACHMENT: 'BREX_CARD_ATTACHMENT',
  REIMBURSEMENT_REQUEST: 'REIMBURSEMENT_REQUEST',
  CARD_FAST_TRACK: 'CARD_FAST_TRACK',
  ONFLY_TRAVEL: 'ONFLY_TRAVEL',
} as const;
export type ApBillSource = (typeof ApBillSource)[keyof typeof ApBillSource];

export const ApBillType = {
  EXPENSE: 'EXPENSE',
  PAYROLL: 'PAYROLL',
  TAXES: 'TAXES',
  BANK_FEE: 'BANK_FEE',
  VENDOR_ADVANCEMENT: 'VENDOR_ADVANCEMENT',
  CREDIT_CARD_INVOICE: 'CREDIT_CARD_INVOICE',
} as const;
export type ApBillType = (typeof ApBillType)[keyof typeof ApBillType];

export const ApBillIntakeState = {
  PENDING: 'PENDING',
  DONE: 'DONE',
} as const;
export type ApBillIntakeState = (typeof ApBillIntakeState)[keyof typeof ApBillIntakeState];

export const ApBillChangeCaptureFailureKind = {
  ERROR: 'ERROR',
  DEGRADED: 'DEGRADED',
} as const;
export type ApBillChangeCaptureFailureKind =
  (typeof ApBillChangeCaptureFailureKind)[keyof typeof ApBillChangeCaptureFailureKind];

export const ApApprovalChainStatus = {
  PENDING: 'PENDING',
  IN_PROGRESS: 'IN_PROGRESS',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  CANCELLED: 'CANCELLED',
} as const;
export type ApApprovalChainStatus =
  (typeof ApApprovalChainStatus)[keyof typeof ApApprovalChainStatus];

export const ApApprovalStepStatus = {
  PENDING: 'PENDING',
  IN_PROGRESS: 'IN_PROGRESS',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  SKIPPED: 'SKIPPED',
  ESCALATED: 'ESCALATED',
} as const;
export type ApApprovalStepStatus = (typeof ApApprovalStepStatus)[keyof typeof ApApprovalStepStatus];

export const ApApprovalAction = {
  APPROVE: 'APPROVE',
  REJECT: 'REJECT',
  DELEGATE: 'DELEGATE',
  ESCALATE: 'ESCALATE',
} as const;
export type ApApprovalAction = (typeof ApApprovalAction)[keyof typeof ApApprovalAction];

export const ApApprovalPattern = {
  SINGLE: 'SINGLE',
  ANY_OF: 'ANY_OF',
  ALL_SEQUENTIAL: 'ALL_SEQUENTIAL',
  ALL_PARALLEL: 'ALL_PARALLEL',
} as const;
export type ApApprovalPattern = (typeof ApApprovalPattern)[keyof typeof ApApprovalPattern];

export const ApBillAlertStatus = {
  OPEN: 'OPEN',
  RESOLVED: 'RESOLVED',
} as const;
export type ApBillAlertStatus = (typeof ApBillAlertStatus)[keyof typeof ApBillAlertStatus];

export const ApBillAlertResolution = {
  KEPT_DEFAULT: 'KEPT_DEFAULT',
  ACCEPTED: 'ACCEPTED',
} as const;
export type ApBillAlertResolution =
  (typeof ApBillAlertResolution)[keyof typeof ApBillAlertResolution];

export const ApBillAlertType = {
  BILL_ALREADY_APPROVED: 'BILL_ALREADY_APPROVED',
  BILL_ALREADY_PAID: 'BILL_ALREADY_PAID',
  DUPLICATE_DOCUMENT: 'DUPLICATE_DOCUMENT',
  ENTITY_MISMATCH: 'ENTITY_MISMATCH',
  EXTERNAL_FORM_DOCUMENT_MISMATCH: 'EXTERNAL_FORM_DOCUMENT_MISMATCH',
  RECONCILED_WITHOUT_APPROVAL: 'RECONCILED_WITHOUT_APPROVAL',
  AMOUNT_ANOMALY: 'AMOUNT_ANOMALY',
  VENDOR_CONCENTRATION: 'VENDOR_CONCENTRATION',
  EXPIRING_CONTRACT: 'EXPIRING_CONTRACT',
  CORPORATE_GROUP_MIXED_CNPJ: 'CORPORATE_GROUP_MIXED_CNPJ',
  INTAKE_DOCUMENTS_MISSING: 'INTAKE_DOCUMENTS_MISSING',
  INTAKE_METADATA_MISMATCH: 'INTAKE_METADATA_MISMATCH',
  ONFLY_CLASSIFICATION_INCOMPLETE: 'ONFLY_CLASSIFICATION_INCOMPLETE',
  ONFLY_DEFAULT_COST_CENTER_USED: 'ONFLY_DEFAULT_COST_CENTER_USED',
  ONFLY_AUTO_APPROVAL_BLOCKED: 'ONFLY_AUTO_APPROVAL_BLOCKED',
  ONFLY_POSTING_FAILED: 'ONFLY_POSTING_FAILED',
} as const;
export type ApBillAlertType = (typeof ApBillAlertType)[keyof typeof ApBillAlertType];

export const ClientReimbursementStatus = {
  OPEN: 'OPEN',
  READY_FOR_REIMBURSEMENT: 'READY_FOR_REIMBURSEMENT',
  BILLED: 'BILLED',
  REIMBURSED: 'REIMBURSED',
  WRITTEN_OFF: 'WRITTEN_OFF',
} as const;
export type ClientReimbursementStatus =
  (typeof ClientReimbursementStatus)[keyof typeof ClientReimbursementStatus];

export const ApClassificationMode = {
  BILL_LEVEL: 'BILL_LEVEL',
  LINE_ITEM_LEVEL: 'LINE_ITEM_LEVEL',
} as const;
export type ApClassificationMode = (typeof ApClassificationMode)[keyof typeof ApClassificationMode];

export const StatutoryTreatment = {
  BYPASS: 'BYPASS',
  AUTO_PROVISION: 'AUTO_PROVISION',
  CLASSIFY: 'CLASSIFY',
} as const;
export type StatutoryTreatment = (typeof StatutoryTreatment)[keyof typeof StatutoryTreatment];

export const StatutoryTaxSlotResolution = {
  TAX_SLOT: 'TAX_SLOT',
  CLASSIFIABLE_CHARGE: 'CLASSIFIABLE_CHARGE',
  UNRESOLVED: 'UNRESOLVED',
} as const;
export type StatutoryTaxSlotResolution =
  (typeof StatutoryTaxSlotResolution)[keyof typeof StatutoryTaxSlotResolution];

export const StatutoryAssessmentPeriodStatus = {
  RESOLVED: 'RESOLVED',
  AMBIGUOUS: 'AMBIGUOUS',
  UNSUPPORTED: 'UNSUPPORTED',
} as const;
export type StatutoryAssessmentPeriodStatus =
  (typeof StatutoryAssessmentPeriodStatus)[keyof typeof StatutoryAssessmentPeriodStatus];

export const StatutoryTreatmentProvenance = {
  SLOT_DEFAULT: 'SLOT_DEFAULT',
  ENTITY_CONFIG: 'ENTITY_CONFIG',
  BILL_OVERRIDE: 'BILL_OVERRIDE',
  PAYER_CLASSIFY: 'PAYER_CLASSIFY',
} as const;
export type StatutoryTreatmentProvenance =
  (typeof StatutoryTreatmentProvenance)[keyof typeof StatutoryTreatmentProvenance];

export const StatutoryTaxComponentKind = {
  PRINCIPAL: 'PRINCIPAL',
  FINE: 'FINE',
  INTEREST: 'INTEREST',
} as const;
export type StatutoryTaxComponentKind =
  (typeof StatutoryTaxComponentKind)[keyof typeof StatutoryTaxComponentKind];

export const StatutoryTaxComponentAttribution = {
  LINE: 'LINE',
  DOCUMENT: 'DOCUMENT',
} as const;
export type StatutoryTaxComponentAttribution =
  (typeof StatutoryTaxComponentAttribution)[keyof typeof StatutoryTaxComponentAttribution];

export const ApExternalFormIntakeStatus = {
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
  FALLBACK_CREATED: 'FALLBACK_CREATED',
  FAILED: 'FAILED',
} as const;
export type ApExternalFormIntakeStatus =
  (typeof ApExternalFormIntakeStatus)[keyof typeof ApExternalFormIntakeStatus];

export const ApClassificationSource = {
  USER: 'USER',
  AI: 'AI',
  SYSTEM: 'SYSTEM',
} as const;
export type ApClassificationSource =
  (typeof ApClassificationSource)[keyof typeof ApClassificationSource];

export const ApAllocationType = {
  SIMPLE: 'SIMPLE',
  CUSTOM_BREAKDOWN: 'CUSTOM_BREAKDOWN',
} as const;
export type ApAllocationType = (typeof ApAllocationType)[keyof typeof ApAllocationType];

export const LineItemType = {
  SERVICE: 'SERVICE',
  INTEREST: 'INTEREST',
  FINE: 'FINE',
  DISCOUNT: 'DISCOUNT',
  OTHER: 'OTHER',
} as const;
export type LineItemType = (typeof LineItemType)[keyof typeof LineItemType];

export const ApRecurrencyFrequency = {
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
  BIMONTHLY: 'BIMONTHLY',
  QUARTERLY: 'QUARTERLY',
  SEMESTERLY: 'SEMESTERLY',
  YEARLY: 'YEARLY',
} as const;
export type ApRecurrencyFrequency =
  (typeof ApRecurrencyFrequency)[keyof typeof ApRecurrencyFrequency];

export const ApRecurrenceValueType = {
  FIXED: 'FIXED',
  VARIABLE: 'VARIABLE',
} as const;
export type ApRecurrenceValueType =
  (typeof ApRecurrenceValueType)[keyof typeof ApRecurrenceValueType];

export const ApRecurringBillType = {
  STANDARD: 'STANDARD',
  PAYROLL: 'PAYROLL',
} as const;
export type ApRecurringBillType = (typeof ApRecurringBillType)[keyof typeof ApRecurringBillType];

export const ApBillHistoryEntityType = {
  BILL: 'BILL',
  LINE_ITEM: 'LINE_ITEM',
  CLASSIFICATION: 'CLASSIFICATION',
  APPROVAL_STEP: 'APPROVAL_STEP',
} as const;
export type ApBillHistoryEntityType =
  (typeof ApBillHistoryEntityType)[keyof typeof ApBillHistoryEntityType];

export const ApBillHistoryAction = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
  STATUS_CHANGE: 'STATUS_CHANGE',
  CLASSIFICATION_MODE_SET: 'CLASSIFICATION_MODE_SET',
  DOCUMENT_LINKED: 'DOCUMENT_LINKED',
  APPROVE: 'APPROVE',
  REJECT: 'REJECT',
  RECONCILED: 'RECONCILED',
  GL_REVERSAL_REGRESSION: 'GL_REVERSAL_REGRESSION',
  GL_REVERSAL_VOID: 'GL_REVERSAL_VOID',
  GL_EDIT_AND_REPOST: 'GL_EDIT_AND_REPOST',
  APPROVAL_FAILED: 'APPROVAL_FAILED',
  MERGED: 'MERGED',
} as const;
export type ApBillHistoryAction = (typeof ApBillHistoryAction)[keyof typeof ApBillHistoryAction];

export const ApBillLineDestination = {
  EXPENSE: 'EXPENSE',
  COST_PROVISION: 'COST_PROVISION',
  COST_POOL: 'COST_POOL',
} as const;
export type ApBillLineDestination =
  (typeof ApBillLineDestination)[keyof typeof ApBillLineDestination];

export const ApBillDeferralStatus = {
  DRAFT: 'DRAFT',
  ACTIVE: 'ACTIVE',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
} as const;
export type ApBillDeferralStatus = (typeof ApBillDeferralStatus)[keyof typeof ApBillDeferralStatus];

export const ApBillDeferralRecognitionMethod = {
  MONTHLY: 'MONTHLY',
  DAILY_PRO_RATA: 'DAILY_PRO_RATA',
} as const;
export type ApBillDeferralRecognitionMethod =
  (typeof ApBillDeferralRecognitionMethod)[keyof typeof ApBillDeferralRecognitionMethod];

export const ApBillDeferralScheduleStatus = {
  PENDING: 'PENDING',
  POSTED: 'POSTED',
  REVERSED: 'REVERSED',
  CANCELLED: 'CANCELLED',
} as const;
export type ApBillDeferralScheduleStatus =
  (typeof ApBillDeferralScheduleStatus)[keyof typeof ApBillDeferralScheduleStatus];

export const ApBillDeferralBucket = {
  SHORT: 'SHORT',
  LONG: 'LONG',
} as const;
export type ApBillDeferralBucket = (typeof ApBillDeferralBucket)[keyof typeof ApBillDeferralBucket];

export const ApBillDeferralCancelMode = {
  FULL_REVERSAL: 'FULL_REVERSAL',
  EARLY_WRITEOFF: 'EARLY_WRITEOFF',
  VENDOR_REFUND: 'VENDOR_REFUND',
  RECLASSIFY_ONLY: 'RECLASSIFY_ONLY',
} as const;
export type ApBillDeferralCancelMode =
  (typeof ApBillDeferralCancelMode)[keyof typeof ApBillDeferralCancelMode];

export const ApExpenseAccrualStatus = {
  PROPOSED: 'PROPOSED',
  POSTED: 'POSTED',
  SETTLED: 'SETTLED',
  DISMISSED: 'DISMISSED',
} as const;
export type ApExpenseAccrualStatus =
  (typeof ApExpenseAccrualStatus)[keyof typeof ApExpenseAccrualStatus];

export const ApExpenseAccrualOrigin = {
  TEMPLATE: 'TEMPLATE',
  MANUAL: 'MANUAL',
} as const;
export type ApExpenseAccrualOrigin =
  (typeof ApExpenseAccrualOrigin)[keyof typeof ApExpenseAccrualOrigin];

export const ApExpenseAccrualSuggestionStatus = {
  PENDING: 'PENDING',
  CONFIRMED: 'CONFIRMED',
  DISMISSED: 'DISMISSED',
} as const;
export type ApExpenseAccrualSuggestionStatus =
  (typeof ApExpenseAccrualSuggestionStatus)[keyof typeof ApExpenseAccrualSuggestionStatus];

export const ApPaymentStatus = {
  SCHEDULED: 'SCHEDULED',
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  PAID: 'PAID',
  RECONCILED: 'RECONCILED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED',
  REVERSED: 'REVERSED',
} as const;
export type ApPaymentStatus = (typeof ApPaymentStatus)[keyof typeof ApPaymentStatus];

export const ApPaymentType = {
  PRINCIPAL: 'PRINCIPAL',
  TAX_WITHHOLDING: 'TAX_WITHHOLDING',
  INSTALLMENT: 'INSTALLMENT',
  ADVANCE: 'ADVANCE',
  REFUND: 'REFUND',
  ADJUSTMENT: 'ADJUSTMENT',
} as const;
export type ApPaymentType = (typeof ApPaymentType)[keyof typeof ApPaymentType];

export const ApAdjustmentType = {
  DISCOUNT_EARLY_PAYMENT: 'DISCOUNT_EARLY_PAYMENT',
  DISCOUNT_NEGOTIATED: 'DISCOUNT_NEGOTIATED',
  DISCOUNT_DEFECT: 'DISCOUNT_DEFECT',
  PENALTY_LATE_PAYMENT: 'PENALTY_LATE_PAYMENT',
  ROUNDING: 'ROUNDING',
  WRITE_OFF: 'WRITE_OFF',
  REFUND: 'REFUND',
  OTHER: 'OTHER',
} as const;
export type ApAdjustmentType = (typeof ApAdjustmentType)[keyof typeof ApAdjustmentType];

export const ApSettlementBookEventKind = {
  SETTLEMENT: 'SETTLEMENT',
  REVERSAL: 'REVERSAL',
} as const;
export type ApSettlementBookEventKind =
  (typeof ApSettlementBookEventKind)[keyof typeof ApSettlementBookEventKind];

export const ReimbursementPeriodType = {
  MONTHLY: 'MONTHLY',
  QUARTERLY: 'QUARTERLY',
  YEARLY: 'YEARLY',
} as const;
export type ReimbursementPeriodType =
  (typeof ReimbursementPeriodType)[keyof typeof ReimbursementPeriodType];

export const ReimbursementFlagType = {
  NO_POLICY_MATCHED: 'NO_POLICY_MATCHED',
  EXCEEDS_TRANSACTION_LIMIT: 'EXCEEDS_TRANSACTION_LIMIT',
  EXCEEDS_PERIOD_LIMIT: 'EXCEEDS_PERIOD_LIMIT',
  NEAR_PERIOD_LIMIT: 'NEAR_PERIOD_LIMIT',
  AUTO_APPROVED: 'AUTO_APPROVED',
  POLICY_OVERRIDE: 'POLICY_OVERRIDE',
  LATE_SUBMISSION: 'LATE_SUBMISSION',
  TAX_ID_ENTITY_MISSING_ON_DOCUMENT: 'TAX_ID_ENTITY_MISSING_ON_DOCUMENT',
  AI_POLICY_MANUAL_REVIEW: 'AI_POLICY_MANUAL_REVIEW',
  AI_APPROVED_WITH_CAVEAT: 'AI_APPROVED_WITH_CAVEAT',
} as const;
export type ReimbursementFlagType =
  (typeof ReimbursementFlagType)[keyof typeof ReimbursementFlagType];

export const ReimbursementPolicyEvaluationMode = {
  DETERMINISTIC: 'DETERMINISTIC',
  AI: 'AI',
} as const;
export type ReimbursementPolicyEvaluationMode =
  (typeof ReimbursementPolicyEvaluationMode)[keyof typeof ReimbursementPolicyEvaluationMode];

export const ReimbursementPayoutScheduleSource = {
  GLOBAL: 'GLOBAL',
  SPECIFIC: 'SPECIFIC',
} as const;
export type ReimbursementPayoutScheduleSource =
  (typeof ReimbursementPayoutScheduleSource)[keyof typeof ReimbursementPayoutScheduleSource];

export const ReimbursementPayoutScheduleMode = {
  WEEKDAYS: 'WEEKDAYS',
  MONTH_DAYS: 'MONTH_DAYS',
  OFFSET_DAYS: 'OFFSET_DAYS',
} as const;
export type ReimbursementPayoutScheduleMode =
  (typeof ReimbursementPayoutScheduleMode)[keyof typeof ReimbursementPayoutScheduleMode];

export const ReimbursementPayoutScheduleAnchor = {
  SUBMISSION: 'SUBMISSION',
  APPROVAL: 'APPROVAL',
} as const;
export type ReimbursementPayoutScheduleAnchor =
  (typeof ReimbursementPayoutScheduleAnchor)[keyof typeof ReimbursementPayoutScheduleAnchor];

export const ReimbursementDueDateSource = {
  MANUAL: 'MANUAL',
  REQUESTED: 'REQUESTED',
  GLOBAL: 'GLOBAL',
  SPECIFIC: 'SPECIFIC',
  FALLBACK: 'FALLBACK',
} as const;
export type ReimbursementDueDateSource =
  (typeof ReimbursementDueDateSource)[keyof typeof ReimbursementDueDateSource];

export const ReimbursementHistoryAction = {
  CREATED: 'CREATED',
  UPDATED: 'UPDATED',
  SUBMITTED: 'SUBMITTED',
  POLICY_EVALUATED: 'POLICY_EVALUATED',
  AMOUNT_CAPPED: 'AMOUNT_CAPPED',
  CANCELLED: 'CANCELLED',
  INFO_REQUESTED: 'INFO_REQUESTED',
  INFO_RESPONDED: 'INFO_RESPONDED',
} as const;
export type ReimbursementHistoryAction =
  (typeof ReimbursementHistoryAction)[keyof typeof ReimbursementHistoryAction];

export const ReimbursementInfoRequestStatus = {
  PENDING: 'PENDING',
  RESPONDED: 'RESPONDED',
  EXPIRED: 'EXPIRED',
  CANCELLED: 'CANCELLED',
} as const;
export type ReimbursementInfoRequestStatus =
  (typeof ReimbursementInfoRequestStatus)[keyof typeof ReimbursementInfoRequestStatus];

export const ReimbursementExternalTokenScope = {
  MORE_INFO_RESPONSE: 'MORE_INFO_RESPONSE',
} as const;
export type ReimbursementExternalTokenScope =
  (typeof ReimbursementExternalTokenScope)[keyof typeof ReimbursementExternalTokenScope];

export const PublicReimbursementIntakeAccessMode = {
  HCM_EMPLOYEES: 'HCM_EMPLOYEES',
  COMPANY_DOMAIN: 'COMPANY_DOMAIN',
  PUBLIC: 'PUBLIC',
} as const;
export type PublicReimbursementIntakeAccessMode =
  (typeof PublicReimbursementIntakeAccessMode)[keyof typeof PublicReimbursementIntakeAccessMode];

export const ApRemediationRunStatus = {
  PREVIEWED: 'PREVIEWED',
  APPROVED: 'APPROVED',
  EXECUTED: 'EXECUTED',
  CANCELLED: 'CANCELLED',
} as const;
export type ApRemediationRunStatus =
  (typeof ApRemediationRunStatus)[keyof typeof ApRemediationRunStatus];

export const ApRemediationFindingType = {
  FACE_VALUE_PROVISION: 'FACE_VALUE_PROVISION',
  LIABILITY_RESIDUAL: 'LIABILITY_RESIDUAL',
  MARK_PAID_NO_CLEARING: 'MARK_PAID_NO_CLEARING',
  RATE_BACKFILL_ONLY: 'RATE_BACKFILL_ONLY',
  DOUBLE_COUNT_RISK: 'DOUBLE_COUNT_RISK',
  QUARANTINED: 'QUARANTINED',
} as const;
export type ApRemediationFindingType =
  (typeof ApRemediationFindingType)[keyof typeof ApRemediationFindingType];

export const ApRemediationTreatment = {
  NET_ADJUSTMENT_OPEN_PERIOD: 'NET_ADJUSTMENT_OPEN_PERIOD',
  REVERSE_AND_REPOST: 'REVERSE_AND_REPOST',
  DATA_NORMALIZE_ONLY: 'DATA_NORMALIZE_ONLY',
  QUARANTINE: 'QUARANTINE',
  NONE: 'NONE',
} as const;
export type ApRemediationTreatment =
  (typeof ApRemediationTreatment)[keyof typeof ApRemediationTreatment];

export const ApRemediationPeriodTreatment = {
  CURRENT_PERIOD_ADJUSTMENT: 'CURRENT_PERIOD_ADJUSTMENT',
  OPENING_EQUITY: 'OPENING_EQUITY',
  COMPARATIVE_RESTATEMENT: 'COMPARATIVE_RESTATEMENT',
  NOT_APPLICABLE: 'NOT_APPLICABLE',
} as const;
export type ApRemediationPeriodTreatment =
  (typeof ApRemediationPeriodTreatment)[keyof typeof ApRemediationPeriodTreatment];

export const ApRemediationJournalEventKind = {
  ORIGINAL: 'ORIGINAL',
  REVERSAL: 'REVERSAL',
  CORRECTION: 'CORRECTION',
} as const;
export type ApRemediationJournalEventKind =
  (typeof ApRemediationJournalEventKind)[keyof typeof ApRemediationJournalEventKind];

export const ArInvoiceStatus = {
  DRAFT: 'DRAFT',
  AWAITING_NF: 'AWAITING_NF',
  BLOCKED: 'BLOCKED',
  STALE: 'STALE',
  ISSUED: 'ISSUED',
  PARTIALLY_PAID: 'PARTIALLY_PAID',
  PAID_UNCONFIRMED: 'PAID_UNCONFIRMED',
  PARTIALLY_RECEIVED: 'PARTIALLY_RECEIVED',
  PAID: 'PAID',
  VOID: 'VOID',
  MIGRATED: 'MIGRATED',
} as const;
export type ArInvoiceStatus = (typeof ArInvoiceStatus)[keyof typeof ArInvoiceStatus];

export const ArReceiptStatus = {
  DRAFT: 'DRAFT',
  POSTED: 'POSTED',
  PARTIALLY_ALLOCATED: 'PARTIALLY_ALLOCATED',
  FULLY_ALLOCATED: 'FULLY_ALLOCATED',
  VOID: 'VOID',
} as const;
export type ArReceiptStatus = (typeof ArReceiptStatus)[keyof typeof ArReceiptStatus];

export const ArDebitNoteStatus = {
  DRAFT: 'DRAFT',
  ISSUED: 'ISSUED',
  PARTIALLY_RECEIVED: 'PARTIALLY_RECEIVED',
  RECEIVED: 'RECEIVED',
  VOID: 'VOID',
} as const;
export type ArDebitNoteStatus = (typeof ArDebitNoteStatus)[keyof typeof ArDebitNoteStatus];

export const ArClassificationSource = {
  USER: 'USER',
  INTEGRATION: 'INTEGRATION',
  WORKFLOW: 'WORKFLOW',
  SYSTEM: 'SYSTEM',
} as const;
export type ArClassificationSource =
  (typeof ArClassificationSource)[keyof typeof ArClassificationSource];

export const ArWithholdingTaxType = {
  IRRF: 'IRRF',
  PIS: 'PIS',
  COFINS: 'COFINS',
  CSLL: 'CSLL',
  INSS: 'INSS',
  ISS: 'ISS',
} as const;
export type ArWithholdingTaxType = (typeof ArWithholdingTaxType)[keyof typeof ArWithholdingTaxType];

export const ArNfseEmissionStatus = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  AUTHORIZED: 'AUTHORIZED',
  CANCELLING: 'CANCELLING',
  ERROR: 'ERROR',
  CANCELLED: 'CANCELLED',
} as const;
export type ArNfseEmissionStatus = (typeof ArNfseEmissionStatus)[keyof typeof ArNfseEmissionStatus];

export const ArNfseEmissionMode = {
  NACIONAL: 'NACIONAL',
  MUNICIPAL: 'MUNICIPAL',
} as const;
export type ArNfseEmissionMode = (typeof ArNfseEmissionMode)[keyof typeof ArNfseEmissionMode];

export const ArNfseCancelType = {
  DIRECT: 'DIRECT',
  ADMINISTRATIVE: 'ADMINISTRATIVE',
} as const;
export type ArNfseCancelType = (typeof ArNfseCancelType)[keyof typeof ArNfseCancelType];

export const ArNfseCancelAction = {
  VOID: 'VOID',
  REVERT_TO_DRAFT: 'REVERT_TO_DRAFT',
} as const;
export type ArNfseCancelAction = (typeof ArNfseCancelAction)[keyof typeof ArNfseCancelAction];

export const ArNfseCancellationStatus = {
  REQUESTED: 'REQUESTED',
  PROCESSING: 'PROCESSING',
  PENDING_ADMINISTRATIVE: 'PENDING_ADMINISTRATIVE',
  GL_REVERSAL_ERROR: 'GL_REVERSAL_ERROR',
  CONFIRMED: 'CONFIRMED',
  FAILED: 'FAILED',
} as const;
export type ArNfseCancellationStatus =
  (typeof ArNfseCancellationStatus)[keyof typeof ArNfseCancellationStatus];

export const ArInvoiceType = {
  STANDARD: 'STANDARD',
  TRANSACTION: 'TRANSACTION',
  GTV_TRANSACTION: 'GTV_TRANSACTION',
  AGGREGATE: 'AGGREGATE',
} as const;
export type ArInvoiceType = (typeof ArInvoiceType)[keyof typeof ArInvoiceType];

export const ArInvoiceIssueStep = {
  RECORD: 'RECORD',
  APPROVE: 'APPROVE',
  NFSE: 'NFSE',
} as const;
export type ArInvoiceIssueStep = (typeof ArInvoiceIssueStep)[keyof typeof ArInvoiceIssueStep];

export const ArBoletoStatus = {
  PENDING: 'PENDING',
  REGISTERED: 'REGISTERED',
  PAID_UNCONFIRMED: 'PAID_UNCONFIRMED',
  SETTLED: 'SETTLED',
  CANCELLED: 'CANCELLED',
  FAILED: 'FAILED',
} as const;
export type ArBoletoStatus = (typeof ArBoletoStatus)[keyof typeof ArBoletoStatus];

export const ItauBoletoEntityConfigStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  ERROR: 'ERROR',
} as const;
export type ItauBoletoEntityConfigStatus =
  (typeof ItauBoletoEntityConfigStatus)[keyof typeof ItauBoletoEntityConfigStatus];

export const ItauBoletoWebhookEventStatus = {
  RECEIVED: 'RECEIVED',
  PROCESSED: 'PROCESSED',
  IGNORED: 'IGNORED',
  FAILED: 'FAILED',
} as const;
export type ItauBoletoWebhookEventStatus =
  (typeof ItauBoletoWebhookEventStatus)[keyof typeof ItauBoletoWebhookEventStatus];

export const ArBoletoMovementKind = {
  LIQUIDACAO: 'LIQUIDACAO',
  ENTRADA: 'ENTRADA',
  BAIXA: 'BAIXA',
  OTHER: 'OTHER',
} as const;
export type ArBoletoMovementKind = (typeof ArBoletoMovementKind)[keyof typeof ArBoletoMovementKind];

export const ArPortfolioLossAnalysisLineKind = {
  LOSS_ALLOWANCE: 'LOSS_ALLOWANCE',
  WRITE_OFF: 'WRITE_OFF',
} as const;
export type ArPortfolioLossAnalysisLineKind =
  (typeof ArPortfolioLossAnalysisLineKind)[keyof typeof ArPortfolioLossAnalysisLineKind];

export const ArRecognitionCalculationKind = {
  CALCULATION: 'CALCULATION',
  EXTERNAL_SCHEDULE: 'EXTERNAL_SCHEDULE',
} as const;
export type ArRecognitionCalculationKind =
  (typeof ArRecognitionCalculationKind)[keyof typeof ArRecognitionCalculationKind];

export const ArSettlementEventState = {
  PENDING: 'PENDING',
  INVOICED: 'INVOICED',
  EXCLUDED: 'EXCLUDED',
  SUPERSEDED: 'SUPERSEDED',
} as const;
export type ArSettlementEventState =
  (typeof ArSettlementEventState)[keyof typeof ArSettlementEventState];

export const ArSettlementFeeField = {
  PROCESSING_COMMISSION: 'PROCESSING_COMMISSION',
  SOFTWARE_FEE: 'SOFTWARE_FEE',
  INSTALLMENT_FEE: 'INSTALLMENT_FEE',
  PENALTY_COMMISSION: 'PENALTY_COMMISSION',
  CHARGEBACK_FEE: 'CHARGEBACK_FEE',
} as const;
export type ArSettlementFeeField = (typeof ArSettlementFeeField)[keyof typeof ArSettlementFeeField];

export const ArSettlementFeedProvider = {
  NEKT: 'NEKT',
} as const;
export type ArSettlementFeedProvider =
  (typeof ArSettlementFeedProvider)[keyof typeof ArSettlementFeedProvider];

export const ArSettlementCfdiConceptMode = {
  PER_SERVICE: 'PER_SERVICE',
  SINGLE_SUMMARY: 'SINGLE_SUMMARY',
} as const;
export type ArSettlementCfdiConceptMode =
  (typeof ArSettlementCfdiConceptMode)[keyof typeof ArSettlementCfdiConceptMode];

export const ArSettlementAggregateGrouping = {
  PAYOUT_ACCOUNT: 'PAYOUT_ACCOUNT',
  CUSTOMER_CURRENCY: 'CUSTOMER_CURRENCY',
} as const;
export type ArSettlementAggregateGrouping =
  (typeof ArSettlementAggregateGrouping)[keyof typeof ArSettlementAggregateGrouping];

export const FixedAssetAcquisitionSource = {
  AP_BILL: 'AP_BILL',
  LEASE_ROU: 'LEASE_ROU',
  LEASEHOLD_IMPROVEMENT: 'LEASEHOLD_IMPROVEMENT',
  MANUAL: 'MANUAL',
  MIGRATION: 'MIGRATION',
} as const;
export type FixedAssetAcquisitionSource =
  (typeof FixedAssetAcquisitionSource)[keyof typeof FixedAssetAcquisitionSource];

export const FixedAssetStatus = {
  DRAFT: 'DRAFT',
  IN_SERVICE: 'IN_SERVICE',
  IN_MAINTENANCE: 'IN_MAINTENANCE',
  IDLE: 'IDLE',
  DISPOSED: 'DISPOSED',
} as const;
export type FixedAssetStatus = (typeof FixedAssetStatus)[keyof typeof FixedAssetStatus];

export const DepreciationMethod = {
  STRAIGHT_LINE: 'STRAIGHT_LINE',
  DECLINING_BALANCE: 'DECLINING_BALANCE',
  UNITS_OF_PRODUCTION: 'UNITS_OF_PRODUCTION',
  NONE: 'NONE',
} as const;
export type DepreciationMethod = (typeof DepreciationMethod)[keyof typeof DepreciationMethod];

export const FixedAssetDepreciationState = {
  ACTIVE: 'ACTIVE',
  SUSPENDED_RESIDUAL_FLOOR: 'SUSPENDED_RESIDUAL_FLOOR',
} as const;
export type FixedAssetDepreciationState =
  (typeof FixedAssetDepreciationState)[keyof typeof FixedAssetDepreciationState];

export const FixedAssetScheduleStatus = {
  PENDING: 'PENDING',
  POSTED: 'POSTED',
  REVERSED: 'REVERSED',
  CANCELLED: 'CANCELLED',
  COMPUTED: 'COMPUTED',
  ROUNDED_ZERO: 'ROUNDED_ZERO',
} as const;
export type FixedAssetScheduleStatus =
  (typeof FixedAssetScheduleStatus)[keyof typeof FixedAssetScheduleStatus];

export const FixedAssetPisCofinsCreditMethod = {
  DEPRECIATION_RFB: 'DEPRECIATION_RFB',
  IMMEDIATE_NEW_MACHINE_EQUIPMENT: 'IMMEDIATE_NEW_MACHINE_EQUIPMENT',
  QUOTA_1_48: 'QUOTA_1_48',
} as const;
export type FixedAssetPisCofinsCreditMethod =
  (typeof FixedAssetPisCofinsCreditMethod)[keyof typeof FixedAssetPisCofinsCreditMethod];

export const FixedAssetPisCofinsElectionMode = {
  INITIAL: 'INITIAL',
  CONVERSION: 'CONVERSION',
} as const;
export type FixedAssetPisCofinsElectionMode =
  (typeof FixedAssetPisCofinsElectionMode)[keyof typeof FixedAssetPisCofinsElectionMode];

export const FixedAssetPisCofinsQualifyingDestination = {
  PRODUCTION_GOODS: 'PRODUCTION_GOODS',
  SERVICE_PROVISION: 'SERVICE_PROVISION',
  RENTAL_THIRD_PARTY: 'RENTAL_THIRD_PARTY',
} as const;
export type FixedAssetPisCofinsQualifyingDestination =
  (typeof FixedAssetPisCofinsQualifyingDestination)[keyof typeof FixedAssetPisCofinsQualifyingDestination];

export const FixedAssetPisCofinsAcquisitionOrigin = {
  DOMESTIC: 'DOMESTIC',
  IMPORT: 'IMPORT',
} as const;
export type FixedAssetPisCofinsAcquisitionOrigin =
  (typeof FixedAssetPisCofinsAcquisitionOrigin)[keyof typeof FixedAssetPisCofinsAcquisitionOrigin];

export const FixedAssetPisCofinsRecoverabilityConclusion = {
  FULL_POTENTIAL_EXPECTED: 'FULL_POTENTIAL_EXPECTED',
} as const;
export type FixedAssetPisCofinsRecoverabilityConclusion =
  (typeof FixedAssetPisCofinsRecoverabilityConclusion)[keyof typeof FixedAssetPisCofinsRecoverabilityConclusion];

export const FixedAssetPisCofinsCreditAvailability = {
  DEFERRED_FIXED_ASSET: 'DEFERRED_FIXED_ASSET',
  AVAILABLE: 'AVAILABLE',
} as const;
export type FixedAssetPisCofinsCreditAvailability =
  (typeof FixedAssetPisCofinsCreditAvailability)[keyof typeof FixedAssetPisCofinsCreditAvailability];

export const FixedAssetPisCofinsInstallmentRegime = {
  PIS_COFINS: 'PIS_COFINS',
  CBS_PRESUMED_TRANSITION_PENDING: 'CBS_PRESUMED_TRANSITION_PENDING',
} as const;
export type FixedAssetPisCofinsInstallmentRegime =
  (typeof FixedAssetPisCofinsInstallmentRegime)[keyof typeof FixedAssetPisCofinsInstallmentRegime];

export const FixedAssetPisCofinsLegalTailEventType = {
  LEGAL_DISPOSAL_TAIL_DERECOGNITION: 'LEGAL_DISPOSAL_TAIL_DERECOGNITION',
} as const;
export type FixedAssetPisCofinsLegalTailEventType =
  (typeof FixedAssetPisCofinsLegalTailEventType)[keyof typeof FixedAssetPisCofinsLegalTailEventType];

export const FixedAssetPisCofinsAllowanceEventType = {
  ALLOWANCE_INCREASE: 'ALLOWANCE_INCREASE',
  ALLOWANCE_REVERSAL: 'ALLOWANCE_REVERSAL',
  ALLOWANCE_REVERSAL_ACTUAL_OFFSET: 'ALLOWANCE_REVERSAL_ACTUAL_OFFSET',
  ALLOWANCE_RECLASS_DEFERRED_TO_AVAILABLE: 'ALLOWANCE_RECLASS_DEFERRED_TO_AVAILABLE',
  ALLOWANCE_APPLIED_TO_LEGAL_DERECOGNITION: 'ALLOWANCE_APPLIED_TO_LEGAL_DERECOGNITION',
  ALLOWANCE_RECLASS_ELECTION_SUPERSESSION: 'ALLOWANCE_RECLASS_ELECTION_SUPERSESSION',
} as const;
export type FixedAssetPisCofinsAllowanceEventType =
  (typeof FixedAssetPisCofinsAllowanceEventType)[keyof typeof FixedAssetPisCofinsAllowanceEventType];

export const FixedAssetPisCofinsAllowanceOwnerType = {
  INSTALLMENT: 'INSTALLMENT',
  ENTITLEMENT: 'ENTITLEMENT',
} as const;
export type FixedAssetPisCofinsAllowanceOwnerType =
  (typeof FixedAssetPisCofinsAllowanceOwnerType)[keyof typeof FixedAssetPisCofinsAllowanceOwnerType];

export const FixedAssetPisCofinsCommonUseExclusionEventType = {
  COMMON_USE_EXCLUSION: 'COMMON_USE_EXCLUSION',
  COMMON_USE_EXCLUSION_REVERSAL: 'COMMON_USE_EXCLUSION_REVERSAL',
} as const;
export type FixedAssetPisCofinsCommonUseExclusionEventType =
  (typeof FixedAssetPisCofinsCommonUseExclusionEventType)[keyof typeof FixedAssetPisCofinsCommonUseExclusionEventType];

export const FixedAssetCommonUseScheduleLinkRole = {
  SUPERSEDED: 'SUPERSEDED',
  REPLACEMENT: 'REPLACEMENT',
} as const;
export type FixedAssetCommonUseScheduleLinkRole =
  (typeof FixedAssetCommonUseScheduleLinkRole)[keyof typeof FixedAssetCommonUseScheduleLinkRole];

export const FixedAssetCommonUseOwnerAccountingTreatment = {
  CURRENT_PERIOD_NEW_LEGAL_FACT: 'CURRENT_PERIOD_NEW_LEGAL_FACT',
  CURRENT_REPORTING_PERIOD_ERROR: 'CURRENT_REPORTING_PERIOD_ERROR',
} as const;
export type FixedAssetCommonUseOwnerAccountingTreatment =
  (typeof FixedAssetCommonUseOwnerAccountingTreatment)[keyof typeof FixedAssetCommonUseOwnerAccountingTreatment];

export const FixedAssetDisposalType = {
  SALE: 'SALE',
  WRITE_OFF: 'WRITE_OFF',
  LOSS: 'LOSS',
  DONATION: 'DONATION',
  LEASE_RETURN: 'LEASE_RETURN',
} as const;
export type FixedAssetDisposalType =
  (typeof FixedAssetDisposalType)[keyof typeof FixedAssetDisposalType];

export const FixedAssetGroup = {
  PROPERTY_PLANT_EQUIPMENT: 'PROPERTY_PLANT_EQUIPMENT',
  RIGHT_OF_USE: 'RIGHT_OF_USE',
  INTANGIBLE: 'INTANGIBLE',
} as const;
export type FixedAssetGroup = (typeof FixedAssetGroup)[keyof typeof FixedAssetGroup];

export const AssetUnitizationPolicy = {
  PER_UNIT: 'PER_UNIT',
  AGGREGATE: 'AGGREGATE',
  ASK: 'ASK',
} as const;
export type AssetUnitizationPolicy =
  (typeof AssetUnitizationPolicy)[keyof typeof AssetUnitizationPolicy];

export const AssetCandidateVerdict = {
  CAPITALIZE: 'CAPITALIZE',
  EXPENSE: 'EXPENSE',
  LEASE_SERVICE: 'LEASE_SERVICE',
  LEASE_ASSESSMENT_REQUIRED: 'LEASE_ASSESSMENT_REQUIRED',
  ADD_TO_PROJECT: 'ADD_TO_PROJECT',
} as const;
export type AssetCandidateVerdict =
  (typeof AssetCandidateVerdict)[keyof typeof AssetCandidateVerdict];

export const AssetCandidateRetiredReason = {
  CLASSIFICATION_RESAVED: 'CLASSIFICATION_RESAVED',
} as const;
export type AssetCandidateRetiredReason =
  (typeof AssetCandidateRetiredReason)[keyof typeof AssetCandidateRetiredReason];

export const AssetCandidateStatus = {
  PENDING: 'PENDING',
  CONFIRMED: 'CONFIRMED',
  OVERRIDDEN: 'OVERRIDDEN',
  DISCARDED: 'DISCARDED',
} as const;
export type AssetCandidateStatus = (typeof AssetCandidateStatus)[keyof typeof AssetCandidateStatus];

export const LeaseClassification = {
  RECOGNIZED: 'RECOGNIZED',
  SHORT_TERM_EXEMPT: 'SHORT_TERM_EXEMPT',
  LOW_VALUE_EXEMPT: 'LOW_VALUE_EXEMPT',
} as const;
export type LeaseClassification = (typeof LeaseClassification)[keyof typeof LeaseClassification];

export const LeaseContractStatus = {
  DRAFT: 'DRAFT',
  ACTIVE: 'ACTIVE',
  EXPIRED: 'EXPIRED',
  TERMINATED: 'TERMINATED',
} as const;
export type LeaseContractStatus = (typeof LeaseContractStatus)[keyof typeof LeaseContractStatus];

export const LeaseRecognitionMode = {
  RECOGNIZE_ROU: 'RECOGNIZE_ROU',
  EXPENSE_PAYMENTS: 'EXPENSE_PAYMENTS',
} as const;
export type LeaseRecognitionMode = (typeof LeaseRecognitionMode)[keyof typeof LeaseRecognitionMode];

export const LeaseIndexBasis = {
  FIXED: 'FIXED',
  CONTRACTUAL_STEP: 'CONTRACTUAL_STEP',
} as const;
export type LeaseIndexBasis = (typeof LeaseIndexBasis)[keyof typeof LeaseIndexBasis];

export const LeasePaymentFrequency = {
  MONTHLY: 'MONTHLY',
  BIMONTHLY: 'BIMONTHLY',
  QUARTERLY: 'QUARTERLY',
  SEMESTERLY: 'SEMESTERLY',
  YEARLY: 'YEARLY',
} as const;
export type LeasePaymentFrequency =
  (typeof LeasePaymentFrequency)[keyof typeof LeasePaymentFrequency];

export const LeaseLiabilityScheduleStatus = {
  PENDING: 'PENDING',
  SETTLED: 'SETTLED',
  REVERSED: 'REVERSED',
  CANCELLED: 'CANCELLED',
  COMPUTED: 'COMPUTED',
} as const;
export type LeaseLiabilityScheduleStatus =
  (typeof LeaseLiabilityScheduleStatus)[keyof typeof LeaseLiabilityScheduleStatus];

export const LeaseRemeasurementReason = {
  INDEX_ADJUSTMENT: 'INDEX_ADJUSTMENT',
  TERM_CHANGE: 'TERM_CHANGE',
  PAYMENT_CHANGE: 'PAYMENT_CHANGE',
  SCOPE_CHANGE: 'SCOPE_CHANGE',
  DISCOUNT_RATE_CHANGE: 'DISCOUNT_RATE_CHANGE',
  TERMINATION: 'TERMINATION',
} as const;
export type LeaseRemeasurementReason =
  (typeof LeaseRemeasurementReason)[keyof typeof LeaseRemeasurementReason];

export const LeaseRemeasurementTreatment = {
  ADJUST_ROU_ASSET: 'ADJUST_ROU_ASSET',
  RECOGNIZE_IN_PROFIT_OR_LOSS: 'RECOGNIZE_IN_PROFIT_OR_LOSS',
} as const;
export type LeaseRemeasurementTreatment =
  (typeof LeaseRemeasurementTreatment)[keyof typeof LeaseRemeasurementTreatment];

export const IntangibleProjectStatus = {
  RESEARCH: 'RESEARCH',
  DEVELOPMENT: 'DEVELOPMENT',
  IN_SERVICE: 'IN_SERVICE',
  WRITTEN_OFF: 'WRITTEN_OFF',
} as const;
export type IntangibleProjectStatus =
  (typeof IntangibleProjectStatus)[keyof typeof IntangibleProjectStatus];

export const AssetArt42ExclusionSource = {
  ENTITY_DEFAULT: 'ENTITY_DEFAULT',
  PROJECT_OVERRIDE: 'PROJECT_OVERRIDE',
} as const;
export type AssetArt42ExclusionSource =
  (typeof AssetArt42ExclusionSource)[keyof typeof AssetArt42ExclusionSource];

export const IntangibleProjectCostSourceType = {
  PAYROLL_ALLOCATION: 'PAYROLL_ALLOCATION',
  PJ_BILL_LINE: 'PJ_BILL_LINE',
  AP_BILL_LINE: 'AP_BILL_LINE',
} as const;
export type IntangibleProjectCostSourceType =
  (typeof IntangibleProjectCostSourceType)[keyof typeof IntangibleProjectCostSourceType];

export const IntangibleAllocationPersonType = {
  EMPLOYEE: 'EMPLOYEE',
  COLLABORATOR: 'COLLABORATOR',
} as const;
export type IntangibleAllocationPersonType =
  (typeof IntangibleAllocationPersonType)[keyof typeof IntangibleAllocationPersonType];

export const IntangibleFiscalMemoKind = {
  EXCLUSION: 'EXCLUSION',
  ADDITION: 'ADDITION',
} as const;
export type IntangibleFiscalMemoKind =
  (typeof IntangibleFiscalMemoKind)[keyof typeof IntangibleFiscalMemoKind];

export const FixedAssetBookRuleRevisionScheduleRole = {
  SUPERSEDED: 'SUPERSEDED',
  REPLACEMENT: 'REPLACEMENT',
} as const;
export type FixedAssetBookRuleRevisionScheduleRole =
  (typeof FixedAssetBookRuleRevisionScheduleRole)[keyof typeof FixedAssetBookRuleRevisionScheduleRole];

export const ServiceCalculationMode = {
  PER_UNIT: 'PER_UNIT',
  GRADUATED: 'GRADUATED',
  VOLUME: 'VOLUME',
  STAIRSTEP: 'STAIRSTEP',
  PERCENT_OF_GTV: 'PERCENT_OF_GTV',
} as const;
export type ServiceCalculationMode =
  (typeof ServiceCalculationMode)[keyof typeof ServiceCalculationMode];

export const BillingTiming = {
  ADVANCE: 'ADVANCE',
  ARREARS: 'ARREARS',
} as const;
export type BillingTiming = (typeof BillingTiming)[keyof typeof BillingTiming];

export const RevenueRecognitionMethod = {
  POINT_IN_TIME_AT_DELIVERY: 'POINT_IN_TIME_AT_DELIVERY',
  STRAIGHT_LINE_OVER_TIME: 'STRAIGHT_LINE_OVER_TIME',
  USAGE_AS_CONSUMED: 'USAGE_AS_CONSUMED',
  PROGRESS_MILESTONES: 'PROGRESS_MILESTONES',
} as const;
export type RevenueRecognitionMethod =
  (typeof RevenueRecognitionMethod)[keyof typeof RevenueRecognitionMethod];

export const RevenueRecognitionModel = {
  ON_FISCAL_DOCUMENT: 'ON_FISCAL_DOCUMENT',
  ON_SETTLEMENT: 'ON_SETTLEMENT',
} as const;
export type RevenueRecognitionModel =
  (typeof RevenueRecognitionModel)[keyof typeof RevenueRecognitionModel];

export const ServiceInvoicing = {
  INDIVIDUAL: 'INDIVIDUAL',
  PERIOD_AGGREGATE: 'PERIOD_AGGREGATE',
} as const;
export type ServiceInvoicing = (typeof ServiceInvoicing)[keyof typeof ServiceInvoicing];

export const SettlementModel = {
  DIRECT: 'DIRECT',
  CUSTODIAL: 'CUSTODIAL',
} as const;
export type SettlementModel = (typeof SettlementModel)[keyof typeof SettlementModel];

export const BillingMode = {
  RECURRING: 'RECURRING',
  ONE_TIME: 'ONE_TIME',
} as const;
export type BillingMode = (typeof BillingMode)[keyof typeof BillingMode];

export const BillingServiceStatus = {
  DRAFT: 'DRAFT',
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
} as const;
export type BillingServiceStatus = (typeof BillingServiceStatus)[keyof typeof BillingServiceStatus];

export const NfseIssTaxation = {
  TAXABLE: 'TAXABLE',
  IMMUNITY: 'IMMUNITY',
  EXPORT: 'EXPORT',
  NON_INCIDENCE: 'NON_INCIDENCE',
} as const;
export type NfseIssTaxation = (typeof NfseIssTaxation)[keyof typeof NfseIssTaxation];

export const BillingFrequency = {
  MONTHLY: 'MONTHLY',
  QUARTERLY: 'QUARTERLY',
  SEMIANNUAL: 'SEMIANNUAL',
  ANNUAL: 'ANNUAL',
} as const;
export type BillingFrequency = (typeof BillingFrequency)[keyof typeof BillingFrequency];

export const BillingDayAnchor = {
  FIXED_DAY: 'FIXED_DAY',
  LAST_DAY: 'LAST_DAY',
  LAST_BUSINESS_DAY: 'LAST_BUSINESS_DAY',
} as const;
export type BillingDayAnchor = (typeof BillingDayAnchor)[keyof typeof BillingDayAnchor];

export const RenewalAdjustmentType = {
  NONE: 'NONE',
  FIXED_PERCENTAGE: 'FIXED_PERCENTAGE',
  INDEX_BASED: 'INDEX_BASED',
} as const;
export type RenewalAdjustmentType =
  (typeof RenewalAdjustmentType)[keyof typeof RenewalAdjustmentType];

export const RenewalCalculationStatus = {
  COMPUTED: 'COMPUTED',
  BLOCKED: 'BLOCKED',
} as const;
export type RenewalCalculationStatus =
  (typeof RenewalCalculationStatus)[keyof typeof RenewalCalculationStatus];

export const PaymentMethod = {
  BOLEPIX: 'BOLEPIX',
  BOLETO: 'BOLETO',
  PIX: 'PIX',
  TRANSFER: 'TRANSFER',
} as const;
export type PaymentMethod = (typeof PaymentMethod)[keyof typeof PaymentMethod];

export const CustomerBalanceType = {
  CREDIT: 'CREDIT',
  DEBIT: 'DEBIT',
} as const;
export type CustomerBalanceType = (typeof CustomerBalanceType)[keyof typeof CustomerBalanceType];

export const CustomerBalanceReason = {
  COMMERCIAL_DISCOUNT: 'COMMERCIAL_DISCOUNT',
  OVERPAYMENT: 'OVERPAYMENT',
  CREDIT_NOTE: 'CREDIT_NOTE',
  GOODWILL: 'GOODWILL',
  PENALTY: 'PENALTY',
  UNBILLED_CHARGE: 'UNBILLED_CHARGE',
  CARRY_FORWARD: 'CARRY_FORWARD',
  OTHER: 'OTHER',
} as const;
export type CustomerBalanceReason =
  (typeof CustomerBalanceReason)[keyof typeof CustomerBalanceReason];

export const CustomerBalanceStatus = {
  AVAILABLE: 'AVAILABLE',
  PARTIALLY_CONSUMED: 'PARTIALLY_CONSUMED',
  CONSUMED: 'CONSUMED',
  EXPIRED: 'EXPIRED',
  CANCELLED: 'CANCELLED',
} as const;
export type CustomerBalanceStatus =
  (typeof CustomerBalanceStatus)[keyof typeof CustomerBalanceStatus];

export const CustomerEmailRole = {
  FINANCIAL: 'FINANCIAL',
  GENERAL: 'GENERAL',
  ACCOUNTING: 'ACCOUNTING',
  NFE_RECIPIENT: 'NFE_RECIPIENT',
} as const;
export type CustomerEmailRole = (typeof CustomerEmailRole)[keyof typeof CustomerEmailRole];

export const BillingContractStatus = {
  DRAFT: 'DRAFT',
  ACTIVE: 'ACTIVE',
  SUSPENDED: 'SUSPENDED',
  CANCELLED: 'CANCELLED',
  EXPIRED: 'EXPIRED',
} as const;
export type BillingContractStatus =
  (typeof BillingContractStatus)[keyof typeof BillingContractStatus];

export const ContractItemServicePeriodRule = {
  CALENDAR_MONTH: 'CALENDAR_MONTH',
  ANNIVERSARY_DATE: 'ANNIVERSARY_DATE',
} as const;
export type ContractItemServicePeriodRule =
  (typeof ContractItemServicePeriodRule)[keyof typeof ContractItemServicePeriodRule];

export const BillingContractAmendmentType = {
  UPSELL: 'UPSELL',
  DOWNGRADE: 'DOWNGRADE',
  SUSPENSION: 'SUSPENSION',
  CANCELLATION: 'CANCELLATION',
  RENEWAL: 'RENEWAL',
} as const;
export type BillingContractAmendmentType =
  (typeof BillingContractAmendmentType)[keyof typeof BillingContractAmendmentType];

export const BillingContractAmendmentStatus = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
} as const;
export type BillingContractAmendmentStatus =
  (typeof BillingContractAmendmentStatus)[keyof typeof BillingContractAmendmentStatus];

export const ContractBillingCycleStatus = {
  GENERATED: 'GENERATED',
  BLOCKED: 'BLOCKED',
} as const;
export type ContractBillingCycleStatus =
  (typeof ContractBillingCycleStatus)[keyof typeof ContractBillingCycleStatus];

export const UsageRecordSource = {
  MANUAL: 'MANUAL',
  CSV: 'CSV',
  API: 'API',
} as const;
export type UsageRecordSource = (typeof UsageRecordSource)[keyof typeof UsageRecordSource];

export const UsageRecordStatus = {
  OPEN: 'OPEN',
  FINALIZED: 'FINALIZED',
  SUPERSEDED: 'SUPERSEDED',
} as const;
export type UsageRecordStatus = (typeof UsageRecordStatus)[keyof typeof UsageRecordStatus];

export const BillingServiceNfIssuer = {
  ALCHEMY: 'ALCHEMY',
  EXTERNAL: 'EXTERNAL',
} as const;
export type BillingServiceNfIssuer =
  (typeof BillingServiceNfIssuer)[keyof typeof BillingServiceNfIssuer];

export const RevenueCycleNfTrigger = {
  ON_APPROVAL: 'ON_APPROVAL',
  AFTER_RECEIPT: 'AFTER_RECEIPT',
} as const;
export type RevenueCycleNfTrigger =
  (typeof RevenueCycleNfTrigger)[keyof typeof RevenueCycleNfTrigger];

export const RevenueCycleSource = {
  CONTRACT: 'CONTRACT',
  TEMPLATE: 'TEMPLATE',
  SYSTEM: 'SYSTEM',
} as const;
export type RevenueCycleSource = (typeof RevenueCycleSource)[keyof typeof RevenueCycleSource];

export const ContractBillingInvoiceDiffType = {
  LINE_AMOUNT_CHANGED: 'LINE_AMOUNT_CHANGED',
  LINE_ADDED: 'LINE_ADDED',
  LINE_REMOVED: 'LINE_REMOVED',
} as const;
export type ContractBillingInvoiceDiffType =
  (typeof ContractBillingInvoiceDiffType)[keyof typeof ContractBillingInvoiceDiffType];

export const ContractBillingInvoiceDiffDecision = {
  PENDING: 'PENDING',
  APPLIED: 'APPLIED',
  DEFERRED: 'DEFERRED',
} as const;
export type ContractBillingInvoiceDiffDecision =
  (typeof ContractBillingInvoiceDiffDecision)[keyof typeof ContractBillingInvoiceDiffDecision];

export const ContractMilestoneStatus = {
  PENDING: 'PENDING',
  READY_TO_BILL: 'READY_TO_BILL',
  BLOCKED: 'BLOCKED',
  BILLED: 'BILLED',
  CANCELLED: 'CANCELLED',
} as const;
export type ContractMilestoneStatus =
  (typeof ContractMilestoneStatus)[keyof typeof ContractMilestoneStatus];

export const ContractRevenueScheduleStatus = {
  ACTIVE: 'ACTIVE',
  SUPERSEDED: 'SUPERSEDED',
  CANCELLED: 'CANCELLED',
} as const;
export type ContractRevenueScheduleStatus =
  (typeof ContractRevenueScheduleStatus)[keyof typeof ContractRevenueScheduleStatus];

export const ContractRevenueScheduleEntryStatus = {
  PENDING: 'PENDING',
  POSTED: 'POSTED',
  REVERSED: 'REVERSED',
  CANCELLED: 'CANCELLED',
} as const;
export type ContractRevenueScheduleEntryStatus =
  (typeof ContractRevenueScheduleEntryStatus)[keyof typeof ContractRevenueScheduleEntryStatus];

export const ContractRevenueScheduleDirection = {
  ADVANCE_LIABILITY: 'ADVANCE_LIABILITY',
  USAGE_ASSET: 'USAGE_ASSET',
} as const;
export type ContractRevenueScheduleDirection =
  (typeof ContractRevenueScheduleDirection)[keyof typeof ContractRevenueScheduleDirection];

export const ContractRevenueScheduleExceptionStatus = {
  OPEN: 'OPEN',
  RESOLVED: 'RESOLVED',
} as const;
export type ContractRevenueScheduleExceptionStatus =
  (typeof ContractRevenueScheduleExceptionStatus)[keyof typeof ContractRevenueScheduleExceptionStatus];

export const ContractRecognitionEvidenceKind = {
  DELIVERY_ACCEPTANCE: 'DELIVERY_ACCEPTANCE',
  MILESTONE_COMPLETION: 'MILESTONE_COMPLETION',
} as const;
export type ContractRecognitionEvidenceKind =
  (typeof ContractRecognitionEvidenceKind)[keyof typeof ContractRecognitionEvidenceKind];

export const BudgetDimensionType = {
  COST_CENTER: 'COST_CENTER',
  DEPARTMENT: 'DEPARTMENT',
  COMPANY: 'COMPANY',
} as const;
export type BudgetDimensionType = (typeof BudgetDimensionType)[keyof typeof BudgetDimensionType];

export const BudgetEnforcementMode = {
  HARD_BLOCK: 'HARD_BLOCK',
  SOFT_BLOCK: 'SOFT_BLOCK',
  ALERT_ONLY: 'ALERT_ONLY',
} as const;
export type BudgetEnforcementMode =
  (typeof BudgetEnforcementMode)[keyof typeof BudgetEnforcementMode];

export const BudgetStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  ARCHIVED: 'ARCHIVED',
} as const;
export type BudgetStatus = (typeof BudgetStatus)[keyof typeof BudgetStatus];

export const BudgetPlanStatus = {
  DRAFT: 'DRAFT',
  ACTIVE: 'ACTIVE',
  ARCHIVED: 'ARCHIVED',
  SUPERSEDED: 'SUPERSEDED',
} as const;
export type BudgetPlanStatus = (typeof BudgetPlanStatus)[keyof typeof BudgetPlanStatus];

export const BudgetVersionKind = {
  ORIGINAL: 'ORIGINAL',
  REVISION: 'REVISION',
} as const;
export type BudgetVersionKind = (typeof BudgetVersionKind)[keyof typeof BudgetVersionKind];

export const BudgetExceptionStatus = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
} as const;
export type BudgetExceptionStatus =
  (typeof BudgetExceptionStatus)[keyof typeof BudgetExceptionStatus];

export const BudgetExceptionRequestType = {
  EXCEPTION: 'EXCEPTION',
  LIMIT_INCREASE: 'LIMIT_INCREASE',
} as const;
export type BudgetExceptionRequestType =
  (typeof BudgetExceptionRequestType)[keyof typeof BudgetExceptionRequestType];

export const BudgetExceptionResolutionType = {
  EXCEPTION: 'EXCEPTION',
  LIMIT_INCREASE: 'LIMIT_INCREASE',
} as const;
export type BudgetExceptionResolutionType =
  (typeof BudgetExceptionResolutionType)[keyof typeof BudgetExceptionResolutionType];

export const BudgetCommitmentSource = {
  PURCHASE_REQUEST: 'PURCHASE_REQUEST',
  PURCHASE_ORDER: 'PURCHASE_ORDER',
  RECURRING_BILL: 'RECURRING_BILL',
  BUDGET_EXCEPTION: 'BUDGET_EXCEPTION',
} as const;
export type BudgetCommitmentSource =
  (typeof BudgetCommitmentSource)[keyof typeof BudgetCommitmentSource];

export const BudgetCommitmentStatus = {
  OPEN: 'OPEN',
  PARTIALLY_SETTLED: 'PARTIALLY_SETTLED',
  SETTLED: 'SETTLED',
  CANCELLED: 'CANCELLED',
  EXPIRED: 'EXPIRED',
} as const;
export type BudgetCommitmentStatus =
  (typeof BudgetCommitmentStatus)[keyof typeof BudgetCommitmentStatus];

export const BudgetEntryType = {
  REALIZED: 'REALIZED',
  COMMITTED: 'COMMITTED',
} as const;
export type BudgetEntryType = (typeof BudgetEntryType)[keyof typeof BudgetEntryType];

export const BudgetEntrySource = {
  PURCHASE_ORDER: 'PURCHASE_ORDER',
  RECURRING_BILL: 'RECURRING_BILL',
  PURCHASE_REQUEST: 'PURCHASE_REQUEST',
  BUDGET_EXCEPTION: 'BUDGET_EXCEPTION',
  BILL: 'BILL',
  BILL_DEFERRAL: 'BILL_DEFERRAL',
} as const;
export type BudgetEntrySource = (typeof BudgetEntrySource)[keyof typeof BudgetEntrySource];

export const BudgetEntryStatus = {
  OPEN: 'OPEN',
  PARTIALLY_SETTLED: 'PARTIALLY_SETTLED',
  CLEARED: 'CLEARED',
  CANCELLED: 'CANCELLED',
  REVERSED: 'REVERSED',
  EXPIRED: 'EXPIRED',
} as const;
export type BudgetEntryStatus = (typeof BudgetEntryStatus)[keyof typeof BudgetEntryStatus];

export const BudgetAlertTier = {
  NONE: 'NONE',
  WARNING: 'WARNING',
  CRITICAL: 'CRITICAL',
} as const;
export type BudgetAlertTier = (typeof BudgetAlertTier)[keyof typeof BudgetAlertTier];

export const BudgetRecomputeStatus = {
  PENDING: 'PENDING',
  RUNNING: 'RUNNING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
} as const;
export type BudgetRecomputeStatus =
  (typeof BudgetRecomputeStatus)[keyof typeof BudgetRecomputeStatus];

export const BudgetHistoryEntityType = {
  BUDGET: 'BUDGET',
  BUDGET_LINE: 'BUDGET_LINE',
} as const;
export type BudgetHistoryEntityType =
  (typeof BudgetHistoryEntityType)[keyof typeof BudgetHistoryEntityType];

export const BudgetHistoryAction = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  ARCHIVE: 'ARCHIVE',
  ACTIVATE: 'ACTIVATE',
  DUPLICATE: 'DUPLICATE',
  CREATE_REVISION: 'CREATE_REVISION',
  PROMOTE_REVISION: 'PROMOTE_REVISION',
  BULK_UPDATE: 'BULK_UPDATE',
  BULK_ARCHIVE: 'BULK_ARCHIVE',
} as const;
export type BudgetHistoryAction = (typeof BudgetHistoryAction)[keyof typeof BudgetHistoryAction];

export const CfConfidenceTier = {
  REALIZED: 'REALIZED',
  COMMITTED: 'COMMITTED',
  FORECAST_AI: 'FORECAST_AI',
  PLANNED: 'PLANNED',
} as const;
export type CfConfidenceTier = (typeof CfConfidenceTier)[keyof typeof CfConfidenceTier];

export const CfDirection = {
  INFLOW: 'INFLOW',
  OUTFLOW: 'OUTFLOW',
} as const;
export type CfDirection = (typeof CfDirection)[keyof typeof CfDirection];

export const CfCpc03Group = {
  OPERACIONAL: 'OPERACIONAL',
  INVESTIMENTO: 'INVESTIMENTO',
  FINANCIAMENTO: 'FINANCIAMENTO',
} as const;
export type CfCpc03Group = (typeof CfCpc03Group)[keyof typeof CfCpc03Group];

export const ClaraEntityConfigStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  ERROR: 'ERROR',
} as const;
export type ClaraEntityConfigStatus =
  (typeof ClaraEntityConfigStatus)[keyof typeof ClaraEntityConfigStatus];

export const CnabFileType = {
  REMESSA: 'REMESSA',
  RETORNO: 'RETORNO',
} as const;
export type CnabFileType = (typeof CnabFileType)[keyof typeof CnabFileType];

export const CnabFileStatus = {
  GENERATED: 'GENERATED',
  SENT: 'SENT',
  PROCESSED: 'PROCESSED',
  REJECTED: 'REJECTED',
  CANCELLED: 'CANCELLED',
} as const;
export type CnabFileStatus = (typeof CnabFileStatus)[keyof typeof CnabFileStatus];

export const CnabOriginReassignmentStatus = {
  PENDING: 'PENDING',
  COMMITTED: 'COMMITTED',
  REVERTED: 'REVERTED',
  REVERT_FAILED: 'REVERT_FAILED',
} as const;
export type CnabOriginReassignmentStatus =
  (typeof CnabOriginReassignmentStatus)[keyof typeof CnabOriginReassignmentStatus];

export const ContractReviewStatus = {
  DRAFT: 'DRAFT',
  PENDING_INTAKE_ACK: 'PENDING_INTAKE_ACK',
  AI_PROCESSING: 'AI_PROCESSING',
  READY_FOR_REVIEW: 'READY_FOR_REVIEW',
  IN_REVIEWER_TRIAGE: 'IN_REVIEWER_TRIAGE',
  AWAITING_VENDOR: 'AWAITING_VENDOR',
  AWAITING_SIGNING: 'AWAITING_SIGNING',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
  FAILED: 'FAILED',
} as const;
export type ContractReviewStatus = (typeof ContractReviewStatus)[keyof typeof ContractReviewStatus];

export const ContractReviewPartyType = {
  VENDOR: 'VENDOR',
  PROSPECT: 'PROSPECT',
} as const;
export type ContractReviewPartyType =
  (typeof ContractReviewPartyType)[keyof typeof ContractReviewPartyType];

export const ContractReviewVersionStatus = {
  ACTIVE: 'ACTIVE',
  DEPRECATED: 'DEPRECATED',
  ARCHIVED: 'ARCHIVED',
  EDITING: 'EDITING',
} as const;
export type ContractReviewVersionStatus =
  (typeof ContractReviewVersionStatus)[keyof typeof ContractReviewVersionStatus];

export const ContractReviewVersionSource = {
  INITIAL_INTAKE: 'INITIAL_INTAKE',
  REVIEWER_REDLINE: 'REVIEWER_REDLINE',
  VENDOR_RESUBMISSION: 'VENDOR_RESUBMISSION',
  AI_GENERATED: 'AI_GENERATED',
} as const;
export type ContractReviewVersionSource =
  (typeof ContractReviewVersionSource)[keyof typeof ContractReviewVersionSource];

export const ContractReviewFlagSeverity = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
  CRITICAL: 'CRITICAL',
} as const;
export type ContractReviewFlagSeverity =
  (typeof ContractReviewFlagSeverity)[keyof typeof ContractReviewFlagSeverity];

export const ContractReviewFlagCategory = {
  LEGAL: 'LEGAL',
  BUSINESS: 'BUSINESS',
  COMPLIANCE: 'COMPLIANCE',
  VENDOR_VALIDATION: 'VENDOR_VALIDATION',
  OTHER: 'OTHER',
} as const;
export type ContractReviewFlagCategory =
  (typeof ContractReviewFlagCategory)[keyof typeof ContractReviewFlagCategory];

export const ContractReviewFlagDecision = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  RESOLVED: 'RESOLVED',
} as const;
export type ContractReviewFlagDecision =
  (typeof ContractReviewFlagDecision)[keyof typeof ContractReviewFlagDecision];

export const ContractReviewFlagSource = {
  AGENT_LEGAL: 'AGENT_LEGAL',
  AGENT_BUSINESS_RISK: 'AGENT_BUSINESS_RISK',
  AGENT_VENDOR_VALIDATION: 'AGENT_VENDOR_VALIDATION',
  REVIEWER: 'REVIEWER',
} as const;
export type ContractReviewFlagSource =
  (typeof ContractReviewFlagSource)[keyof typeof ContractReviewFlagSource];

export const ContractReviewExternalTokenScope = {
  STATUS_VIEW: 'STATUS_VIEW',
  DOWNLOAD_VERSION: 'DOWNLOAD_VERSION',
  UPLOAD_VERSION: 'UPLOAD_VERSION',
} as const;
export type ContractReviewExternalTokenScope =
  (typeof ContractReviewExternalTokenScope)[keyof typeof ContractReviewExternalTokenScope];

export const CostServiceStatus = {
  DRAFT: 'DRAFT',
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
} as const;
export type CostServiceStatus = (typeof CostServiceStatus)[keyof typeof CostServiceStatus];

export const CostComponentBaseType = {
  PERCENT_OF_REVENUE: 'PERCENT_OF_REVENUE',
  FIXED_PER_CONTRACT: 'FIXED_PER_CONTRACT',
  FIXED_PER_MONTH: 'FIXED_PER_MONTH',
} as const;
export type CostComponentBaseType =
  (typeof CostComponentBaseType)[keyof typeof CostComponentBaseType];

export const CostServiceTrigger = {
  SCHEDULE: 'SCHEDULE',
  INVOICE_ISSUED: 'INVOICE_ISSUED',
  SETTLEMENT_APPROVED: 'SETTLEMENT_APPROVED',
} as const;
export type CostServiceTrigger = (typeof CostServiceTrigger)[keyof typeof CostServiceTrigger];

export const CostRecognitionPostingState = {
  PENDING: 'PENDING',
  POSTED: 'POSTED',
} as const;
export type CostRecognitionPostingState =
  (typeof CostRecognitionPostingState)[keyof typeof CostRecognitionPostingState];

export const CostMatchSource = {
  SUGGESTED: 'SUGGESTED',
  AUTO: 'AUTO',
  MANUAL: 'MANUAL',
  MCP: 'MCP',
  AUTO_FIFO: 'AUTO_FIFO',
} as const;
export type CostMatchSource = (typeof CostMatchSource)[keyof typeof CostMatchSource];

export const EconomicIndexFrequency = {
  MONTHLY: 'MONTHLY',
  DAILY: 'DAILY',
} as const;
export type EconomicIndexFrequency =
  (typeof EconomicIndexFrequency)[keyof typeof EconomicIndexFrequency];

export const EconomicIndexCompounding = {
  MONTHLY_VARIATION: 'MONTHLY_VARIATION',
  DAILY_BUSINESS_RATE: 'DAILY_BUSINESS_RATE',
} as const;
export type EconomicIndexCompounding =
  (typeof EconomicIndexCompounding)[keyof typeof EconomicIndexCompounding];

export const EconomicIndexObservationSource = {
  BCB_SGS: 'BCB_SGS',
} as const;
export type EconomicIndexObservationSource =
  (typeof EconomicIndexObservationSource)[keyof typeof EconomicIndexObservationSource];

export const WithholdingTaxType = {
  IRRF: 'IRRF',
  PIS: 'PIS',
  COFINS: 'COFINS',
  CSLL: 'CSLL',
  ISS: 'ISS',
  INSS: 'INSS',
  CBS: 'CBS',
  IBS: 'IBS',
} as const;
export type WithholdingTaxType = (typeof WithholdingTaxType)[keyof typeof WithholdingTaxType];

export const AccumulationType = {
  NONE: 'NONE',
  MONTHLY: 'MONTHLY',
  BIWEEKLY: 'BIWEEKLY',
} as const;
export type AccumulationType = (typeof AccumulationType)[keyof typeof AccumulationType];

export const CalculationBase = {
  TOTAL_VALUE: 'TOTAL_VALUE',
  SERVICE_VALUE: 'SERVICE_VALUE',
  LABOR_VALUE: 'LABOR_VALUE',
  NET_VALUE: 'NET_VALUE',
  GROSS_LESS_MATERIALS: 'GROSS_LESS_MATERIALS',
} as const;
export type CalculationBase = (typeof CalculationBase)[keyof typeof CalculationBase];

export const IrrfNature = {
  PROFESSIONAL_1_5: 'PROFESSIONAL_1_5',
  COMMISSION_1_5: 'COMMISSION_1_5',
  CLEANING_SECURITY_1_0: 'CLEANING_SECURITY_1_0',
  NONE: 'NONE',
} as const;
export type IrrfNature = (typeof IrrfNature)[keyof typeof IrrfNature];

export const IssRateSource = {
  MUNICIPAL_LOOKUP: 'MUNICIPAL_LOOKUP',
  DEFAULT_RATE: 'DEFAULT_RATE',
  ASK_USER: 'ASK_USER',
} as const;
export type IssRateSource = (typeof IssRateSource)[keyof typeof IssRateSource];

export const FiscalServiceCategory = {
  PROFESSIONAL_SERVICES: 'PROFESSIONAL_SERVICES',
  LABOR_PROVISION: 'LABOR_PROVISION',
  MAINTENANCE: 'MAINTENANCE',
  IT_SERVICES: 'IT_SERVICES',
  RENT_PROPERTY: 'RENT_PROPERTY',
  RENT_EQUIPMENT: 'RENT_EQUIPMENT',
  FREIGHT: 'FREIGHT',
  MARKETING: 'MARKETING',
  FINANCIAL_SERVICES: 'FINANCIAL_SERVICES',
  GOODS_RESALE: 'GOODS_RESALE',
  GOODS_CONSUMPTION: 'GOODS_CONSUMPTION',
  GOODS_FIXED_ASSET: 'GOODS_FIXED_ASSET',
  OTHER_SERVICES: 'OTHER_SERVICES',
  OTHER_GOODS: 'OTHER_GOODS',
} as const;
export type FiscalServiceCategory =
  (typeof FiscalServiceCategory)[keyof typeof FiscalServiceCategory];

export const SimplesNacionalTier = {
  TIER_1: 'TIER_1',
  TIER_2: 'TIER_2',
  TIER_3: 'TIER_3',
  TIER_4: 'TIER_4',
  TIER_5: 'TIER_5',
  TIER_6: 'TIER_6',
} as const;
export type SimplesNacionalTier = (typeof SimplesNacionalTier)[keyof typeof SimplesNacionalTier];

export const SimplesAnexo = {
  ANEXO_I: 'ANEXO_I',
  ANEXO_II: 'ANEXO_II',
  ANEXO_III: 'ANEXO_III',
  ANEXO_IV: 'ANEXO_IV',
  ANEXO_V: 'ANEXO_V',
} as const;
export type SimplesAnexo = (typeof SimplesAnexo)[keyof typeof SimplesAnexo];

export const CompanyTaxRegime = {
  SIMPLES_NACIONAL: 'SIMPLES_NACIONAL',
  LUCRO_PRESUMIDO: 'LUCRO_PRESUMIDO',
  LUCRO_REAL: 'LUCRO_REAL',
} as const;
export type CompanyTaxRegime = (typeof CompanyTaxRegime)[keyof typeof CompanyTaxRegime];

export const ConsumptionTax = {
  CBS: 'CBS',
  IBS: 'IBS',
} as const;
export type ConsumptionTax = (typeof ConsumptionTax)[keyof typeof ConsumptionTax];

export const ConsumptionTaxTreatment = {
  SIMPLES_INSIDE_DAS: 'SIMPLES_INSIDE_DAS',
  SIMPLES_REGULAR_OPTION: 'SIMPLES_REGULAR_OPTION',
  REGULAR: 'REGULAR',
  SIMPLES_SUBLIMIT_EXCEEDED: 'SIMPLES_SUBLIMIT_EXCEEDED',
  OUT_OF_SCOPE: 'OUT_OF_SCOPE',
} as const;
export type ConsumptionTaxTreatment =
  (typeof ConsumptionTaxTreatment)[keyof typeof ConsumptionTaxTreatment];

export const ConsumptionOptionEventType = {
  REQUESTED: 'REQUESTED',
  GRANTED: 'GRANTED',
  RENOUNCED: 'RENOUNCED',
  WITHDRAWN: 'WITHDRAWN',
} as const;
export type ConsumptionOptionEventType =
  (typeof ConsumptionOptionEventType)[keyof typeof ConsumptionOptionEventType];

export const PisCofinsRegime = {
  CUMULATIVE: 'CUMULATIVE',
  NON_CUMULATIVE: 'NON_CUMULATIVE',
} as const;
export type PisCofinsRegime = (typeof PisCofinsRegime)[keyof typeof PisCofinsRegime];

export const TaxpayerFiscalHistorySource = {
  LEGACY_CONFIG_BACKFILL: 'LEGACY_CONFIG_BACKFILL',
  MANUAL_SETUP: 'MANUAL_SETUP',
  SYSTEM_SEED: 'SYSTEM_SEED',
} as const;
export type TaxpayerFiscalHistorySource =
  (typeof TaxpayerFiscalHistorySource)[keyof typeof TaxpayerFiscalHistorySource];

export const FiscalObligationLevel = {
  FEDERAL: 'FEDERAL',
  MUNICIPAL: 'MUNICIPAL',
} as const;
export type FiscalObligationLevel =
  (typeof FiscalObligationLevel)[keyof typeof FiscalObligationLevel];

export const FiscalObligationPeriodicity = {
  MONTHLY: 'MONTHLY',
  QUARTERLY: 'QUARTERLY',
  SEMIANNUAL: 'SEMIANNUAL',
  ANNUAL: 'ANNUAL',
  EVENT: 'EVENT',
} as const;
export type FiscalObligationPeriodicity =
  (typeof FiscalObligationPeriodicity)[keyof typeof FiscalObligationPeriodicity];

export const ObligationApplicabilityState = {
  APPLICABLE: 'APPLICABLE',
  WAIVED_WITH_BASIS: 'WAIVED_WITH_BASIS',
  PENDING_CLASSIFICATION: 'PENDING_CLASSIFICATION',
  OUT_OF_SCOPE_FLAGGED: 'OUT_OF_SCOPE_FLAGGED',
} as const;
export type ObligationApplicabilityState =
  (typeof ObligationApplicabilityState)[keyof typeof ObligationApplicabilityState];

export const ObligationApplicabilityOrigin = {
  MANUAL: 'MANUAL',
  SUGGESTION_ACCEPTED: 'SUGGESTION_ACCEPTED',
  SCREENING: 'SCREENING',
  BACKFILL: 'BACKFILL',
} as const;
export type ObligationApplicabilityOrigin =
  (typeof ObligationApplicabilityOrigin)[keyof typeof ObligationApplicabilityOrigin];

export const ObligationScopeType = {
  TAXPAYER: 'TAXPAYER',
  ENTITY: 'ENTITY',
} as const;
export type ObligationScopeType = (typeof ObligationScopeType)[keyof typeof ObligationScopeType];

export const FiscalChannelPartner = {
  FOCUS: 'FOCUS',
  TECNOSPEED: 'TECNOSPEED',
  SERPRO: 'SERPRO',
  RTC: 'RTC',
} as const;
export type FiscalChannelPartner = (typeof FiscalChannelPartner)[keyof typeof FiscalChannelPartner];

export const FiscalChannelEnvironment = {
  PRODUCTION: 'PRODUCTION',
  HOMOLOGATION: 'HOMOLOGATION',
} as const;
export type FiscalChannelEnvironment =
  (typeof FiscalChannelEnvironment)[keyof typeof FiscalChannelEnvironment];

export const FiscalChannelCredentialKind = {
  FOCUS_ENTITY_CONFIG: 'FOCUS_ENTITY_CONFIG',
  TECNOSPEED_PAYER_CONFIG: 'TECNOSPEED_PAYER_CONFIG',
  NONE: 'NONE',
} as const;
export type FiscalChannelCredentialKind =
  (typeof FiscalChannelCredentialKind)[keyof typeof FiscalChannelCredentialKind];

export const OfficialMailboxKind = {
  RFB_DTE: 'RFB_DTE',
  CBS_DTE: 'CBS_DTE',
  MUNICIPAL: 'MUNICIPAL',
} as const;
export type OfficialMailboxKind = (typeof OfficialMailboxKind)[keyof typeof OfficialMailboxKind];

export const MailboxDeadlineDayType = {
  CALENDAR: 'CALENDAR',
  BUSINESS: 'BUSINESS',
} as const;
export type MailboxDeadlineDayType =
  (typeof MailboxDeadlineDayType)[keyof typeof MailboxDeadlineDayType];

export const OfficialCommunicationStatus = {
  RECEIVED: 'RECEIVED',
  ACKNOWLEDGED: 'ACKNOWLEDGED',
  FORWARDED: 'FORWARDED',
  CLOSED: 'CLOSED',
} as const;
export type OfficialCommunicationStatus =
  (typeof OfficialCommunicationStatus)[keyof typeof OfficialCommunicationStatus];

export const OfficialCommunicationOutcome = {
  NO_ACTION_REQUIRED: 'NO_ACTION_REQUIRED',
  RESPONDED: 'RESPONDED',
  REGULARIZED: 'REGULARIZED',
  CONTESTED: 'CONTESTED',
  OTHER: 'OTHER',
} as const;
export type OfficialCommunicationOutcome =
  (typeof OfficialCommunicationOutcome)[keyof typeof OfficialCommunicationOutcome];

export const AcknowledgmentKind = {
  EXPRESS: 'EXPRESS',
  TACIT: 'TACIT',
} as const;
export type AcknowledgmentKind = (typeof AcknowledgmentKind)[keyof typeof AcknowledgmentKind];

export const ObligationResponsibleRole = {
  PREPARER: 'PREPARER',
  APPROVER: 'APPROVER',
  TRANSMITTER: 'TRANSMITTER',
  PAYER: 'PAYER',
} as const;
export type ObligationResponsibleRole =
  (typeof ObligationResponsibleRole)[keyof typeof ObligationResponsibleRole];

export const ObligationOccurrenceState = {
  AWAITING_FACTS: 'AWAITING_FACTS',
  PENDING: 'PENDING',
  PREPARED: 'PREPARED',
  VALIDATED: 'VALIDATED',
  TRANSMITTED: 'TRANSMITTED',
  ACCEPTED: 'ACCEPTED',
  RECTIFICATION_PENDING: 'RECTIFICATION_PENDING',
  CLOSED: 'CLOSED',
  NOT_APPLICABLE: 'NOT_APPLICABLE',
} as const;
export type ObligationOccurrenceState =
  (typeof ObligationOccurrenceState)[keyof typeof ObligationOccurrenceState];

export const ObligationEvidenceEnvironment = {
  PRODUCTION: 'PRODUCTION',
  RESTRICTED_PRODUCTION: 'RESTRICTED_PRODUCTION',
  SIMULATED: 'SIMULATED',
} as const;
export type ObligationEvidenceEnvironment =
  (typeof ObligationEvidenceEnvironment)[keyof typeof ObligationEvidenceEnvironment];

export const ObligationPaymentState = {
  NOT_DUE: 'NOT_DUE',
  DUE: 'DUE',
  PAID: 'PAID',
  INSTALLMENT: 'INSTALLMENT',
} as const;
export type ObligationPaymentState =
  (typeof ObligationPaymentState)[keyof typeof ObligationPaymentState];

export const ObligationOccurrenceEventKind = {
  STATE_CHANGED: 'STATE_CHANGED',
  PAYMENT_CHANGED: 'PAYMENT_CHANGED',
  EVIDENCE_RECORDED: 'EVIDENCE_RECORDED',
  RECTIFICATION_OPENED: 'RECTIFICATION_OPENED',
  DEADLINE_CHANGED: 'DEADLINE_CHANGED',
} as const;
export type ObligationOccurrenceEventKind =
  (typeof ObligationOccurrenceEventKind)[keyof typeof ObligationOccurrenceEventKind];

export const ObligationDeadlineAdjustment = {
  NONE: 'NONE',
  PREVIOUS_BUSINESS_DAY: 'PREVIOUS_BUSINESS_DAY',
  NEXT_BUSINESS_DAY: 'NEXT_BUSINESS_DAY',
} as const;
export type ObligationDeadlineAdjustment =
  (typeof ObligationDeadlineAdjustment)[keyof typeof ObligationDeadlineAdjustment];

export const ObligationDeadlineSource = {
  CATALOG: 'CATALOG',
  ENTITY_OVERRIDE: 'ENTITY_OVERRIDE',
} as const;
export type ObligationDeadlineSource =
  (typeof ObligationDeadlineSource)[keyof typeof ObligationDeadlineSource];

export const ObligationScreeningAnswer = {
  YES: 'YES',
  NO: 'NO',
} as const;
export type ObligationScreeningAnswer =
  (typeof ObligationScreeningAnswer)[keyof typeof ObligationScreeningAnswer];

export const TaxpayerFiscalRegimeChangeExceptionReason = {
  START_OF_ACTIVITY: 'START_OF_ACTIVITY',
  MANDATORY_LUCRO_REAL: 'MANDATORY_LUCRO_REAL',
  OTHER_WITH_EVIDENCE: 'OTHER_WITH_EVIDENCE',
} as const;
export type TaxpayerFiscalRegimeChangeExceptionReason =
  (typeof TaxpayerFiscalRegimeChangeExceptionReason)[keyof typeof TaxpayerFiscalRegimeChangeExceptionReason];

export const MixedRevenueCreditAppropriationMethod = {
  REVENUE_PRORATION: 'REVENUE_PRORATION',
} as const;
export type MixedRevenueCreditAppropriationMethod =
  (typeof MixedRevenueCreditAppropriationMethod)[keyof typeof MixedRevenueCreditAppropriationMethod];

export const PisCofinsCreditType = {
  BASIC: 'BASIC',
  PRESUMED: 'PRESUMED',
  IMPORT: 'IMPORT',
  FIXED_ASSET: 'FIXED_ASSET',
} as const;
export type PisCofinsCreditType = (typeof PisCofinsCreditType)[keyof typeof PisCofinsCreditType];

export const TaxJurisdiction = {
  FEDERAL: 'FEDERAL',
  ESTADUAL: 'ESTADUAL',
  MUNICIPAL: 'MUNICIPAL',
} as const;
export type TaxJurisdiction = (typeof TaxJurisdiction)[keyof typeof TaxJurisdiction];

export const TaxCategory = {
  WITHHOLDING_AP: 'WITHHOLDING_AP',
  OWN_AR: 'OWN_AR',
  PAYROLL: 'PAYROLL',
  RECOVERABLE: 'RECOVERABLE',
  DEDUCTION: 'DEDUCTION',
  TAX_EXPENSE: 'TAX_EXPENSE',
} as const;
export type TaxCategory = (typeof TaxCategory)[keyof typeof TaxCategory];

export const AccountNature = {
  DEBIT: 'DEBIT',
  CREDIT: 'CREDIT',
} as const;
export type AccountNature = (typeof AccountNature)[keyof typeof AccountNature];

export const TaxpayerBookkeepingType = {
  COMPLETE: 'COMPLETE',
  SIMPLIFIED: 'SIMPLIFIED',
} as const;
export type TaxpayerBookkeepingType =
  (typeof TaxpayerBookkeepingType)[keyof typeof TaxpayerBookkeepingType];

export const FiscalNoteDirection = {
  EMITTED: 'EMITTED',
  RECEIVED: 'RECEIVED',
} as const;
export type FiscalNoteDirection = (typeof FiscalNoteDirection)[keyof typeof FiscalNoteDirection];

export const FiscalDocumentKind = {
  INVOICE: 'INVOICE',
  CREDIT_NOTE: 'CREDIT_NOTE',
  PAYMENT: 'PAYMENT',
  TRANSFER: 'TRANSFER',
  PAYROLL: 'PAYROLL',
} as const;
export type FiscalDocumentKind = (typeof FiscalDocumentKind)[keyof typeof FiscalDocumentKind];

export const FiscalNoteDocumentType = {
  NFSE: 'NFSE',
  NFSE_NACIONAL: 'NFSE_NACIONAL',
  NFE: 'NFE',
  CFDI: 'CFDI',
} as const;
export type FiscalNoteDocumentType =
  (typeof FiscalNoteDocumentType)[keyof typeof FiscalNoteDocumentType];

export const FleetAgentMode = {
  OFF: 'OFF',
  SHADOW: 'SHADOW',
  LIVE: 'LIVE',
} as const;
export type FleetAgentMode = (typeof FleetAgentMode)[keyof typeof FleetAgentMode];

export const FleetRunStatus = {
  RUNNING: 'RUNNING',
  SUCCEEDED: 'SUCCEEDED',
  STOPPED_BUDGET: 'STOPPED_BUDGET',
  FAILED: 'FAILED',
  SKIPPED: 'SKIPPED',
} as const;
export type FleetRunStatus = (typeof FleetRunStatus)[keyof typeof FleetRunStatus];

export const FleetRunTrigger = {
  SCHEDULED: 'SCHEDULED',
  MANUAL: 'MANUAL',
} as const;
export type FleetRunTrigger = (typeof FleetRunTrigger)[keyof typeof FleetRunTrigger];

export const FleetDecisionOutcome = {
  ACTED: 'ACTED',
  PROPOSED: 'PROPOSED',
  REJECTED: 'REJECTED',
  ACT_FAILED: 'ACT_FAILED',
  ACCEPTED: 'ACCEPTED',
} as const;
export type FleetDecisionOutcome = (typeof FleetDecisionOutcome)[keyof typeof FleetDecisionOutcome];

export const FleetInboxStatus = {
  OPEN: 'OPEN',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  CLOSED: 'CLOSED',
} as const;
export type FleetInboxStatus = (typeof FleetInboxStatus)[keyof typeof FleetInboxStatus];

export const FocusNfeEntityStatus = {
  PENDING: 'PENDING',
  ACTIVE: 'ACTIVE',
  ERROR: 'ERROR',
  SUSPENDED: 'SUSPENDED',
} as const;
export type FocusNfeEntityStatus = (typeof FocusNfeEntityStatus)[keyof typeof FocusNfeEntityStatus];

export const InboxDocumentType = {
  NFE: 'NFE',
  NFSE: 'NFSE',
  NFSE_NACIONAL: 'NFSE_NACIONAL',
  CFDI: 'CFDI',
} as const;
export type InboxDocumentType = (typeof InboxDocumentType)[keyof typeof InboxDocumentType];

export const InboxDocumentStatus = {
  SUMMARY: 'SUMMARY',
  ACKNOWLEDGED: 'ACKNOWLEDGED',
  FULL_AVAILABLE: 'FULL_AVAILABLE',
  FULL_NOT_FOUND: 'FULL_NOT_FOUND',
  CANCELLED: 'CANCELLED',
} as const;
export type InboxDocumentStatus = (typeof InboxDocumentStatus)[keyof typeof InboxDocumentStatus];

export const InboxProcessingStatus = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  MATCHED: 'MATCHED',
  BILL_CREATED: 'BILL_CREATED',
  BILL_REMOVED: 'BILL_REMOVED',
  IGNORED: 'IGNORED',
  SKIPPED_CANCELLED: 'SKIPPED_CANCELLED',
} as const;
export type InboxProcessingStatus =
  (typeof InboxProcessingStatus)[keyof typeof InboxProcessingStatus];

export const InboxDirection = {
  RECEIVED: 'RECEIVED',
  EMITTED: 'EMITTED',
} as const;
export type InboxDirection = (typeof InboxDirection)[keyof typeof InboxDirection];

export const ManifestationType = {
  CIENCIA: 'CIENCIA',
  CONFIRMACAO: 'CONFIRMACAO',
  DESCONHECIMENTO: 'DESCONHECIMENTO',
  NAO_REALIZADA: 'NAO_REALIZADA',
} as const;
export type ManifestationType = (typeof ManifestationType)[keyof typeof ManifestationType];

export const FpaFonte = {
  CONTABIL: 'CONTABIL',
  GERENCIAL: 'GERENCIAL',
} as const;
export type FpaFonte = (typeof FpaFonte)[keyof typeof FpaFonte];

export const FpaRegime = {
  COMPETENCIA: 'COMPETENCIA',
  CAIXA: 'CAIXA',
} as const;
export type FpaRegime = (typeof FpaRegime)[keyof typeof FpaRegime];

export const FpaDateBasis = {
  COMPETENCIA: 'COMPETENCIA',
  GERENCIAL: 'GERENCIAL',
} as const;
export type FpaDateBasis = (typeof FpaDateBasis)[keyof typeof FpaDateBasis];

export const FpaRollupKind = {
  AGGREGATION: 'AGGREGATION',
  CALCULATED: 'CALCULATED',
} as const;
export type FpaRollupKind = (typeof FpaRollupKind)[keyof typeof FpaRollupKind];

export const FpaDisplayFormat = {
  CURRENCY: 'CURRENCY',
  PERCENT: 'PERCENT',
  NUMBER: 'NUMBER',
} as const;
export type FpaDisplayFormat = (typeof FpaDisplayFormat)[keyof typeof FpaDisplayFormat];

export const FpaFilterDimension = {
  ENTITY: 'ENTITY',
  COST_CENTER: 'COST_CENTER',
  DEPARTMENT: 'DEPARTMENT',
  MANAGERIAL_ACCOUNT: 'MANAGERIAL_ACCOUNT',
  SEGMENT: 'SEGMENT',
  VENDOR: 'VENDOR',
  CUSTOMER: 'CUSTOMER',
  AMOUNT: 'AMOUNT',
} as const;
export type FpaFilterDimension = (typeof FpaFilterDimension)[keyof typeof FpaFilterDimension];

export const FpaTemplateRowType = {
  ROLLUP: 'ROLLUP',
  SECTION_HEADER: 'SECTION_HEADER',
  SPACER: 'SPACER',
} as const;
export type FpaTemplateRowType = (typeof FpaTemplateRowType)[keyof typeof FpaTemplateRowType];

export const FpaSignConvention = {
  NATURAL: 'NATURAL',
  INVERTED: 'INVERTED',
} as const;
export type FpaSignConvention = (typeof FpaSignConvention)[keyof typeof FpaSignConvention];

export const FpaMetricProducer = {
  SYSTEM: 'SYSTEM',
  TENANT: 'TENANT',
} as const;
export type FpaMetricProducer = (typeof FpaMetricProducer)[keyof typeof FpaMetricProducer];

export const FpaMetricRestatementStatus = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
} as const;
export type FpaMetricRestatementStatus =
  (typeof FpaMetricRestatementStatus)[keyof typeof FpaMetricRestatementStatus];

export const FpaDefinitionKind = {
  ROLLUP: 'ROLLUP',
  TEMPLATE: 'TEMPLATE',
  FORECAST_RULE_SET: 'FORECAST_RULE_SET',
  HEADCOUNT_PLAN: 'HEADCOUNT_PLAN',
  ASSUMPTION: 'ASSUMPTION',
  LINE_OVERRIDE: 'LINE_OVERRIDE',
  BUDGET_LINE_DERIVATION_RULE: 'BUDGET_LINE_DERIVATION_RULE',
  BUDGET_LIMIT_STAMP: 'BUDGET_LIMIT_STAMP',
  HCM_COLLABORATOR: 'HCM_COLLABORATOR',
  TAX_SLOT_MAPPING: 'TAX_SLOT_MAPPING',
} as const;
export type FpaDefinitionKind = (typeof FpaDefinitionKind)[keyof typeof FpaDefinitionKind];

export const FpaForecastRuleVariant = {
  RECURRING_BILLS: 'RECURRING_BILLS',
  OPEN_DOCUMENTS: 'OPEN_DOCUMENTS',
  ADHOC_RESIDUAL: 'ADHOC_RESIDUAL',
  HEADCOUNT_PLAN: 'HEADCOUNT_PLAN',
  PAYROLL_RUNRATE: 'PAYROLL_RUNRATE',
} as const;
export type FpaForecastRuleVariant =
  (typeof FpaForecastRuleVariant)[keyof typeof FpaForecastRuleVariant];

export const FpaHeadcountPositionStatus = {
  PLANNED: 'PLANNED',
  HIRED: 'HIRED',
  CANCELLED: 'CANCELLED',
} as const;
export type FpaHeadcountPositionStatus =
  (typeof FpaHeadcountPositionStatus)[keyof typeof FpaHeadcountPositionStatus];

export const FpaHeadcountHiringType = {
  CLT: 'CLT',
  PJ: 'PJ',
} as const;
export type FpaHeadcountHiringType =
  (typeof FpaHeadcountHiringType)[keyof typeof FpaHeadcountHiringType];

export const FpaForecastRuleSetStatus = {
  ACTIVE: 'ACTIVE',
  ARCHIVED: 'ARCHIVED',
} as const;
export type FpaForecastRuleSetStatus =
  (typeof FpaForecastRuleSetStatus)[keyof typeof FpaForecastRuleSetStatus];

export const FpaForecastRuleStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
} as const;
export type FpaForecastRuleStatus =
  (typeof FpaForecastRuleStatus)[keyof typeof FpaForecastRuleStatus];

export const ExchangeRatePurpose = {
  SPOT_TRANSACTION: 'SPOT_TRANSACTION',
  CLOSING: 'CLOSING',
  AVERAGE: 'AVERAGE',
  HISTORICAL: 'HISTORICAL',
  SETTLEMENT: 'SETTLEMENT',
  FORECAST: 'FORECAST',
} as const;
export type ExchangeRatePurpose = (typeof ExchangeRatePurpose)[keyof typeof ExchangeRatePurpose];

export const ExchangeRateQuoteConvention = {
  DIRECT: 'DIRECT',
  INVERSE: 'INVERSE',
} as const;
export type ExchangeRateQuoteConvention =
  (typeof ExchangeRateQuoteConvention)[keyof typeof ExchangeRateQuoteConvention];

export const ExchangeRateQuoteSource = {
  IDENTITY: 'IDENTITY',
  PTAX: 'PTAX',
  MANUAL: 'MANUAL',
  TRANSACTION: 'TRANSACTION',
  DERIVED: 'DERIVED',
  DOF: 'DOF',
  FED_H10: 'FED_H10',
} as const;
export type ExchangeRateQuoteSource =
  (typeof ExchangeRateQuoteSource)[keyof typeof ExchangeRateQuoteSource];

export const ExchangeRateQuoteStatus = {
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  ACTIVE: 'ACTIVE',
  SUPERSEDED: 'SUPERSEDED',
  REJECTED: 'REJECTED',
} as const;
export type ExchangeRateQuoteStatus =
  (typeof ExchangeRateQuoteStatus)[keyof typeof ExchangeRateQuoteStatus];

export const MonetaryExposureType = {
  AP_PAYABLE: 'AP_PAYABLE',
  AR_RECEIVABLE: 'AR_RECEIVABLE',
  CONTRACT_ASSET: 'CONTRACT_ASSET',
  BANK_BALANCE: 'BANK_BALANCE',
  CARD_BALANCE: 'CARD_BALANCE',
  LOAN_PRINCIPAL: 'LOAN_PRINCIPAL',
  LOAN_INTEREST: 'LOAN_INTEREST',
  INVESTMENT: 'INVESTMENT',
  INTERCOMPANY_RECEIVABLE: 'INTERCOMPANY_RECEIVABLE',
  INTERCOMPANY_PAYABLE: 'INTERCOMPANY_PAYABLE',
  ADVANCE: 'ADVANCE',
  DEPOSIT: 'DEPOSIT',
  OTHER: 'OTHER',
  COST_PROVISION: 'COST_PROVISION',
} as const;
export type MonetaryExposureType = (typeof MonetaryExposureType)[keyof typeof MonetaryExposureType];

export const MonetaryClassification = {
  MONETARY: 'MONETARY',
  NONMONETARY: 'NONMONETARY',
  UNRESOLVED: 'UNRESOLVED',
} as const;
export type MonetaryClassification =
  (typeof MonetaryClassification)[keyof typeof MonetaryClassification];

export const MonetaryExposureStatus = {
  OPEN: 'OPEN',
  SETTLED: 'SETTLED',
  REVERSED: 'REVERSED',
  QUARANTINED: 'QUARANTINED',
} as const;
export type MonetaryExposureStatus =
  (typeof MonetaryExposureStatus)[keyof typeof MonetaryExposureStatus];

export const MonetaryExposureMovementKind = {
  RECOGNITION: 'RECOGNITION',
  SETTLEMENT: 'SETTLEMENT',
  RECLASSIFICATION: 'RECLASSIFICATION',
  REMEASUREMENT: 'REMEASUREMENT',
  REVERSAL: 'REVERSAL',
  CORRECTION: 'CORRECTION',
} as const;
export type MonetaryExposureMovementKind =
  (typeof MonetaryExposureMovementKind)[keyof typeof MonetaryExposureMovementKind];

export const FxCategory = {
  OPER: 'OPER',
  FIN: 'FIN',
  CONFIGURED: 'CONFIGURED',
} as const;
export type FxCategory = (typeof FxCategory)[keyof typeof FxCategory];

export const FxRemeasurementRunStatus = {
  PREVIEWED: 'PREVIEWED',
  RUNNING: 'RUNNING',
  COMPLETED: 'COMPLETED',
  COMPLETED_WITH_EXCEPTIONS: 'COMPLETED_WITH_EXCEPTIONS',
  FAILED: 'FAILED',
  SUPERSEDED: 'SUPERSEDED',
} as const;
export type FxRemeasurementRunStatus =
  (typeof FxRemeasurementRunStatus)[keyof typeof FxRemeasurementRunStatus];

export const FxRemeasurementLineStatus = {
  PENDING: 'PENDING',
  POSTED: 'POSTED',
  NO_CHANGE: 'NO_CHANGE',
  EXCEPTION: 'EXCEPTION',
  REVERSED: 'REVERSED',
} as const;
export type FxRemeasurementLineStatus =
  (typeof FxRemeasurementLineStatus)[keyof typeof FxRemeasurementLineStatus];

export const FxExchangeStatus = {
  DRAFT: 'DRAFT',
  CONFIRMED: 'CONFIRMED',
  SETTLED: 'SETTLED',
  REVERSED: 'REVERSED',
} as const;
export type FxExchangeStatus = (typeof FxExchangeStatus)[keyof typeof FxExchangeStatus];

export const PeriodStatus = {
  OPEN: 'OPEN',
  CLOSED: 'CLOSED',
  LOCKED: 'LOCKED',
} as const;
export type PeriodStatus = (typeof PeriodStatus)[keyof typeof PeriodStatus];

export const JournalStatus = {
  DRAFT: 'DRAFT',
  POSTED: 'POSTED',
  VOID: 'VOID',
  REVERSED: 'REVERSED',
} as const;
export type JournalStatus = (typeof JournalStatus)[keyof typeof JournalStatus];

export const GlManualEntryStatus = {
  DRAFT: 'DRAFT',
  POSTED: 'POSTED',
  CANCELLED: 'CANCELLED',
  REVERSED: 'REVERSED',
} as const;
export type GlManualEntryStatus = (typeof GlManualEntryStatus)[keyof typeof GlManualEntryStatus];

export const GlManualEntrySource = {
  WEB: 'WEB',
  MCP: 'MCP',
} as const;
export type GlManualEntrySource = (typeof GlManualEntrySource)[keyof typeof GlManualEntrySource];

export const FxRateEvidenceContext = {
  PROVISION: 'PROVISION',
  REVALUATION: 'REVALUATION',
  SETTLEMENT: 'SETTLEMENT',
  JOURNAL: 'JOURNAL',
} as const;
export type FxRateEvidenceContext =
  (typeof FxRateEvidenceContext)[keyof typeof FxRateEvidenceContext];

export const FxRateEvidenceSource = {
  IDENTITY: 'IDENTITY',
  PTAX: 'PTAX',
  MANUAL: 'MANUAL',
  TRANSACTION: 'TRANSACTION',
  DOF: 'DOF',
  FED_H10: 'FED_H10',
} as const;
export type FxRateEvidenceSource = (typeof FxRateEvidenceSource)[keyof typeof FxRateEvidenceSource];

export const NaturalBalance = {
  DEBIT: 'DEBIT',
  CREDIT: 'CREDIT',
} as const;
export type NaturalBalance = (typeof NaturalBalance)[keyof typeof NaturalBalance];

export const AccountType = {
  ASSET: 'ASSET',
  LIABILITY: 'LIABILITY',
  EQUITY: 'EQUITY',
  REVENUE: 'REVENUE',
  COGS: 'COGS',
  EXPENSE: 'EXPENSE',
  OTHER_INCOME: 'OTHER_INCOME',
  OTHER_EXPENSE: 'OTHER_EXPENSE',
} as const;
export type AccountType = (typeof AccountType)[keyof typeof AccountType];

export const CoaVersionStatus = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
  SCHEDULED: 'SCHEDULED',
  DEPRECATED: 'DEPRECATED',
} as const;
export type CoaVersionStatus = (typeof CoaVersionStatus)[keyof typeof CoaVersionStatus];

export const CoaAssignmentStatus = {
  SCHEDULED: 'SCHEDULED',
  ACTIVE: 'ACTIVE',
  SUPERSEDED: 'SUPERSEDED',
} as const;
export type CoaAssignmentStatus = (typeof CoaAssignmentStatus)[keyof typeof CoaAssignmentStatus];

export const VersionMappingType = {
  UNCHANGED: 'UNCHANGED',
  RENAMED: 'RENAMED',
  MERGED: 'MERGED',
  SPLIT: 'SPLIT',
  DISCONTINUED: 'DISCONTINUED',
} as const;
export type VersionMappingType = (typeof VersionMappingType)[keyof typeof VersionMappingType];

export const RollupCategory = {
  BALANCE_SHEET: 'BALANCE_SHEET',
  INCOME_STATEMENT: 'INCOME_STATEMENT',
} as const;
export type RollupCategory = (typeof RollupCategory)[keyof typeof RollupCategory];

export const BookType = {
  STATUTORY: 'STATUTORY',
  MANAGEMENT: 'MANAGEMENT',
  CONSOLIDATION: 'CONSOLIDATION',
  TAX: 'TAX',
  SANDBOX: 'SANDBOX',
} as const;
export type BookType = (typeof BookType)[keyof typeof BookType];

export const BookScope = {
  ENTITY: 'ENTITY',
  GROUP: 'GROUP',
} as const;
export type BookScope = (typeof BookScope)[keyof typeof BookScope];

export const PostingMode = {
  POSTED: 'POSTED',
  MEMO: 'MEMO',
} as const;
export type PostingMode = (typeof PostingMode)[keyof typeof PostingMode];

export const CalendarPeriodicity = {
  MONTHLY: 'MONTHLY',
  QUARTERLY: 'QUARTERLY',
  WEEKLY: 'WEEKLY',
  THIRTEEN_PERIODS: 'THIRTEEN_PERIODS',
  FOUR_FOUR_FIVE: 'FOUR_FOUR_FIVE',
  FOUR_FIVE_FOUR: 'FOUR_FIVE_FOUR',
  FIVE_FOUR_FOUR: 'FIVE_FOUR_FOUR',
} as const;
export type CalendarPeriodicity = (typeof CalendarPeriodicity)[keyof typeof CalendarPeriodicity];

export const AccountingReviewStatus = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  CANCELLED: 'CANCELLED',
} as const;
export type AccountingReviewStatus =
  (typeof AccountingReviewStatus)[keyof typeof AccountingReviewStatus];

export const HistoricalImportStage = {
  SETUP: 'SETUP',
  OPENING_BALANCES: 'OPENING_BALANCES',
  RAZAO_JOURNALS: 'RAZAO_JOURNALS',
  PARTIES: 'PARTIES',
  PARTY_PLACEHOLDER_RENAMES: 'PARTY_PLACEHOLDER_RENAMES',
  BANK_TRANSACTIONS: 'BANK_TRANSACTIONS',
  AP_BILL_ATTACHMENTS: 'AP_BILL_ATTACHMENTS',
  AP_ORIGIN_LINKS: 'AP_ORIGIN_LINKS',
  AP_VENDOR_REMEDIATION: 'AP_VENDOR_REMEDIATION',
  AR_ORIGIN_LINKS: 'AR_ORIGIN_LINKS',
} as const;
export type HistoricalImportStage =
  (typeof HistoricalImportStage)[keyof typeof HistoricalImportStage];

export const HistoricalImportStatus = {
  PREVIEWED: 'PREVIEWED',
  APPLIED: 'APPLIED',
  VERIFIED: 'VERIFIED',
  FAILED: 'FAILED',
} as const;
export type HistoricalImportStatus =
  (typeof HistoricalImportStatus)[keyof typeof HistoricalImportStatus];

export const ClosingChecklistSection = {
  ACCOUNTS_PAYABLE: 'ACCOUNTS_PAYABLE',
  BANK_RECONCILIATION: 'BANK_RECONCILIATION',
  TAX_OBLIGATIONS: 'TAX_OBLIGATIONS',
  ACCOUNTING_GL: 'ACCOUNTING_GL',
  BILLING: 'BILLING',
} as const;
export type ClosingChecklistSection =
  (typeof ClosingChecklistSection)[keyof typeof ClosingChecklistSection];

export const ClosingTaskStatus = {
  PENDING: 'PENDING',
  DONE: 'DONE',
  WAIVED: 'WAIVED',
} as const;
export type ClosingTaskStatus = (typeof ClosingTaskStatus)[keyof typeof ClosingTaskStatus];

export const ClosingTaskAttachmentKind = {
  TEMPLATE_ATTACHMENT: 'TEMPLATE_ATTACHMENT',
  EVIDENCE: 'EVIDENCE',
} as const;
export type ClosingTaskAttachmentKind =
  (typeof ClosingTaskAttachmentKind)[keyof typeof ClosingTaskAttachmentKind];

export const FxRevaluationRecoveryStatus = {
  PREVIEWED: 'PREVIEWED',
  APPROVED: 'APPROVED',
  EXECUTED: 'EXECUTED',
  CANCELLED: 'CANCELLED',
} as const;
export type FxRevaluationRecoveryStatus =
  (typeof FxRevaluationRecoveryStatus)[keyof typeof FxRevaluationRecoveryStatus];

export const FinancialControlAssessmentExecution = {
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
} as const;
export type FinancialControlAssessmentExecution =
  (typeof FinancialControlAssessmentExecution)[keyof typeof FinancialControlAssessmentExecution];

export const FinancialControlAssessmentPublication = {
  PUBLISHED: 'PUBLISHED',
  REJECTED_STALE: 'REJECTED_STALE',
  NOT_PUBLISHED: 'NOT_PUBLISHED',
} as const;
export type FinancialControlAssessmentPublication =
  (typeof FinancialControlAssessmentPublication)[keyof typeof FinancialControlAssessmentPublication];

export const FinancialControlFindingStatus = {
  OPEN: 'OPEN',
  RESOLVED: 'RESOLVED',
  SUPERSEDED: 'SUPERSEDED',
} as const;
export type FinancialControlFindingStatus =
  (typeof FinancialControlFindingStatus)[keyof typeof FinancialControlFindingStatus];

export const FinancialControlReviewDecision = {
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  KEEP: 'KEEP',
} as const;
export type FinancialControlReviewDecision =
  (typeof FinancialControlReviewDecision)[keyof typeof FinancialControlReviewDecision];

export const FinancialControlReviewInvalidationReason = {
  SOURCE_CHANGED: 'SOURCE_CHANGED',
  RULE_CHANGED: 'RULE_CHANGED',
} as const;
export type FinancialControlReviewInvalidationReason =
  (typeof FinancialControlReviewInvalidationReason)[keyof typeof FinancialControlReviewInvalidationReason];

export const SubjectAccountType = {
  AP_VENDOR: 'AP_VENDOR',
  AP_VENDOR_ADVANCE: 'AP_VENDOR_ADVANCE',
  TREASURY_BANK_ACCOUNT: 'TREASURY_BANK_ACCOUNT',
  TREASURY_CREDIT_CARD: 'TREASURY_CREDIT_CARD',
  TREASURY_INVESTMENT_POSITION: 'TREASURY_INVESTMENT_POSITION',
  AR_CUSTOMER: 'AR_CUSTOMER',
  PAYROLL_ORG_UNIT: 'PAYROLL_ORG_UNIT',
  PAYROLL_EMPLOYEE: 'PAYROLL_EMPLOYEE',
  BILLING_SERVICE: 'BILLING_SERVICE',
  AR_CUSTODIAL_PARTNER: 'AR_CUSTODIAL_PARTNER',
  ACQUIRER_RAIL: 'ACQUIRER_RAIL',
  AR_UNBILLED_CUSTOMER: 'AR_UNBILLED_CUSTOMER',
} as const;
export type SubjectAccountType = (typeof SubjectAccountType)[keyof typeof SubjectAccountType];

export const SystemAccountModule = {
  AP: 'AP',
  AR: 'AR',
  GL: 'GL',
  HCM: 'HCM',
  OP: 'OP',
  FA: 'FA',
} as const;
export type SystemAccountModule = (typeof SystemAccountModule)[keyof typeof SystemAccountModule];

export const SystemAccountCategory = {
  FINANCIAL_REVENUE: 'FINANCIAL_REVENUE',
  FINANCIAL_EXPENSE: 'FINANCIAL_EXPENSE',
  BANK_FEES: 'BANK_FEES',
  TAX_EXPENSE_PAYMENT: 'TAX_EXPENSE_PAYMENT',
  SUPPLIER_ADVANCE: 'SUPPLIER_ADVANCE',
  CREDIT_CARD_LIABILITY: 'CREDIT_CARD_LIABILITY',
  FX_VARIATION: 'FX_VARIATION',
  PAYROLL_LIABILITY: 'PAYROLL_LIABILITY',
  PAYROLL_ASSET: 'PAYROLL_ASSET',
  RECOVERY_REVENUE: 'RECOVERY_REVENUE',
  CLIENT_RECOVERABLE_ADVANCE: 'CLIENT_RECOVERABLE_ADVANCE',
  CONTRACT_ASSET: 'CONTRACT_ASSET',
  CONTRACT_LIABILITY: 'CONTRACT_LIABILITY',
  RETAINED_EARNINGS: 'RETAINED_EARNINGS',
  FIXED_ASSET_COST: 'FIXED_ASSET_COST',
  ACCUMULATED_DEPRECIATION: 'ACCUMULATED_DEPRECIATION',
  DEPRECIATION_EXPENSE: 'DEPRECIATION_EXPENSE',
  ROU_ASSET: 'ROU_ASSET',
  ACCUMULATED_ROU_AMORTIZATION: 'ACCUMULATED_ROU_AMORTIZATION',
  LEASE_LIABILITY_CURRENT: 'LEASE_LIABILITY_CURRENT',
  LEASE_LIABILITY_NONCURRENT: 'LEASE_LIABILITY_NONCURRENT',
  LEASE_INTEREST_EXPENSE: 'LEASE_INTEREST_EXPENSE',
  ASSET_DISPOSAL_RESULT: 'ASSET_DISPOSAL_RESULT',
  VENDOR_LIABILITY: 'VENDOR_LIABILITY',
  BANK_ACCOUNT: 'BANK_ACCOUNT',
  INVESTMENT_SHORT_TERM: 'INVESTMENT_SHORT_TERM',
  INVESTMENT_LONG_TERM: 'INVESTMENT_LONG_TERM',
  IN_TRANSIT: 'IN_TRANSIT',
  CUSTOMER_RECEIVABLE: 'CUSTOMER_RECEIVABLE',
  EXPENSE_ACCRUAL: 'EXPENSE_ACCRUAL',
  CUSTODIAL_PAYABLE: 'CUSTODIAL_PAYABLE',
  SERVICE_TAX_PAYABLE: 'SERVICE_TAX_PAYABLE',
  SERVICE_REVENUE: 'SERVICE_REVENUE',
  INTANGIBLE_IN_PROGRESS: 'INTANGIBLE_IN_PROGRESS',
  ACQUIRER_FEE_EXPENSE: 'ACQUIRER_FEE_EXPENSE',
  RECOVERABLE_TAX: 'RECOVERABLE_TAX',
  INTANGIBLE_WRITE_OFF_LOSS: 'INTANGIBLE_WRITE_OFF_LOSS',
  UNBILLED_RECEIVABLE: 'UNBILLED_RECEIVABLE',
  REVENUE_DEDUCTION: 'REVENUE_DEDUCTION',
  CUSTOMER_ADVANCE: 'CUSTOMER_ADVANCE',
  CARD_FINANCING_CLEARING: 'CARD_FINANCING_CLEARING',
  INTANGIBLE_ASSET_COST: 'INTANGIBLE_ASSET_COST',
  INTANGIBLE_ACCUMULATED_AMORTIZATION: 'INTANGIBLE_ACCUMULATED_AMORTIZATION',
  PIS_COFINS_RECOVERABILITY_LOSS: 'PIS_COFINS_RECOVERABILITY_LOSS',
  PREPAID_EXPENSE: 'PREPAID_EXPENSE',
} as const;
export type SystemAccountCategory =
  (typeof SystemAccountCategory)[keyof typeof SystemAccountCategory];

export const SystemAccountSlotTreatment = {
  ROOT_PROVISIONED: 'ROOT_PROVISIONED',
  DIRECT_LINK: 'DIRECT_LINK',
} as const;
export type SystemAccountSlotTreatment =
  (typeof SystemAccountSlotTreatment)[keyof typeof SystemAccountSlotTreatment];

export const HcmEmploymentStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  TERMINATED: 'TERMINATED',
  SUSPENDED: 'SUSPENDED',
} as const;
export type HcmEmploymentStatus = (typeof HcmEmploymentStatus)[keyof typeof HcmEmploymentStatus];

export const HcmPayrollCostType = {
  EXPENSE: 'EXPENSE',
  COST: 'COST',
} as const;
export type HcmPayrollCostType = (typeof HcmPayrollCostType)[keyof typeof HcmPayrollCostType];

export const HcmCollaboratorRegime = {
  PJ: 'PJ',
} as const;
export type HcmCollaboratorRegime =
  (typeof HcmCollaboratorRegime)[keyof typeof HcmCollaboratorRegime];

export const HcmPayrollRunStatus = {
  DRAFT: 'DRAFT',
  PROCESSING: 'PROCESSING',
  PROCESSED: 'PROCESSED',
  POSTED: 'POSTED',
  VOIDED: 'VOIDED',
} as const;
export type HcmPayrollRunStatus = (typeof HcmPayrollRunStatus)[keyof typeof HcmPayrollRunStatus];

export const HcmClassificationSource = {
  USER: 'USER',
  INTEGRATION: 'INTEGRATION',
  WORKFLOW: 'WORKFLOW',
  SYSTEM: 'SYSTEM',
} as const;
export type HcmClassificationSource =
  (typeof HcmClassificationSource)[keyof typeof HcmClassificationSource];

export const HcmPayrollFileStatus = {
  PENDING_PROCESSING: 'PENDING_PROCESSING',
  PROCESSING: 'PROCESSING',
  PROCESSED: 'PROCESSED',
  FAILED: 'FAILED',
} as const;
export type HcmPayrollFileStatus = (typeof HcmPayrollFileStatus)[keyof typeof HcmPayrollFileStatus];

export const HcmPayrollDimensionType = {
  COST_CENTER: 'COST_CENTER',
  DEPARTMENT: 'DEPARTMENT',
} as const;
export type HcmPayrollDimensionType =
  (typeof HcmPayrollDimensionType)[keyof typeof HcmPayrollDimensionType];

export const HcmPayrollResolutionSource = {
  AUTO: 'AUTO',
  MANUAL: 'MANUAL',
} as const;
export type HcmPayrollResolutionSource =
  (typeof HcmPayrollResolutionSource)[keyof typeof HcmPayrollResolutionSource];

export const HcmPayrollResolutionAction = {
  MAP: 'MAP',
  CREATE: 'CREATE',
} as const;
export type HcmPayrollResolutionAction =
  (typeof HcmPayrollResolutionAction)[keyof typeof HcmPayrollResolutionAction];

export const HcmPayrollHistoryAction = {
  CREATE: 'CREATE',
  STATUS_CHANGE: 'STATUS_CHANGE',
  REPROCESS: 'REPROCESS',
  MAPPING_CHANGE: 'MAPPING_CHANGE',
  APPROVE: 'APPROVE',
  POST: 'POST',
  VOID: 'VOID',
} as const;
export type HcmPayrollHistoryAction =
  (typeof HcmPayrollHistoryAction)[keyof typeof HcmPayrollHistoryAction];

export const HcmPayrollRunType = {
  MONTHLY: 'MONTHLY',
  ADVANCE: 'ADVANCE',
  PRO_LABORE: 'PRO_LABORE',
  TERMINATION: 'TERMINATION',
  THIRTEENTH: 'THIRTEENTH',
  VACATION: 'VACATION',
  PROVISION_VACATION: 'PROVISION_VACATION',
  PROVISION_THIRTEENTH: 'PROVISION_THIRTEENTH',
  AUTONOMOUS: 'AUTONOMOUS',
} as const;
export type HcmPayrollRunType = (typeof HcmPayrollRunType)[keyof typeof HcmPayrollRunType];

export const HcmPayrollWorkerCategory = {
  EMPLOYEE: 'EMPLOYEE',
  AUTONOMOUS: 'AUTONOMOUS',
} as const;
export type HcmPayrollWorkerCategory =
  (typeof HcmPayrollWorkerCategory)[keyof typeof HcmPayrollWorkerCategory];

export const TaxpayerEntityRole = {
  HEAD_OFFICE: 'HEAD_OFFICE',
  BRANCH: 'BRANCH',
} as const;
export type TaxpayerEntityRole = (typeof TaxpayerEntityRole)[keyof typeof TaxpayerEntityRole];

export const TaxDueBasis = {
  ACCRUAL: 'ACCRUAL',
  CASH: 'CASH',
} as const;
export type TaxDueBasis = (typeof TaxDueBasis)[keyof typeof TaxDueBasis];

export const EntityTaxIdentifierStatus = {
  ACTIVE: 'ACTIVE',
  RETIRED: 'RETIRED',
} as const;
export type EntityTaxIdentifierStatus =
  (typeof EntityTaxIdentifierStatus)[keyof typeof EntityTaxIdentifierStatus];

export const FgaOperationStatus = {
  PENDING: 'PENDING',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
} as const;
export type FgaOperationStatus = (typeof FgaOperationStatus)[keyof typeof FgaOperationStatus];

export const McpAgentConnectionStatus = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REVOKED: 'REVOKED',
} as const;
export type McpAgentConnectionStatus =
  (typeof McpAgentConnectionStatus)[keyof typeof McpAgentConnectionStatus];

export const McpWriteConfirmationStatus = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  CONSUMED: 'CONSUMED',
} as const;
export type McpWriteConfirmationStatus =
  (typeof McpWriteConfirmationStatus)[keyof typeof McpWriteConfirmationStatus];

export const IntegrationCategory = {
  ERP: 'ERP',
  PAYROLL: 'PAYROLL',
  BANKING: 'BANKING',
  ACCOUNTING: 'ACCOUNTING',
  FISCAL: 'FISCAL',
  ECOMMERCE: 'ECOMMERCE',
  COMMUNICATION: 'COMMUNICATION',
  OTHER: 'OTHER',
} as const;
export type IntegrationCategory = (typeof IntegrationCategory)[keyof typeof IntegrationCategory];

export const IntegrationStatus = {
  ACTIVE: 'ACTIVE',
  BETA: 'BETA',
  IN_DEVELOPMENT: 'IN_DEVELOPMENT',
  PLANNED: 'PLANNED',
  DEPRECATED: 'DEPRECATED',
} as const;
export type IntegrationStatus = (typeof IntegrationStatus)[keyof typeof IntegrationStatus];

export const IntegrationControl = {
  CUSTOMER: 'CUSTOMER',
  PLATFORM: 'PLATFORM',
} as const;
export type IntegrationControl = (typeof IntegrationControl)[keyof typeof IntegrationControl];

export const TenantIntegrationStatus = {
  INACTIVE: 'INACTIVE',
  ACTIVE: 'ACTIVE',
  ERROR: 'ERROR',
  SUSPENDED: 'SUSPENDED',
  CONFIGURING: 'CONFIGURING',
} as const;
export type TenantIntegrationStatus =
  (typeof TenantIntegrationStatus)[keyof typeof TenantIntegrationStatus];

export const SyncStatus = {
  SUCCESS: 'SUCCESS',
  PARTIAL: 'PARTIAL',
  FAILED: 'FAILED',
} as const;
export type SyncStatus = (typeof SyncStatus)[keyof typeof SyncStatus];

export const SyncDirection = {
  INBOUND: 'INBOUND',
  OUTBOUND: 'OUTBOUND',
  BIDIRECTIONAL: 'BIDIRECTIONAL',
} as const;
export type SyncDirection = (typeof SyncDirection)[keyof typeof SyncDirection];

export const SyncJobStatus = {
  PENDING: 'PENDING',
  RUNNING: 'RUNNING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED',
} as const;
export type SyncJobStatus = (typeof SyncJobStatus)[keyof typeof SyncJobStatus];

export const SyncJobOperation = {
  PREVIEW: 'PREVIEW',
  SYNC: 'SYNC',
  IMPORT: 'IMPORT',
} as const;
export type SyncJobOperation = (typeof SyncJobOperation)[keyof typeof SyncJobOperation];

export const IntegrationResourceType = {
  PARTY: 'PARTY',
  BANK_ACCOUNT: 'BANK_ACCOUNT',
  ACCOUNT: 'ACCOUNT',
  COST_CENTER: 'COST_CENTER',
  DEPARTMENT: 'DEPARTMENT',
  MANAGERIAL_ACCOUNT: 'MANAGERIAL_ACCOUNT',
  AP_SEGMENT_VALUE: 'AP_SEGMENT_VALUE',
  AR_CUSTOMER: 'AR_CUSTOMER',
  AR_INVOICE: 'AR_INVOICE',
  AR_RECEIPT: 'AR_RECEIPT',
  AP_VENDOR: 'AP_VENDOR',
  AP_BILL: 'AP_BILL',
  AP_PAYMENT: 'AP_PAYMENT',
} as const;
export type IntegrationResourceType =
  (typeof IntegrationResourceType)[keyof typeof IntegrationResourceType];

export const IntegrationApiRequestOutcome = {
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
  UNAUTHORIZED: 'UNAUTHORIZED',
  RATE_LIMITED: 'RATE_LIMITED',
  BLOCKED: 'BLOCKED',
} as const;
export type IntegrationApiRequestOutcome =
  (typeof IntegrationApiRequestOutcome)[keyof typeof IntegrationApiRequestOutcome];

export const IntegrationProviderHealth = {
  HEALTHY: 'HEALTHY',
  DEGRADED: 'DEGRADED',
  UNAUTHORIZED: 'UNAUTHORIZED',
  BLOCKED: 'BLOCKED',
} as const;
export type IntegrationProviderHealth =
  (typeof IntegrationProviderHealth)[keyof typeof IntegrationProviderHealth];

export const JobStatus = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED',
  PARTIAL: 'PARTIAL',
} as const;
export type JobStatus = (typeof JobStatus)[keyof typeof JobStatus];

export const JobType = {
  VENDOR_CONTEXT_UPLOAD: 'VENDOR_CONTEXT_UPLOAD',
  SETTLEMENT_REPORT_IMPORT: 'SETTLEMENT_REPORT_IMPORT',
  AR_PRE_BILLING_IMPORT: 'AR_PRE_BILLING_IMPORT',
  AR_PRE_BILLING_APPROVAL: 'AR_PRE_BILLING_APPROVAL',
} as const;
export type JobType = (typeof JobType)[keyof typeof JobType];

export const JobItemStage = {
  IMPORT: 'IMPORT',
  APPROVAL: 'APPROVAL',
  EMISSION: 'EMISSION',
  POSTING: 'POSTING',
} as const;
export type JobItemStage = (typeof JobItemStage)[keyof typeof JobItemStage];

export const JobItemStatus = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  RETRY_SCHEDULED: 'RETRY_SCHEDULED',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
} as const;
export type JobItemStatus = (typeof JobItemStatus)[keyof typeof JobItemStatus];

export const JobItemAttemptOutcome = {
  PROCESSING: 'PROCESSING',
  SUCCEEDED: 'SUCCEEDED',
  RETRY_SCHEDULED: 'RETRY_SCHEDULED',
  FAILED: 'FAILED',
} as const;
export type JobItemAttemptOutcome =
  (typeof JobItemAttemptOutcome)[keyof typeof JobItemAttemptOutcome];

export const NotificationUrgency = {
  LOW: 'LOW',
  NORMAL: 'NORMAL',
  HIGH: 'HIGH',
} as const;
export type NotificationUrgency = (typeof NotificationUrgency)[keyof typeof NotificationUrgency];

export const NotificationClass = {
  OBLIGATION: 'OBLIGATION',
  REVIEW: 'REVIEW',
} as const;
export type NotificationClass = (typeof NotificationClass)[keyof typeof NotificationClass];

export const NotificationObligationState = {
  PENDING: 'PENDING',
  RESOLVED: 'RESOLVED',
  DISMISSED: 'DISMISSED',
  EXPIRED: 'EXPIRED',
} as const;
export type NotificationObligationState =
  (typeof NotificationObligationState)[keyof typeof NotificationObligationState];

export const OnboardingCompletionSource = {
  AUTO: 'AUTO',
  MANUAL: 'MANUAL',
  SKIPPED: 'SKIPPED',
} as const;
export type OnboardingCompletionSource =
  (typeof OnboardingCompletionSource)[keyof typeof OnboardingCompletionSource];

export const EmailInboxStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  SUSPENDED: 'SUSPENDED',
} as const;
export type EmailInboxStatus = (typeof EmailInboxStatus)[keyof typeof EmailInboxStatus];

export const EmailMessageStatus = {
  RECEIVED: 'RECEIVED',
  TRIAGING: 'TRIAGING',
  AWAITING_INFO: 'AWAITING_INFO',
  READY_TO_PROCESS: 'READY_TO_PROCESS',
  PROCESSED: 'PROCESSED',
  REJECTED: 'REJECTED',
  FAILED: 'FAILED',
} as const;
export type EmailMessageStatus = (typeof EmailMessageStatus)[keyof typeof EmailMessageStatus];

export const EmailClassificationType = {
  AP: 'AP',
  REIMBURSEMENT: 'REIMBURSEMENT',
  SPAM: 'SPAM',
  UNKNOWN: 'UNKNOWN',
} as const;
export type EmailClassificationType =
  (typeof EmailClassificationType)[keyof typeof EmailClassificationType];

export const EmailIntakeOutcome = {
  BILL_CREATED: 'BILL_CREATED',
  REIMBURSEMENT_CREATED: 'REIMBURSEMENT_CREATED',
  NO_BILL: 'NO_BILL',
  AWAITING_INFO: 'AWAITING_INFO',
  REJECTED: 'REJECTED',
} as const;
export type EmailIntakeOutcome = (typeof EmailIntakeOutcome)[keyof typeof EmailIntakeOutcome];

export const EmailMessageSource = {
  RESEND: 'RESEND',
  MANUAL: 'MANUAL',
  PIPEFY_WEBHOOK: 'PIPEFY_WEBHOOK',
} as const;
export type EmailMessageSource = (typeof EmailMessageSource)[keyof typeof EmailMessageSource];

export const DocumentBundleSource = {
  EMAIL: 'EMAIL',
  BILLS_PAGE_BROWSER: 'BILLS_PAGE_BROWSER',
  EXTERNAL_FORM: 'EXTERNAL_FORM',
  REPROCESS_SINGLE_DOCUMENT: 'REPROCESS_SINGLE_DOCUMENT',
  STUCK_SWEEP_REQUEUE: 'STUCK_SWEEP_REQUEUE',
  SINGLE_FILE_UPLOAD: 'SINGLE_FILE_UPLOAD',
  PIPEFY_WEBHOOK: 'PIPEFY_WEBHOOK',
} as const;
export type DocumentBundleSource = (typeof DocumentBundleSource)[keyof typeof DocumentBundleSource];

export const SerproQueryType = {
  BASICA: 'BASICA',
  QSA: 'QSA',
  EMPRESA: 'EMPRESA',
} as const;
export type SerproQueryType = (typeof SerproQueryType)[keyof typeof SerproQueryType];

export const PipefyCardIntakeReservationStatus = {
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
} as const;
export type PipefyCardIntakeReservationStatus =
  (typeof PipefyCardIntakeReservationStatus)[keyof typeof PipefyCardIntakeReservationStatus];

export const IntakeRuleCreatedVia = {
  USER: 'USER',
  PROMPT: 'PROMPT',
  MCP: 'MCP',
} as const;
export type IntakeRuleCreatedVia = (typeof IntakeRuleCreatedVia)[keyof typeof IntakeRuleCreatedVia];

export const InvestmentPositionStatus = {
  ACTIVE: 'ACTIVE',
  PENDING: 'PENDING',
  TOTAL_WITHDRAWAL: 'TOTAL_WITHDRAWAL',
} as const;
export type InvestmentPositionStatus =
  (typeof InvestmentPositionStatus)[keyof typeof InvestmentPositionStatus];

export const InvestmentTransactionType = {
  BUY: 'BUY',
  SELL: 'SELL',
  TAX: 'TAX',
  TRANSFER: 'TRANSFER',
  CASH: 'CASH',
  FEE: 'FEE',
  CANCEL: 'CANCEL',
} as const;
export type InvestmentTransactionType =
  (typeof InvestmentTransactionType)[keyof typeof InvestmentTransactionType];

export const InvestmentTermBucket = {
  SHORT: 'SHORT',
  LONG: 'LONG',
} as const;
export type InvestmentTermBucket = (typeof InvestmentTermBucket)[keyof typeof InvestmentTermBucket];

export const LoanStatus = {
  ACTIVE: 'ACTIVE',
  PENDING: 'PENDING',
  CLOSED: 'CLOSED',
} as const;
export type LoanStatus = (typeof LoanStatus)[keyof typeof LoanStatus];

export const MatchingProposalRecommendation = {
  AUTO_APPLY: 'AUTO_APPLY',
  SUGGEST: 'SUGGEST',
  REVIEW_ONLY: 'REVIEW_ONLY',
} as const;
export type MatchingProposalRecommendation =
  (typeof MatchingProposalRecommendation)[keyof typeof MatchingProposalRecommendation];

export const MatchingProposalStatus = {
  PROPOSED: 'PROPOSED',
  AUTO_APPLIED: 'AUTO_APPLIED',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  SUPERSEDED: 'SUPERSEDED',
  EXPIRED: 'EXPIRED',
} as const;
export type MatchingProposalStatus =
  (typeof MatchingProposalStatus)[keyof typeof MatchingProposalStatus];

export const MatchingProposalBucket = {
  RECOMMENDED: 'RECOMMENDED',
  ALTERNATIVE: 'ALTERNATIVE',
} as const;
export type MatchingProposalBucket =
  (typeof MatchingProposalBucket)[keyof typeof MatchingProposalBucket];

export const MatchingProposalLegType = {
  BANK_TX: 'BANK_TX',
  CARD_ITEM: 'CARD_ITEM',
  AP_BILL: 'AP_BILL',
  AP_PAYMENT: 'AP_PAYMENT',
  AR_INVOICE: 'AR_INVOICE',
  AR_PAYMENT_SCHEDULE: 'AR_PAYMENT_SCHEDULE',
  AR_DEBIT_NOTE: 'AR_DEBIT_NOTE',
  CUSTODY_DEPOSIT: 'CUSTODY_DEPOSIT',
  RAIL_EXPECTATION: 'RAIL_EXPECTATION',
} as const;
export type MatchingProposalLegType =
  (typeof MatchingProposalLegType)[keyof typeof MatchingProposalLegType];

export const BankAccountStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  DRAFT: 'DRAFT',
  PENDING_VERIFICATION: 'PENDING_VERIFICATION',
} as const;
export type BankAccountStatus = (typeof BankAccountStatus)[keyof typeof BankAccountStatus];

export const BankAccountPaymentSetupStatus = {
  DISABLED: 'DISABLED',
  CONFIGURING: 'CONFIGURING',
  READY: 'READY',
  ERROR: 'ERROR',
} as const;
export type BankAccountPaymentSetupStatus =
  (typeof BankAccountPaymentSetupStatus)[keyof typeof BankAccountPaymentSetupStatus];

export const CreditCardStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  DRAFT: 'DRAFT',
  CANCELLED: 'CANCELLED',
  EXPIRED: 'EXPIRED',
} as const;
export type CreditCardStatus = (typeof CreditCardStatus)[keyof typeof CreditCardStatus];

export const CreditCardBrand = {
  VISA: 'VISA',
  MASTERCARD: 'MASTERCARD',
  AMEX: 'AMEX',
  ELO: 'ELO',
  HIPERCARD: 'HIPERCARD',
  DINERS: 'DINERS',
  OTHER: 'OTHER',
} as const;
export type CreditCardBrand = (typeof CreditCardBrand)[keyof typeof CreditCardBrand];

export const CreditCardSource = {
  MANUAL: 'MANUAL',
  CLARA: 'CLARA',
  CONTA_SIMPLES: 'CONTA_SIMPLES',
  PLAID: 'PLAID',
  BREX: 'BREX',
} as const;
export type CreditCardSource = (typeof CreditCardSource)[keyof typeof CreditCardSource];

export const CashCurrencyEvidenceSource = {
  PROVIDER_ACCOUNT: 'PROVIDER_ACCOUNT',
  PROVIDER_TRANSACTION: 'PROVIDER_TRANSACTION',
  STATEMENT_CURDEF: 'STATEMENT_CURDEF',
  USER_CONFIRMED: 'USER_CONFIRMED',
  TENANT_ATTESTED: 'TENANT_ATTESTED',
  ACCOUNT_INHERITED: 'ACCOUNT_INHERITED',
  LEGACY_DEFAULT: 'LEGACY_DEFAULT',
} as const;
export type CashCurrencyEvidenceSource =
  (typeof CashCurrencyEvidenceSource)[keyof typeof CashCurrencyEvidenceSource];

export const CashCurrencyEvidenceConfidence = {
  EXPLICIT: 'EXPLICIT',
  CORROBORATED: 'CORROBORATED',
  ATTESTED: 'ATTESTED',
  UNRESOLVED: 'UNRESOLVED',
  CONTRADICTORY: 'CONTRADICTORY',
} as const;
export type CashCurrencyEvidenceConfidence =
  (typeof CashCurrencyEvidenceConfidence)[keyof typeof CashCurrencyEvidenceConfidence];

export const FinancialConnectionStatus = {
  PENDING_AUTH: 'PENDING_AUTH',
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  ERROR: 'ERROR',
  SUSPENDED: 'SUSPENDED',
} as const;
export type FinancialConnectionStatus =
  (typeof FinancialConnectionStatus)[keyof typeof FinancialConnectionStatus];

export const StatementImportSourceType = {
  OFX: 'OFX',
  CSV: 'CSV',
  PDF: 'PDF',
  API: 'API',
  MANUAL: 'MANUAL',
} as const;
export type StatementImportSourceType =
  (typeof StatementImportSourceType)[keyof typeof StatementImportSourceType];

export const StatementImportStatus = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED',
} as const;
export type StatementImportStatus =
  (typeof StatementImportStatus)[keyof typeof StatementImportStatus];

export const BankTransactionDirection = {
  DEBIT: 'DEBIT',
  CREDIT: 'CREDIT',
} as const;
export type BankTransactionDirection =
  (typeof BankTransactionDirection)[keyof typeof BankTransactionDirection];

export const BankTransactionPaymentMethod = {
  PIX: 'PIX',
  TED: 'TED',
  DOC: 'DOC',
  BOLETO: 'BOLETO',
  CARD: 'CARD',
  DIRECT_DEBIT: 'DIRECT_DEBIT',
  DIRECT_CREDIT: 'DIRECT_CREDIT',
  UNKNOWN: 'UNKNOWN',
  SPEI: 'SPEI',
} as const;
export type BankTransactionPaymentMethod =
  (typeof BankTransactionPaymentMethod)[keyof typeof BankTransactionPaymentMethod];

export const ReconciliationStatus = {
  PENDING: 'PENDING',
  MATCHED: 'MATCHED',
  RECONCILED: 'RECONCILED',
  IGNORED: 'IGNORED',
} as const;
export type ReconciliationStatus = (typeof ReconciliationStatus)[keyof typeof ReconciliationStatus];

export const BankTransactionProviderLifecycleStatus = {
  POSTED: 'POSTED',
  PENDING: 'PENDING',
  EXPIRED: 'EXPIRED',
  RETRACTED: 'RETRACTED',
  UNKNOWN: 'UNKNOWN',
} as const;
export type BankTransactionProviderLifecycleStatus =
  (typeof BankTransactionProviderLifecycleStatus)[keyof typeof BankTransactionProviderLifecycleStatus];

export const ReconciliationGroupStatus = {
  DRAFT: 'DRAFT',
  SUGGESTED: 'SUGGESTED',
  CONFIRMED: 'CONFIRMED',
  RECONCILED: 'RECONCILED',
  VOIDED: 'VOIDED',
} as const;
export type ReconciliationGroupStatus =
  (typeof ReconciliationGroupStatus)[keyof typeof ReconciliationGroupStatus];

export const ReconciliationMethod = {
  HISTORICAL: 'HISTORICAL',
  RULES: 'RULES',
  AI: 'AI',
  MANUAL: 'MANUAL',
} as const;
export type ReconciliationMethod = (typeof ReconciliationMethod)[keyof typeof ReconciliationMethod];

export const ReconciliationGroupType = {
  BANK: 'BANK',
  CARD_STATEMENT: 'CARD_STATEMENT',
  CARD_ITEM: 'CARD_ITEM',
  MIXED: 'MIXED',
  INTERNAL: 'INTERNAL',
} as const;
export type ReconciliationGroupType =
  (typeof ReconciliationGroupType)[keyof typeof ReconciliationGroupType];

export const AllocationRole = {
  PRINCIPAL: 'PRINCIPAL',
  FEE: 'FEE',
  INTEREST: 'INTEREST',
  DISCOUNT: 'DISCOUNT',
  TAX: 'TAX',
  WITHHOLDING: 'WITHHOLDING',
  FX_DIFF: 'FX_DIFF',
  ROUNDING: 'ROUNDING',
  OTHER: 'OTHER',
} as const;
export type AllocationRole = (typeof AllocationRole)[keyof typeof AllocationRole];

export const AdjustmentType = {
  TARIFA: 'TARIFA',
  JUROS: 'JUROS',
  MULTA: 'MULTA',
  DESCONTO: 'DESCONTO',
  IOF: 'IOF',
  IRRF: 'IRRF',
  INSS: 'INSS',
  ISS: 'ISS',
  FX: 'FX',
  ARREDONDAMENTO: 'ARREDONDAMENTO',
  ADIANTAMENTO: 'ADIANTAMENTO',
  DEVOLUCAO_ADIANTAMENTO: 'DEVOLUCAO_ADIANTAMENTO',
  PIS: 'PIS',
  COFINS: 'COFINS',
  CSLL: 'CSLL',
  TARIFA_ADQUIRENCIA: 'TARIFA_ADQUIRENCIA',
  DESCONTO_INCONDICIONAL: 'DESCONTO_INCONDICIONAL',
} as const;
export type AdjustmentType = (typeof AdjustmentType)[keyof typeof AdjustmentType];

export const ReconciliationDecisionGroup = {
  CONFIRM: 'CONFIRM',
  RESOLVE_DIFF: 'RESOLVE_DIFF',
  REVIEW: 'REVIEW',
  IDENTIFY: 'IDENTIFY',
} as const;
export type ReconciliationDecisionGroup =
  (typeof ReconciliationDecisionGroup)[keyof typeof ReconciliationDecisionGroup];

export const ReconciliationPatternKind = {
  TRANSFER_PAIR: 'TRANSFER_PAIR',
  CNPJ_CLUSTER: 'CNPJ_CLUSTER',
  INSTALLMENT: 'INSTALLMENT',
  FEE_LIKE: 'FEE_LIKE',
} as const;
export type ReconciliationPatternKind =
  (typeof ReconciliationPatternKind)[keyof typeof ReconciliationPatternKind];

export const ReconciliationTargetKind = {
  AP_BILL: 'AP_BILL',
  AP_PAYMENT: 'AP_PAYMENT',
  AR_INVOICE: 'AR_INVOICE',
  BANK_TX: 'BANK_TX',
  AP_REIMBURSEMENT: 'AP_REIMBURSEMENT',
  CARD_STATEMENT: 'CARD_STATEMENT',
} as const;
export type ReconciliationTargetKind =
  (typeof ReconciliationTargetKind)[keyof typeof ReconciliationTargetKind];

export const ReconciliationAdjustmentSourceSemanticType = {
  OPERATIONAL_ROUNDING: 'OPERATIONAL_ROUNDING',
  PARTIAL_PAYMENT_REMAINDER: 'PARTIAL_PAYMENT_REMAINDER',
  OVERPAYMENT_EXCESS: 'OVERPAYMENT_EXCESS',
  BOLETO_FRANCESA: 'BOLETO_FRANCESA',
} as const;
export type ReconciliationAdjustmentSourceSemanticType =
  (typeof ReconciliationAdjustmentSourceSemanticType)[keyof typeof ReconciliationAdjustmentSourceSemanticType];

export const CardStatementStatus = {
  OPEN: 'OPEN',
  CLOSED: 'CLOSED',
  PAID: 'PAID',
  PARTIAL: 'PARTIAL',
  IGNORED: 'IGNORED',
} as const;
export type CardStatementStatus = (typeof CardStatementStatus)[keyof typeof CardStatementStatus];

export const CardFastTrackPostStatus = {
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  POSTED: 'POSTED',
  FAILED: 'FAILED',
} as const;
export type CardFastTrackPostStatus =
  (typeof CardFastTrackPostStatus)[keyof typeof CardFastTrackPostStatus];

export const CardMerchantRuleSource = {
  MANUAL: 'MANUAL',
  LEARNED: 'LEARNED',
} as const;
export type CardMerchantRuleSource =
  (typeof CardMerchantRuleSource)[keyof typeof CardMerchantRuleSource];

export const CardStatementItemAnnotationType = {
  OBSERVATION: 'OBSERVATION',
  FINANCE_QUESTION: 'FINANCE_QUESTION',
} as const;
export type CardStatementItemAnnotationType =
  (typeof CardStatementItemAnnotationType)[keyof typeof CardStatementItemAnnotationType];

export const CardStatementItemAnnotationStatus = {
  OPEN: 'OPEN',
  RESOLVED: 'RESOLVED',
} as const;
export type CardStatementItemAnnotationStatus =
  (typeof CardStatementItemAnnotationStatus)[keyof typeof CardStatementItemAnnotationStatus];

export const CardItemManagerReviewStatus = {
  PENDING: 'PENDING',
  ACKNOWLEDGED: 'ACKNOWLEDGED',
  IMPROPER: 'IMPROPER',
} as const;
export type CardItemManagerReviewStatus =
  (typeof CardItemManagerReviewStatus)[keyof typeof CardItemManagerReviewStatus];

export const StatementImportDocumentType = {
  BANK_STATEMENT: 'BANK_STATEMENT',
  CARD_STATEMENT: 'CARD_STATEMENT',
} as const;
export type StatementImportDocumentType =
  (typeof StatementImportDocumentType)[keyof typeof StatementImportDocumentType];

export const BankStatementStatus = {
  OPEN: 'OPEN',
  CLOSED: 'CLOSED',
  RECONCILED: 'RECONCILED',
  IGNORED: 'IGNORED',
} as const;
export type BankStatementStatus = (typeof BankStatementStatus)[keyof typeof BankStatementStatus];

export const FiscalDocumentType = {
  NFE: 'NFE',
  NFSE: 'NFSE',
  CTE: 'CTE',
  INVOICE: 'INVOICE',
  RECEIPT: 'RECEIPT',
  OTHER: 'OTHER',
} as const;
export type FiscalDocumentType = (typeof FiscalDocumentType)[keyof typeof FiscalDocumentType];

export const FiscalDocumentStatus = {
  FOUND: 'FOUND',
  VERIFIED: 'VERIFIED',
  CANCELLED: 'CANCELLED',
  UNKNOWN: 'UNKNOWN',
} as const;
export type FiscalDocumentStatus = (typeof FiscalDocumentStatus)[keyof typeof FiscalDocumentStatus];

export const FiscalDocumentSource = {
  API: 'API',
  OCR: 'OCR',
  EMAIL: 'EMAIL',
  MANUAL: 'MANUAL',
} as const;
export type FiscalDocumentSource = (typeof FiscalDocumentSource)[keyof typeof FiscalDocumentSource];

export const ReconciliationLinkSourceType = {
  BANK_TX: 'BANK_TX',
  CARD_ITEM: 'CARD_ITEM',
  CARD_STATEMENT: 'CARD_STATEMENT',
  AP_PAYMENT: 'AP_PAYMENT',
  FISCAL_DOC: 'FISCAL_DOC',
  ADJUSTMENT: 'ADJUSTMENT',
} as const;
export type ReconciliationLinkSourceType =
  (typeof ReconciliationLinkSourceType)[keyof typeof ReconciliationLinkSourceType];

export const ReconciliationLinkTargetType = {
  AP_BILL: 'AP_BILL',
  AP_PAYMENT: 'AP_PAYMENT',
  AR_INVOICE: 'AR_INVOICE',
  AR_DEBIT_NOTE: 'AR_DEBIT_NOTE',
  FISCAL_DOC: 'FISCAL_DOC',
  CARD_STATEMENT: 'CARD_STATEMENT',
  BANK_TX: 'BANK_TX',
  ADJUSTMENT: 'ADJUSTMENT',
} as const;
export type ReconciliationLinkTargetType =
  (typeof ReconciliationLinkTargetType)[keyof typeof ReconciliationLinkTargetType];

export const InternalOperationType = {
  YIELD: 'YIELD',
  RESCUE: 'RESCUE',
  APPLICATION: 'APPLICATION',
  OTHER: 'OTHER',
} as const;
export type InternalOperationType =
  (typeof InternalOperationType)[keyof typeof InternalOperationType];

export const InternalOperationPick = {
  YIELD: 'YIELD',
  APPLICATION: 'APPLICATION',
  RESCUE: 'RESCUE',
  WITHHOLDING_TAX: 'WITHHOLDING_TAX',
  WITHHOLDING_TAX_FINAL: 'WITHHOLDING_TAX_FINAL',
} as const;
export type InternalOperationPick =
  (typeof InternalOperationPick)[keyof typeof InternalOperationPick];

export const BankSweepDirection = {
  DEBIT: 'DEBIT',
  CREDIT: 'CREDIT',
  BOTH: 'BOTH',
} as const;
export type BankSweepDirection = (typeof BankSweepDirection)[keyof typeof BankSweepDirection];

export const BankSweepMarkState = {
  RULE: 'RULE',
  MANUAL: 'MANUAL',
  EXCEPTION: 'EXCEPTION',
} as const;
export type BankSweepMarkState = (typeof BankSweepMarkState)[keyof typeof BankSweepMarkState];

export const BankSweepEventType = {
  RULE_CREATED: 'RULE_CREATED',
  RULE_EDITED: 'RULE_EDITED',
  RULE_TURNED_OFF: 'RULE_TURNED_OFF',
  RULE_TURNED_ON: 'RULE_TURNED_ON',
  LINE_MARKED_MANUAL: 'LINE_MARKED_MANUAL',
  LINE_MARKED_BY_RULE: 'LINE_MARKED_BY_RULE',
  LINE_UNMARKED_BY_RULE: 'LINE_UNMARKED_BY_RULE',
  LINE_UNMARKED_MANUAL: 'LINE_UNMARKED_MANUAL',
} as const;
export type BankSweepEventType = (typeof BankSweepEventType)[keyof typeof BankSweepEventType];

export const BankTransactionType = {
  INTERNAL_TRANSFER: 'INTERNAL_TRANSFER',
  INTERNAL_OP: 'INTERNAL_OP',
  FEE_TAX: 'FEE_TAX',
  VENDOR_PAYMENT: 'VENDOR_PAYMENT',
  CUSTOMER_RECEIPT: 'CUSTOMER_RECEIPT',
  EMPLOYEE_PAYMENT: 'EMPLOYEE_PAYMENT',
  OTHER: 'OTHER',
} as const;
export type BankTransactionType = (typeof BankTransactionType)[keyof typeof BankTransactionType];

export const BankAccountProviderStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
} as const;
export type BankAccountProviderStatus =
  (typeof BankAccountProviderStatus)[keyof typeof BankAccountProviderStatus];

export const BankAccountCapability = {
  OPEN_FINANCE: 'OPEN_FINANCE',
  SEND_PAYMENTS: 'SEND_PAYMENTS',
  EMIT_PAYMENTS: 'EMIT_PAYMENTS',
} as const;
export type BankAccountCapability =
  (typeof BankAccountCapability)[keyof typeof BankAccountCapability];

export const BankBalanceSource = {
  OPEN_FINANCE: 'OPEN_FINANCE',
  RECONCILIATION: 'RECONCILIATION',
  STATEMENT_IMPORT: 'STATEMENT_IMPORT',
  MANUAL: 'MANUAL',
} as const;
export type BankBalanceSource = (typeof BankBalanceSource)[keyof typeof BankBalanceSource];

export const BankBalanceDayStatus = {
  DECLARED: 'DECLARED',
  SNAPSHOT_CONFIRMED: 'SNAPSHOT_CONFIRMED',
  SNAPSHOT_DIVERGENT: 'SNAPSHOT_DIVERGENT',
  PROJECTED_FORWARD: 'PROJECTED_FORWARD',
  PROJECTED_BACKWARD: 'PROJECTED_BACKWARD',
  PROVISIONAL: 'PROVISIONAL',
  ANCHOR_CONFLICT: 'ANCHOR_CONFLICT',
  CALCULATION_FAILED: 'CALCULATION_FAILED',
} as const;
export type BankBalanceDayStatus = (typeof BankBalanceDayStatus)[keyof typeof BankBalanceDayStatus];

export const BankBalanceCalculationDirection = {
  FORWARD: 'FORWARD',
  BACKWARD: 'BACKWARD',
  ANCHORED: 'ANCHORED',
} as const;
export type BankBalanceCalculationDirection =
  (typeof BankBalanceCalculationDirection)[keyof typeof BankBalanceCalculationDirection];

export const BankBalanceCalculationTrigger = {
  PROVIDER_SYNC: 'PROVIDER_SYNC',
  TRANSACTION_MUTATION: 'TRANSACTION_MUTATION',
  SNAPSHOT_CREATED: 'SNAPSHOT_CREATED',
  MANUAL_RECALCULATION: 'MANUAL_RECALCULATION',
  FULL_RESYNC: 'FULL_RESYNC',
  POLICY_CHANGE: 'POLICY_CHANGE',
  BACKFILL: 'BACKFILL',
} as const;
export type BankBalanceCalculationTrigger =
  (typeof BankBalanceCalculationTrigger)[keyof typeof BankBalanceCalculationTrigger];

export const BankBalanceCalculationRunStatus = {
  QUEUED: 'QUEUED',
  RUNNING: 'RUNNING',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
  SUPERSEDED: 'SUPERSEDED',
} as const;
export type BankBalanceCalculationRunStatus =
  (typeof BankBalanceCalculationRunStatus)[keyof typeof BankBalanceCalculationRunStatus];

export const BankBalanceSegmentStatus = {
  CONFIRMED: 'CONFIRMED',
  DIVERGENT: 'DIVERGENT',
  OPEN_BACKWARD: 'OPEN_BACKWARD',
  OPEN_FORWARD: 'OPEN_FORWARD',
  PROVISIONAL: 'PROVISIONAL',
  ANCHOR_CONFLICT: 'ANCHOR_CONFLICT',
} as const;
export type BankBalanceSegmentStatus =
  (typeof BankBalanceSegmentStatus)[keyof typeof BankBalanceSegmentStatus];

export const CardRefundLinkKind = {
  MATCHED: 'MATCHED',
  PAIRED: 'PAIRED',
  UNMATCHED: 'UNMATCHED',
} as const;
export type CardRefundLinkKind = (typeof CardRefundLinkKind)[keyof typeof CardRefundLinkKind];

export const CardRefundLinkStatus = {
  ACTIVE: 'ACTIVE',
  REVERSED: 'REVERSED',
} as const;
export type CardRefundLinkStatus = (typeof CardRefundLinkStatus)[keyof typeof CardRefundLinkStatus];

export const BalancePartyType = {
  VENDOR: 'VENDOR',
  CLIENT: 'CLIENT',
  ACQUIRER: 'ACQUIRER',
} as const;
export type BalancePartyType = (typeof BalancePartyType)[keyof typeof BalancePartyType];

export const PartyBalanceEntryType = {
  CREDIT: 'CREDIT',
  DEBIT: 'DEBIT',
} as const;
export type PartyBalanceEntryType =
  (typeof PartyBalanceEntryType)[keyof typeof PartyBalanceEntryType];

export const PartyBalanceSourceType = {
  RECONCILIATION: 'RECONCILIATION',
  BILL_PROVISION: 'BILL_PROVISION',
  MANUAL_ADJUSTMENT: 'MANUAL_ADJUSTMENT',
  REVERSAL: 'REVERSAL',
  SETTLEMENT_DEPOSIT: 'SETTLEMENT_DEPOSIT',
  SETTLEMENT_PAYOUT: 'SETTLEMENT_PAYOUT',
  RAIL_SETTLEMENT_EXPECTED: 'RAIL_SETTLEMENT_EXPECTED',
  RAIL_SETTLEMENT_RECEIVED: 'RAIL_SETTLEMENT_RECEIVED',
} as const;
export type PartyBalanceSourceType =
  (typeof PartyBalanceSourceType)[keyof typeof PartyBalanceSourceType];

export const ReconV2WriteIdempotencyStatus = {
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
} as const;
export type ReconV2WriteIdempotencyStatus =
  (typeof ReconV2WriteIdempotencyStatus)[keyof typeof ReconV2WriteIdempotencyStatus];

export const PartyType = {
  PERSON: 'PERSON',
  ORGANIZATION: 'ORGANIZATION',
} as const;
export type PartyType = (typeof PartyType)[keyof typeof PartyType];

export const PartyRoleType = {
  VENDOR: 'VENDOR',
  CUSTOMER: 'CUSTOMER',
  EMPLOYEE: 'EMPLOYEE',
} as const;
export type PartyRoleType = (typeof PartyRoleType)[keyof typeof PartyRoleType];

export const PaymentInstructionKind = {
  PIX_KEY: 'PIX_KEY',
  PIX_DYNAMIC_QR: 'PIX_DYNAMIC_QR',
  BANK_TRANSFER: 'BANK_TRANSFER',
  BILLET: 'BILLET',
  UTILITY_BILLET: 'UTILITY_BILLET',
  TAX_BARCODE: 'TAX_BARCODE',
  DARF: 'DARF',
  GPS: 'GPS',
  FGTS: 'FGTS',
  GARE: 'GARE',
  IPVA: 'IPVA',
  DPVAT: 'DPVAT',
  PAYCHECK: 'PAYCHECK',
  ACH: 'ACH',
} as const;
export type PaymentInstructionKind =
  (typeof PaymentInstructionKind)[keyof typeof PaymentInstructionKind];

export const PaymentCapabilityStatus = {
  AWAITING_BANK: 'AWAITING_BANK',
  PILOT: 'PILOT',
  ACTIVE: 'ACTIVE',
  REFUSED: 'REFUSED',
  SUSPENDED: 'SUSPENDED',
} as const;
export type PaymentCapabilityStatus =
  (typeof PaymentCapabilityStatus)[keyof typeof PaymentCapabilityStatus];

export const PaymentChannelCapabilityStatus = {
  DECLARED: 'DECLARED',
  CONFIRMED: 'CONFIRMED',
  RETIRED: 'RETIRED',
} as const;
export type PaymentChannelCapabilityStatus =
  (typeof PaymentChannelCapabilityStatus)[keyof typeof PaymentChannelCapabilityStatus];

export const PaymentAttemptOutcome = {
  IN_FLIGHT: 'IN_FLIGHT',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  TRANSPORT_ERROR: 'TRANSPORT_ERROR',
  ABANDONED: 'ABANDONED',
} as const;
export type PaymentAttemptOutcome =
  (typeof PaymentAttemptOutcome)[keyof typeof PaymentAttemptOutcome];

export const PaymentRemittanceStatus = {
  CREATING: 'CREATING',
  PENDING_SEND: 'PENDING_SEND',
  PROCESSING: 'PROCESSING',
  PROCESSED: 'PROCESSED',
  SENT: 'SENT',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED',
  UNKNOWN: 'UNKNOWN',
} as const;
export type PaymentRemittanceStatus =
  (typeof PaymentRemittanceStatus)[keyof typeof PaymentRemittanceStatus];

export const PaymentHomologationStatus = {
  CREATED: 'CREATED',
  REMITTANCE_PROCESSING: 'REMITTANCE_PROCESSING',
  SENT: 'SENT',
  RETURN_RECEIVED: 'RETURN_RECEIVED',
  PASSED: 'PASSED',
  FAILED: 'FAILED',
  UNKNOWN: 'UNKNOWN',
  CANCELLED: 'CANCELLED',
  PASSED_NO_PROMOTION: 'PASSED_NO_PROMOTION',
} as const;
export type PaymentHomologationStatus =
  (typeof PaymentHomologationStatus)[keyof typeof PaymentHomologationStatus];

export const PaymentTransportProof = {
  NONE: 'NONE',
  OUTBOUND: 'OUTBOUND',
  ROUND_TRIP: 'ROUND_TRIP',
} as const;
export type PaymentTransportProof =
  (typeof PaymentTransportProof)[keyof typeof PaymentTransportProof];

export const PaymentProviderConnectionStatus = {
  PENDING: 'PENDING',
  ACTIVE: 'ACTIVE',
  LAPSED: 'LAPSED',
  REVOKED: 'REVOKED',
} as const;
export type PaymentProviderConnectionStatus =
  (typeof PaymentProviderConnectionStatus)[keyof typeof PaymentProviderConnectionStatus];

export const PaymentProviderConnectionKind = {
  OAUTH: 'OAUTH',
  CREDENTIALS: 'CREDENTIALS',
} as const;
export type PaymentProviderConnectionKind =
  (typeof PaymentProviderConnectionKind)[keyof typeof PaymentProviderConnectionKind];

export const BtgDdaProcessingStatus = {
  NEW: 'NEW',
  LINKED_TO_BILL: 'LINKED_TO_BILL',
  IGNORED: 'IGNORED',
} as const;
export type BtgDdaProcessingStatus =
  (typeof BtgDdaProcessingStatus)[keyof typeof BtgDdaProcessingStatus];

export const DdaSubscriptionVendorStatus = {
  UNKNOWN: 'UNKNOWN',
  ACTIVE: 'ACTIVE',
  AWAITING_BANK: 'AWAITING_BANK',
  MISSING_SCOPE: 'MISSING_SCOPE',
  REFUSED: 'REFUSED',
  UNAVAILABLE: 'UNAVAILABLE',
} as const;
export type DdaSubscriptionVendorStatus =
  (typeof DdaSubscriptionVendorStatus)[keyof typeof DdaSubscriptionVendorStatus];

export const PaymentProviderWebhookVerificationKind = {
  HMAC_SHA256_HEADER: 'HMAC_SHA256_HEADER',
  BEARER: 'BEARER',
} as const;
export type PaymentProviderWebhookVerificationKind =
  (typeof PaymentProviderWebhookVerificationKind)[keyof typeof PaymentProviderWebhookVerificationKind];

export const PaymentProviderWebhookSignatureEncoding = {
  HEX: 'HEX',
  BASE64: 'BASE64',
} as const;
export type PaymentProviderWebhookSignatureEncoding =
  (typeof PaymentProviderWebhookSignatureEncoding)[keyof typeof PaymentProviderWebhookSignatureEncoding];

export const PaymentProviderWebhookRegistrationStatus = {
  PENDING_HANDSHAKE: 'PENDING_HANDSHAKE',
  ACTIVE: 'ACTIVE',
  DISABLED: 'DISABLED',
} as const;
export type PaymentProviderWebhookRegistrationStatus =
  (typeof PaymentProviderWebhookRegistrationStatus)[keyof typeof PaymentProviderWebhookRegistrationStatus];

export const PaymentProviderInboundEventStatus = {
  RECEIVED: 'RECEIVED',
  QUEUED: 'QUEUED',
  PROCESSED: 'PROCESSED',
  FAILED: 'FAILED',
} as const;
export type PaymentProviderInboundEventStatus =
  (typeof PaymentProviderInboundEventStatus)[keyof typeof PaymentProviderInboundEventStatus];

export const PaymentProviderReturnStatus = {
  OPEN: 'OPEN',
  CONFIRMED: 'CONFIRMED',
  CONFIRMED_UNRESOLVED: 'CONFIRMED_UNRESOLVED',
} as const;
export type PaymentProviderReturnStatus =
  (typeof PaymentProviderReturnStatus)[keyof typeof PaymentProviderReturnStatus];

export const PipefyWebhookEventStatus = {
  RECEIVED: 'RECEIVED',
  PROCESSING: 'PROCESSING',
  PROCESSED: 'PROCESSED',
  DUPLICATE: 'DUPLICATE',
  IGNORED: 'IGNORED',
  FAILED: 'FAILED',
} as const;
export type PipefyWebhookEventStatus =
  (typeof PipefyWebhookEventStatus)[keyof typeof PipefyWebhookEventStatus];

export const PipefyWebhookCorrelationStatus = {
  PENDING: 'PENDING',
  RESOLVED: 'RESOLVED',
  NOT_FOUND: 'NOT_FOUND',
  AMBIGUOUS: 'AMBIGUOUS',
  FAILED: 'FAILED',
  SKIPPED: 'SKIPPED',
} as const;
export type PipefyWebhookCorrelationStatus =
  (typeof PipefyWebhookCorrelationStatus)[keyof typeof PipefyWebhookCorrelationStatus];

export const PipefyConfigScope = {
  TENANT: 'TENANT',
  ENTITY: 'ENTITY',
} as const;
export type PipefyConfigScope = (typeof PipefyConfigScope)[keyof typeof PipefyConfigScope];

export const PipefyConfigStatus = {
  CONFIGURING: 'CONFIGURING',
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  ERROR: 'ERROR',
} as const;
export type PipefyConfigStatus = (typeof PipefyConfigStatus)[keyof typeof PipefyConfigStatus];

export const PipefyConnectionStatus = {
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
} as const;
export type PipefyConnectionStatus =
  (typeof PipefyConnectionStatus)[keyof typeof PipefyConnectionStatus];

export const PipefySyncOperationStatus = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
  DEAD: 'DEAD',
  SKIPPED: 'SKIPPED',
} as const;
export type PipefySyncOperationStatus =
  (typeof PipefySyncOperationStatus)[keyof typeof PipefySyncOperationStatus];

export const PurchaseRequestStatus = {
  OPEN: 'OPEN',
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  APPROVED: 'APPROVED',
  CONVERTED: 'CONVERTED',
  REJECTED: 'REJECTED',
  CANCELLED: 'CANCELLED',
} as const;
export type PurchaseRequestStatus =
  (typeof PurchaseRequestStatus)[keyof typeof PurchaseRequestStatus];

export const PurchaseOrderStatus = {
  OPEN: 'OPEN',
  READY: 'READY',
  PARTIALLY_RECEIVED: 'PARTIALLY_RECEIVED',
  RECEIVED: 'RECEIVED',
  FULFILLED: 'FULFILLED',
  SETTLED: 'SETTLED',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
} as const;
export type PurchaseOrderStatus = (typeof PurchaseOrderStatus)[keyof typeof PurchaseOrderStatus];

export const PurchaseOrderType = {
  ONE_TIME: 'ONE_TIME',
  RECURRING: 'RECURRING',
  BLANKET: 'BLANKET',
} as const;
export type PurchaseOrderType = (typeof PurchaseOrderType)[keyof typeof PurchaseOrderType];

export const ProcurementThreeWayReceiptGate = {
  BEFORE_BILL: 'BEFORE_BILL',
  BEFORE_PO_CLOSE: 'BEFORE_PO_CLOSE',
} as const;
export type ProcurementThreeWayReceiptGate =
  (typeof ProcurementThreeWayReceiptGate)[keyof typeof ProcurementThreeWayReceiptGate];

export const PurchaseRequestType = {
  ONE_TIME: 'ONE_TIME',
  RECURRING: 'RECURRING',
} as const;
export type PurchaseRequestType = (typeof PurchaseRequestType)[keyof typeof PurchaseRequestType];

export const RevenueClass = {
  OPERATING: 'OPERATING',
  OPERATING_CUMULATIVE: 'OPERATING_CUMULATIVE',
  FINANCIAL: 'FINANCIAL',
  FINANCIAL_ZERO_RATED: 'FINANCIAL_ZERO_RATED',
  EQUITY_INTEREST: 'EQUITY_INTEREST',
  EXPORT: 'EXPORT',
  NOT_TAXED: 'NOT_TAXED',
} as const;
export type RevenueClass = (typeof RevenueClass)[keyof typeof RevenueClass];

export const RevenueTaxOutcome = {
  TAXED: 'TAXED',
  ZERO_RATED: 'ZERO_RATED',
  EXEMPT: 'EXEMPT',
  OUTSIDE_BASE: 'OUTSIDE_BASE',
} as const;
export type RevenueTaxOutcome = (typeof RevenueTaxOutcome)[keyof typeof RevenueTaxOutcome];

export const RevenueTaxRuleSource = {
  ENTITY_OVERRIDE: 'ENTITY_OVERRIDE',
  TENANT_OVERRIDE: 'TENANT_OVERRIDE',
  SYSTEM_DEFAULT: 'SYSTEM_DEFAULT',
} as const;
export type RevenueTaxRuleSource = (typeof RevenueTaxRuleSource)[keyof typeof RevenueTaxRuleSource];

export const RevenueTaxProvisionStatus = {
  POSTED: 'POSTED',
  NOT_APPLICABLE: 'NOT_APPLICABLE',
  PENDING: 'PENDING',
  REVERSED: 'REVERSED',
} as const;
export type RevenueTaxProvisionStatus =
  (typeof RevenueTaxProvisionStatus)[keyof typeof RevenueTaxProvisionStatus];

export const RevenueTaxSourceEventType = {
  AR_INVOICE: 'AR_INVOICE',
  AR_DEBIT_NOTE: 'AR_DEBIT_NOTE',
  CONTRACT_REVENUE_RECOGNITION: 'CONTRACT_REVENUE_RECOGNITION',
  GL_JOURNAL: 'GL_JOURNAL',
} as const;
export type RevenueTaxSourceEventType =
  (typeof RevenueTaxSourceEventType)[keyof typeof RevenueTaxSourceEventType];

export const RevenueTaxSourceDiscountEvidenceKind = {
  MANUAL_ENTRY_ATTACHMENT: 'MANUAL_ENTRY_ATTACHMENT',
} as const;
export type RevenueTaxSourceDiscountEvidenceKind =
  (typeof RevenueTaxSourceDiscountEvidenceKind)[keyof typeof RevenueTaxSourceDiscountEvidenceKind];

export const RevenueTaxProvisionMovementKind = {
  REVERSAL: 'REVERSAL',
  CASH_RELEASE: 'CASH_RELEASE',
  CASH_RELEASE_REVERSAL: 'CASH_RELEASE_REVERSAL',
} as const;
export type RevenueTaxProvisionMovementKind =
  (typeof RevenueTaxProvisionMovementKind)[keyof typeof RevenueTaxProvisionMovementKind];

export const RevenueTaxLegacyTransitionTreatment = {
  ORDINARY_LEGACY_PIS_COFINS: 'ORDINARY_LEGACY_PIS_COFINS',
  OPTIONAL_REAL_ESTATE_CBS: 'OPTIONAL_REAL_ESTATE_CBS',
  NOT_ELIGIBLE: 'NOT_ELIGIBLE',
} as const;
export type RevenueTaxLegacyTransitionTreatment =
  (typeof RevenueTaxLegacyTransitionTreatment)[keyof typeof RevenueTaxLegacyTransitionTreatment];

export const RevenueTaxExportEligibilityRoute = {
  DIRECT_GOODS: 'DIRECT_GOODS',
  SERVICE_FX_INGRESS: 'SERVICE_FX_INGRESS',
  SERVICE_FUNDS_RETAINED_ABROAD: 'SERVICE_FUNDS_RETAINED_ABROAD',
} as const;
export type RevenueTaxExportEligibilityRoute =
  (typeof RevenueTaxExportEligibilityRoute)[keyof typeof RevenueTaxExportEligibilityRoute];

export const RevenueTaxExportEvidenceDocumentRole = {
  CUSTOMS_EXPORT_OPERATION: 'CUSTOMS_EXPORT_OPERATION',
  SERVICE_FX_FULL_OPERATION: 'SERVICE_FX_FULL_OPERATION',
  SERVICE_FUNDS_ABROAD_FULL_OPERATION: 'SERVICE_FUNDS_ABROAD_FULL_OPERATION',
} as const;
export type RevenueTaxExportEvidenceDocumentRole =
  (typeof RevenueTaxExportEvidenceDocumentRole)[keyof typeof RevenueTaxExportEvidenceDocumentRole];

export const TaxAssessmentKind = {
  PIS_COFINS_MONTHLY: 'PIS_COFINS_MONTHLY',
  IRPJ_CSLL_PRESUMED_MONTHLY: 'IRPJ_CSLL_PRESUMED_MONTHLY',
  IRPJ_CSLL_PRESUMED_QUARTERLY: 'IRPJ_CSLL_PRESUMED_QUARTERLY',
  IRPJ_CSLL_ACTUAL_QUARTERLY: 'IRPJ_CSLL_ACTUAL_QUARTERLY',
  IRPJ_CSLL_ACTUAL_ANNUAL_ESTIMATE: 'IRPJ_CSLL_ACTUAL_ANNUAL_ESTIMATE',
} as const;
export type TaxAssessmentKind = (typeof TaxAssessmentKind)[keyof typeof TaxAssessmentKind];

export const TaxAssessmentStatus = {
  DRAFT: 'DRAFT',
  APPROVED: 'APPROVED',
  OUTDATED: 'OUTDATED',
} as const;
export type TaxAssessmentStatus = (typeof TaxAssessmentStatus)[keyof typeof TaxAssessmentStatus];

export const TaxAssessmentRevisionStatus = {
  DRAFT: 'DRAFT',
  APPROVED: 'APPROVED',
  SUPERSEDED: 'SUPERSEDED',
} as const;
export type TaxAssessmentRevisionStatus =
  (typeof TaxAssessmentRevisionStatus)[keyof typeof TaxAssessmentRevisionStatus];

export const TaxAssessmentTax = {
  PIS: 'PIS',
  COFINS: 'COFINS',
  IRPJ: 'IRPJ',
  CSLL: 'CSLL',
  ISS: 'ISS',
} as const;
export type TaxAssessmentTax = (typeof TaxAssessmentTax)[keyof typeof TaxAssessmentTax];

export const TaxAssessmentSourceType = {
  REVENUE_PROVISION: 'REVENUE_PROVISION',
  REVENUE_RELEASE: 'REVENUE_RELEASE',
  PURCHASE_CREDIT: 'PURCHASE_CREDIT',
  CUSTOMER_WITHHOLDING: 'CUSTOMER_WITHHOLDING',
  ADVANCE_ESTIMATE: 'ADVANCE_ESTIMATE',
  FISCAL_HISTORY: 'FISCAL_HISTORY',
  JOURNAL_LINE: 'JOURNAL_LINE',
  MANUAL_EVIDENCE: 'MANUAL_EVIDENCE',
} as const;
export type TaxAssessmentSourceType =
  (typeof TaxAssessmentSourceType)[keyof typeof TaxAssessmentSourceType];

export const TaxAssessmentPostingKind = {
  EXPENSE_TRUE_UP: 'EXPENSE_TRUE_UP',
  SETTLEMENT_OFFSET: 'SETTLEMENT_OFFSET',
  HEAD_OFFICE_TRANSFER: 'HEAD_OFFICE_TRANSFER',
  HEAD_OFFICE_RECOVERABLE_TRANSFER: 'HEAD_OFFICE_RECOVERABLE_TRANSFER',
  GUIDE_REGISTRATION: 'GUIDE_REGISTRATION',
  REVERSAL: 'REVERSAL',
  CORRECTION: 'CORRECTION',
  FIXED_ASSET_CREDIT_MATURATION: 'FIXED_ASSET_CREDIT_MATURATION',
} as const;
export type TaxAssessmentPostingKind =
  (typeof TaxAssessmentPostingKind)[keyof typeof TaxAssessmentPostingKind];

export const TaxEntitlementType = {
  PURCHASE_CREDIT: 'PURCHASE_CREDIT',
  CUSTOMER_WITHHOLDING: 'CUSTOMER_WITHHOLDING',
  SEGREGATED_RECOVERABLE: 'SEGREGATED_RECOVERABLE',
  LEGACY_CREDIT: 'LEGACY_CREDIT',
  ADVANCE_ESTIMATE: 'ADVANCE_ESTIMATE',
  ISS_PAID_RECOVERABLE: 'ISS_PAID_RECOVERABLE',
  PAID_TAX_RECOVERABLE: 'PAID_TAX_RECOVERABLE',
} as const;
export type TaxEntitlementType = (typeof TaxEntitlementType)[keyof typeof TaxEntitlementType];

export const TaxEntitlementMovementKind = {
  ALLOCATE: 'ALLOCATE',
  RELEASE: 'RELEASE',
  RECLASSIFY_SEGREGATED: 'RECLASSIFY_SEGREGATED',
  CONVERT_LEGACY: 'CONVERT_LEGACY',
  REVERSE_TRANSITION: 'REVERSE_TRANSITION',
} as const;
export type TaxEntitlementMovementKind =
  (typeof TaxEntitlementMovementKind)[keyof typeof TaxEntitlementMovementKind];

export const TaxEntitlementStatus = {
  ACTIVE: 'ACTIVE',
  EXHAUSTED: 'EXHAUSTED',
  RETIRED: 'RETIRED',
} as const;
export type TaxEntitlementStatus = (typeof TaxEntitlementStatus)[keyof typeof TaxEntitlementStatus];

export const TaxEntitlementAllocationReason = {
  PURCHASE_CREDIT_OFFSET: 'PURCHASE_CREDIT_OFFSET',
  WITHHOLDING_OFFSET: 'WITHHOLDING_OFFSET',
  WITHHOLDING_CROSS_REGIME_TRANSFER: 'WITHHOLDING_CROSS_REGIME_TRANSFER',
  ADVANCE_ESTIMATE_OFFSET: 'ADVANCE_ESTIMATE_OFFSET',
  CORRECTION: 'CORRECTION',
  REVERSAL: 'REVERSAL',
} as const;
export type TaxEntitlementAllocationReason =
  (typeof TaxEntitlementAllocationReason)[keyof typeof TaxEntitlementAllocationReason];

export const TaxAccrualOriginConsumptionReason = {
  PURCHASE_CREDIT_OFFSET: 'PURCHASE_CREDIT_OFFSET',
  WITHHOLDING_OFFSET: 'WITHHOLDING_OFFSET',
  NEGATIVE_ASSESSMENT_DELTA: 'NEGATIVE_ASSESSMENT_DELTA',
  HEAD_OFFICE_TRANSFER: 'HEAD_OFFICE_TRANSFER',
  ADVANCE_ESTIMATE_OFFSET: 'ADVANCE_ESTIMATE_OFFSET',
  REVERSAL_CORRECTION: 'REVERSAL_CORRECTION',
} as const;
export type TaxAccrualOriginConsumptionReason =
  (typeof TaxAccrualOriginConsumptionReason)[keyof typeof TaxAccrualOriginConsumptionReason];

export const TaxAccrualOriginConsumptionMovementKind = {
  CONSUME: 'CONSUME',
  RELEASE: 'RELEASE',
} as const;
export type TaxAccrualOriginConsumptionMovementKind =
  (typeof TaxAccrualOriginConsumptionMovementKind)[keyof typeof TaxAccrualOriginConsumptionMovementKind];

export const TaxAccrualOriginType = {
  HCM_PAYROLL_RUN: 'HCM_PAYROLL_RUN',
  AR_INVOICE: 'AR_INVOICE',
  STATUTORY_AUTO_PROVISION: 'STATUTORY_AUTO_PROVISION',
  AP_BILL_WITHHOLDING: 'AP_BILL_WITHHOLDING',
  AP_VENDOR_PAYMENT: 'AP_VENDOR_PAYMENT',
  AP_BILL_APPROVAL_LEGACY: 'AP_BILL_APPROVAL_LEGACY',
  TAX_LIABILITY_RAIL_MIGRATION: 'TAX_LIABILITY_RAIL_MIGRATION',
  AR_DEBIT_NOTE: 'AR_DEBIT_NOTE',
  CONTRACT_REVENUE_RECOGNITION: 'CONTRACT_REVENUE_RECOGNITION',
  GL_JOURNAL: 'GL_JOURNAL',
  TAX_ASSESSMENT_TRUE_UP: 'TAX_ASSESSMENT_TRUE_UP',
  HEAD_OFFICE_TRANSFER: 'HEAD_OFFICE_TRANSFER',
} as const;
export type TaxAccrualOriginType = (typeof TaxAccrualOriginType)[keyof typeof TaxAccrualOriginType];

export const TaxAccrualOriginStatus = {
  ACTIVE: 'ACTIVE',
  REVERSED: 'REVERSED',
} as const;
export type TaxAccrualOriginStatus =
  (typeof TaxAccrualOriginStatus)[keyof typeof TaxAccrualOriginStatus];

export const TaxLiabilityRailStage = {
  APURADO: 'APURADO',
  EM_GUIAS_A_PAGAR: 'EM_GUIAS_A_PAGAR',
} as const;
export type TaxLiabilityRailStage =
  (typeof TaxLiabilityRailStage)[keyof typeof TaxLiabilityRailStage];

export const TecnospeedPayerStatus = {
  PENDING: 'PENDING',
  ACTIVE: 'ACTIVE',
  ERROR: 'ERROR',
  SUSPENDED: 'SUSPENDED',
} as const;
export type TecnospeedPayerStatus =
  (typeof TecnospeedPayerStatus)[keyof typeof TecnospeedPayerStatus];

export const TecnospeedPaymentStatus = {
  CREATED: 'CREATED',
  PAID: 'PAID',
  SCHEDULED: 'SCHEDULED',
  CANCELLED: 'CANCELLED',
  REJECTED: 'REJECTED',
  REFUNDED: 'REFUNDED',
} as const;
export type TecnospeedPaymentStatus =
  (typeof TecnospeedPaymentStatus)[keyof typeof TecnospeedPaymentStatus];

export const TecnospeedVanStatus = {
  NOT_REQUESTED: 'NOT_REQUESTED',
  PENDING: 'PENDING',
  TESTING: 'TESTING',
  HOMOLOGATED: 'HOMOLOGATED',
  DEGRADED: 'DEGRADED',
  SUSPENDED: 'SUSPENDED',
} as const;
export type TecnospeedVanStatus = (typeof TecnospeedVanStatus)[keyof typeof TecnospeedVanStatus];

export const TecnospeedDdaBoletoStatus = {
  REGISTERED: 'REGISTERED',
  PAID: 'PAID',
  CANCELLED: 'CANCELLED',
  PROTESTED: 'PROTESTED',
  REJECTED: 'REJECTED',
} as const;
export type TecnospeedDdaBoletoStatus =
  (typeof TecnospeedDdaBoletoStatus)[keyof typeof TecnospeedDdaBoletoStatus];

export const TecnospeedOnboardingStatus = {
  NOT_STARTED: 'NOT_STARTED',
  LETTER_REQUESTED: 'LETTER_REQUESTED',
  LETTER_DOWNLOADED: 'LETTER_DOWNLOADED',
  LETTER_SENT_TO_MANAGER: 'LETTER_SENT_TO_MANAGER',
  BANK_APPROVED: 'BANK_APPROVED',
  ACTIVE: 'ACTIVE',
  ERROR: 'ERROR',
} as const;
export type TecnospeedOnboardingStatus =
  (typeof TecnospeedOnboardingStatus)[keyof typeof TecnospeedOnboardingStatus];

export const TecnospeedDdaProcessingStatus = {
  NEW: 'NEW',
  BILL_CREATED: 'BILL_CREATED',
  LINKED_TO_BILL: 'LINKED_TO_BILL',
  IGNORED: 'IGNORED',
} as const;
export type TecnospeedDdaProcessingStatus =
  (typeof TecnospeedDdaProcessingStatus)[keyof typeof TecnospeedDdaProcessingStatus];

export const TecnospeedWebhookEventClass = {
  PAYMENT: 'PAYMENT',
  DDA: 'DDA',
} as const;
export type TecnospeedWebhookEventClass =
  (typeof TecnospeedWebhookEventClass)[keyof typeof TecnospeedWebhookEventClass];

export const TecnospeedWebhookRegistrationStatus = {
  ACTIVE: 'ACTIVE',
  DISABLED: 'DISABLED',
  ERROR: 'ERROR',
} as const;
export type TecnospeedWebhookRegistrationStatus =
  (typeof TecnospeedWebhookRegistrationStatus)[keyof typeof TecnospeedWebhookRegistrationStatus];

export const AveniaConnectionStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  ERROR: 'ERROR',
} as const;
export type AveniaConnectionStatus =
  (typeof AveniaConnectionStatus)[keyof typeof AveniaConnectionStatus];

export const BrexConnectionStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  ERROR: 'ERROR',
} as const;
export type BrexConnectionStatus = (typeof BrexConnectionStatus)[keyof typeof BrexConnectionStatus];

export const ContaSimplesEntityConfigStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  ERROR: 'ERROR',
} as const;
export type ContaSimplesEntityConfigStatus =
  (typeof ContaSimplesEntityConfigStatus)[keyof typeof ContaSimplesEntityConfigStatus];

export const OnflyEntityConfigStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  ERROR: 'ERROR',
} as const;
export type OnflyEntityConfigStatus =
  (typeof OnflyEntityConfigStatus)[keyof typeof OnflyEntityConfigStatus];

export const OnflyPostStatus = {
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  POSTED: 'POSTED',
  FAILED: 'FAILED',
} as const;
export type OnflyPostStatus = (typeof OnflyPostStatus)[keyof typeof OnflyPostStatus];

export const OnflyRefundStatus = {
  NONE: 'NONE',
  REVIEW_PENDING: 'REVIEW_PENDING',
  PARTIALLY_REFUNDED: 'PARTIALLY_REFUNDED',
  REFUNDED: 'REFUNDED',
  FAILED: 'FAILED',
} as const;
export type OnflyRefundStatus = (typeof OnflyRefundStatus)[keyof typeof OnflyRefundStatus];

export const OnflyTravelAccountKey = {
  FLIGHT: 'FLIGHT',
  HOTEL: 'HOTEL',
  RENTAL_CAR: 'RENTAL_CAR',
  BUS: 'BUS',
  CHANGE_FEE: 'CHANGE_FEE',
} as const;
export type OnflyTravelAccountKey =
  (typeof OnflyTravelAccountKey)[keyof typeof OnflyTravelAccountKey];

export const WorkflowDependencyType = {
  CONDITION: 'CONDITION',
  ACTION: 'ACTION',
} as const;
export type WorkflowDependencyType =
  (typeof WorkflowDependencyType)[keyof typeof WorkflowDependencyType];

export const WorkflowConditionLineQuantifier = {
  ANY: 'ANY',
  ALL: 'ALL',
} as const;
export type WorkflowConditionLineQuantifier =
  (typeof WorkflowConditionLineQuantifier)[keyof typeof WorkflowConditionLineQuantifier];

export const WorkflowRunOutcome = {
  RUNNING: 'RUNNING',
  MATCHED: 'MATCHED',
  DONE: 'DONE',
  SKIPPED: 'SKIPPED',
  REFUSED: 'REFUSED',
  FAILED: 'FAILED',
} as const;
export type WorkflowRunOutcome = (typeof WorkflowRunOutcome)[keyof typeof WorkflowRunOutcome];

export const WorkflowActorType = {
  WORKFLOW: 'WORKFLOW',
  USER: 'USER',
  SYSTEM: 'SYSTEM',
} as const;
export type WorkflowActorType = (typeof WorkflowActorType)[keyof typeof WorkflowActorType];

export const WorkflowOriginKind = {
  DESCRIPTION: 'DESCRIPTION',
  APPROVAL_OFFER: 'APPROVAL_OFFER',
} as const;
export type WorkflowOriginKind = (typeof WorkflowOriginKind)[keyof typeof WorkflowOriginKind];
